export const SERVICES_CONTENT = {
  extreme: {
    fr: {
      seo: {
        title: "Nettoyage après décès, Diogène et logements insalubres -Lyon & Rhône-Alpes | BIONET SOLUTIONS",
        description: "Expert nettoyage extrême : après décès, découverte tardive, syndrome de Diogène, logement insalubre. Discret, certifié, 24h/24 -Lyon, Rhône-Alpes. Devis gratuit."
      },
      hero: {
        h1: "Expert en nettoyage après décès, syndrome de Diogène et logements insalubres -Lyon & Auvergne-Rhône-Alpes",
        subtitle: "Intervention discrète, certifiée biologique et respectueuse. Disponible 24h/24, 7j/7 à Lyon et en Rhône-Alpes.",
        badge: "Discrétion garantie · Certifié décontamination · 24h/24",
        image: "https://images.unsplash.com/photo-1581578731548-c64695cc6952?crop=entropy&cs=srgb&fm=jpg&q=85&w=900"
      },
      intro: {
        title: "Pourquoi faire appel à un professionnel pour le nettoyage extrême ?",
        body: [
          "Le nettoyage après décès, après une découverte tardive de corps ou suite à un syndrome de Diogène ne peut pas être confié à n'importe qui. Ces situations exposent à des risques biologiques sérieux : fluides corporels, agents pathogènes, contaminations bactériennes ou fongiques. Sans les équipements de protection et les produits biocides homologués, le risque de contamination pour les occupants suivants est réel et peut avoir des conséquences graves sur la santé.",
          "BIONET SOLUTIONS intervient dans ces situations avec un protocole rigoureux, des équipes formées aux risques biologiques de niveau 2 et 3, et un matériel professionnel certifié. Nous travaillons en tenue de protection intégrale, confinons la zone concernée et procédons à une décontamination en profondeur avant tout nettoyage visible. Chaque surface poreuse, joint et sous-couche est traitée selon les protocoles en vigueur.",
          "Le syndrome de Diogène représente un autre type d'intervention extrême : accumulation pathologique d'objets, présence de nuisibles, odeurs persistantes, mycoses sur les murs, dégradations structurelles. Ces logements nécessitent une approche méthodique -débarras sélectif, désinfection complète, traitement des odeurs et remise en état -que nos équipes maîtrisent depuis des années.",
          "Nous intervenons à Lyon et en Rhône-Alpes avec une base principale en Auvergne-Rhône-Alpes (Neyron, près de Lyon). Grâce à notre réseau de techniciens déployés sur toute la région, nous garantissons une intervention en 24 à 48h maximum, même pour les situations les plus urgentes. Les cas critiques dans le périmètre lyonnais peuvent bénéficier d'une intervention en moins de 4 heures.",
          "Chaque dossier est traité avec une confidentialité absolue : véhicules banalisés sans marquage visible, tenues sobres dans les parties communes, et aucune communication sur la nature de l'intervention. Nous savons que derrière chaque dossier, il y a des familles en deuil, des proches sous le choc ou des gestionnaires qui doivent agir rapidement et avec discernement."
        ]
      },
      whyUs: [
        {
          icon: "EyeOff",
          title: "Discrétion absolue garantie",
          desc: "Véhicules banalisés, tenues sobres à l'extérieur, aucune signalétique. Vos voisins et locataires ne sauront rien. Nous signons un accord de confidentialité sur demande."
        },
        {
          icon: "ShieldCheck",
          title: "Certification biologique niveau 3",
          desc: "Techniciens formés aux risques biologiques, biocides homologués, EPI de niveau 3. Certificat de décontamination fourni en fin d'intervention pour assureurs et notaires."
        },
        {
          icon: "Clock",
          title: "Disponible 24h/24, week-ends et fériés",
          desc: "La découverte d'un logement extrême ne prévient pas. Nous répondons dans l'heure et intervenons en moins de 4h dans le périmètre lyonnais pour les urgences absolues."
        },
        {
          icon: "Heart",
          title: "Accompagnement humain des familles",
          desc: "Notre équipe est formée à communiquer avec tact et bienveillance. Nous respectons les objets personnels, préservons les souvenirs identifiables et restituons le logement avec dignité."
        }
      ],
      process: [
        {
          step: 1,
          title: "Prise de contact et évaluation",
          desc: "Appel ou formulaire en ligne. Nous vous recontactons dans l'heure, évaluons la situation par téléphone et vous donnons une première estimation de coût et de délai.",
          tag: "< 1h"
        },
        {
          step: 2,
          title: "Sécurisation et confinement",
          desc: "À l'arrivée, nos techniciens sécurisent le périmètre, confinent la zone impactée et s'équipent des EPI adaptés au niveau de risque biologique identifié.",
          tag: "J+0 -arrivée"
        },
        {
          step: 3,
          title: "Décontamination biologique",
          desc: "Élimination de tous les agents biologiques avec biocides professionnels homologués. Traitement en profondeur des surfaces poreuses, joints et sous-couches.",
          tag: "J+0 -J+2"
        },
        {
          step: 4,
          title: "Nettoyage et remise en état",
          desc: "Nettoyage intégral : sols, murs, mobilier conservé. Évacuation des déchets biologiques classés DASRI. Traitement des odeurs par neutralisants à action profonde.",
          tag: "J+1 -J+3"
        },
        {
          step: 5,
          title: "Restitution et certification",
          desc: "Remise du logement propre, sain et neutre en odeurs. Certificat de décontamination fourni sur demande pour assureurs, notaires ou bailleurs sociaux.",
          tag: "Fin d'intervention"
        }
      ],
      clientExamples: [
        {
          avatar: "T",
          from: "M. Thierry A. -Notaire, Lyon 2e",
          date: "Janvier 2025",
          subject: "Succession -appartement Diogène",
          message: "Bonjour, je suis notaire et gère la succession d'une personne décédée dont l'appartement est dans un état de dégradation extrême. L'accumulation d'objets est massive, il y a des traces de nuisibles et une odeur insupportable. Nous devons remettre le logement en état pour la vente. Pouvez-vous intervenir et fournir un devis détaillé pour le débarras et la décontamination complète ?"
        },
        {
          avatar: "S",
          from: "Mme Sophie L. -Particulière, Bourg-en-Bresse",
          date: "Mars 2025",
          subject: "Nettoyage après décès de ma mère",
          message: "Bonjour, ma mère est décédée dans son appartement et n'a pas été découverte pendant plusieurs semaines. Le logement est dans un état que je ne suis pas capable de gérer seule. J'ai besoin d'une intervention professionnelle et discrète. Ma famille souhaite que les voisins ne soient pas au courant de la situation."
        },
        {
          avatar: "P",
          from: "M. Pierre-Yves M. -Gestionnaire HLM, Grenoble",
          date: "Novembre 2024",
          subject: "Logement insalubre après départ locataire",
          message: "Bonjour, suite au départ d'un locataire, l'appartement est dans un état insalubre grave : déchets accumulés, traces de nuisibles, moisissures importantes. Nous devons le remettre en état pour une nouvelle attribution rapide. Quels sont vos délais et tarifs pour ce type d'intervention ?"
        },
        {
          avatar: "C",
          from: "Cabinet Clairvaux -Syndic de copropriété, Villeurbanne",
          date: "Septembre 2024",
          subject: "Syndrome de Diogène -copropriétaire",
          message: "Nous gérons une copropriété où un propriétaire occupant présente un syndrome de Diogène avancé. L'odeur affecte les parties communes et nous avons reçu des plaintes. L'occupant a accepté une intervention. Nous cherchons une société qui intervienne avec discrétion et dans le respect total de la personne concernée."
        }
      ],
      faq: [
        {
          q: "Comment se déroule concrètement un nettoyage après décès ?",
          a: "Nous commençons par sécuriser et confiner la zone pour éviter toute propagation de contamination. Nos techniciens, équipés d'EPI de niveau 3, procèdent d'abord à la décontamination biologique (fluides, bactéries, agents pathogènes) avec des biocides homologués, puis au traitement des odeurs par des neutralisants professionnels à action profonde. Le nettoyage visible vient en dernier. Selon l'état du logement, l'intervention dure de quelques heures à plusieurs jours."
        },
        {
          q: "Êtes-vous disponibles la nuit et les jours fériés ?",
          a: "Oui, sans exception. Notre ligne d'urgence est active 24h/24, 7j/7, y compris les nuits, week-ends et jours fériés. Nous nous engageons à vous recontacter dans l'heure suivant votre appel et à intervenir en moins de 4h pour les urgences dans le périmètre Lyon–Rhône-Alpes."
        },
        {
          q: "Les voisins sauront-ils ce qui s'est passé ?",
          a: "La discrétion est notre priorité absolue. Nous intervenons avec des véhicules banalisés (sans logo ni signalétique), en tenues sobres dans les parties communes, et sans aucune communication sur la nature de l'intervention. Sur demande, nous pouvons intervenir à des horaires décalés pour minimiser les croisements avec d'autres résidents."
        },
        {
          q: "Combien de temps dure l'intervention ?",
          a: "Cela dépend de la superficie du logement, de la durée d'exposition et de la nature des contaminations. Un nettoyage après décès récent dans un studio peut être réalisé en une journée. Une intervention dans un appartement Diogène de 80 m² peut nécessiter 3 à 5 jours. Nous vous donnons une estimation précise lors de l'évaluation téléphonique initiale."
        },
        {
          q: "Peut-on récupérer des objets ou documents personnels avant l'intervention ?",
          a: "Oui, sous réserve que la zone concernée ne présente pas de risque biologique immédiat. Lors de notre évaluation sur site, nous identifions les zones sécurisées où des objets peuvent être récupérés. Pour les zones contaminées, nous procédons à un inventaire avant toute évacuation et préservons tout objet d'importance sentimentale ou administrative identifiable."
        },
        {
          q: "Quels risques si le nettoyage n'est pas fait par un professionnel ?",
          a: "Les risques biologiques liés aux fluides corporels (hépatite B et C, bactéries diverses) restent actifs plusieurs semaines après le décès. Un nettoyage non professionnel laisse souvent des contaminations invisibles sur les surfaces poreuses et sous-couches. Les odeurs mal traitées reviennent de façon persistante. En cas de vente ou relocation, ces problèmes peuvent aussi engager la responsabilité civile du propriétaire."
        },
        {
          q: "Fournissez-vous un certificat de décontamination ?",
          a: "Oui. Un rapport d'intervention et un certificat de décontamination peuvent être fournis en fin de mission. Ces documents sont reconnus par les compagnies d'assurance, les études notariales et les bailleurs sociaux. Ils attestent que le logement a été traité selon les protocoles biologiques en vigueur et qu'il est sain pour une réoccupation."
        },
        {
          q: "Comment obtenir un devis pour un nettoyage extrême ?",
          a: "Appelez notre ligne au 06 49 50 28 01 (disponible 24h/24) ou utilisez notre formulaire de devis en ligne. Pour ce type d'intervention, nous recommandons l'appel téléphonique qui permet une évaluation plus rapide et précise. Vous recevrez une estimation dans l'heure et un devis formalisé sous 24h."
        }
      ],
      relatedSlugs: ["sinistre", "debarras", "batiments", "particuliers"]
    },
    en: {
      seo: {
        title: "After-death cleaning, Diogenes syndrome & unsanitary housing -Lyon & Rhône-Alpes | BIONET SOLUTIONS",
        description: "Specialist extreme cleaning: after death, Diogenes syndrome, unsanitary housing. Discreet, certified, 24/7 -Lyon, Rhône-Alpes. Free quote."
      },
      hero: {
        h1: "Expert in after-death cleaning, Diogenes syndrome and unsanitary housing -Lyon & Auvergne-Rhône-Alpes",
        subtitle: "Discreet, biologically certified and respectful intervention. Available 24/7 in Lyon & the Rhône-Alpes region.",
        badge: "Guaranteed discretion · Decontamination certified · 24/7",
        image: "https://images.unsplash.com/photo-1581578731548-c64695cc6952?crop=entropy&cs=srgb&fm=jpg&q=85&w=900"
      },
      intro: {
        title: "Why call a professional for extreme cleaning?",
        body: [
          "After-death cleaning, late-discovery cleaning or Diogenes syndrome cleaning cannot be entrusted to just anyone. These situations involve serious biological hazards: bodily fluids, pathogens, bacterial or fungal contamination. Without appropriate protective equipment and approved biocidal products, the risk of contamination for subsequent occupants is real and can have serious health consequences.",
          "BIONET SOLUTIONS intervenes in these situations with a rigorous protocol, teams trained in biological hazards at levels 2 and 3, and certified professional equipment. We work in full protective gear, contain the affected area and carry out deep decontamination before any visible cleaning. Every porous surface, joint and underlay is treated according to current protocols.",
          "Diogenes syndrome represents another type of extreme intervention: pathological accumulation of objects, pest infestations, persistent odours, mould on walls, structural damage. These properties require a methodical approach -selective clearance, full disinfection, odour treatment and restoration -which our teams have mastered.",
          "We operate in Lyon & the Rhône-Alpes region with our main base in Auvergne-Rhône-Alpes (Neyron, near Lyon). Through our network of certified technicians deployed across the region, we guarantee intervention within 24 to 48 hours maximum. Critical cases in the Lyon area can benefit from intervention in under 4 hours.",
          "Every case is handled with absolute confidentiality: unmarked vehicles, plain clothing in common areas, and no communication about the nature of the intervention. We understand that behind every case there are grieving families, people in shock, or managers who need to act quickly and with care."
        ]
      },
      whyUs: [
        {
          icon: "EyeOff",
          title: "Absolute discretion guaranteed",
          desc: "Unmarked vehicles, plain clothing in common areas, no signage. Your neighbours and tenants will know nothing. We sign a confidentiality agreement on request."
        },
        {
          icon: "ShieldCheck",
          title: "Level 3 biological certification",
          desc: "Technicians trained in biological hazards, approved biocides, level 3 PPE. Decontamination certificate provided at end of intervention for insurers and notaries."
        },
        {
          icon: "Clock",
          title: "Available 24/7, weekends and holidays",
          desc: "Discovery of extreme premises is unpredictable. We respond within the hour and can be on site in under 4 hours in the Lyon area for absolute emergencies."
        },
        {
          icon: "Heart",
          title: "Human support for families",
          desc: "Our team is trained to communicate with tact and compassion. We respect personal belongings, preserve identifiable memories and restore the property with full dignity."
        }
      ],
      process: [
        {
          step: 1,
          title: "Contact and assessment",
          desc: "Call or online form. We call back within the hour, assess the situation by phone and provide a first cost and timeline estimate.",
          tag: "< 1h"
        },
        {
          step: 2,
          title: "Securing and containment",
          desc: "On arrival, our technicians secure the perimeter, contain the affected area and put on PPE appropriate to the identified biological hazard level.",
          tag: "Day 0 -arrival"
        },
        {
          step: 3,
          title: "Biological decontamination",
          desc: "Elimination of all biological agents with approved professional biocides. Deep treatment of porous surfaces, joints and underlays.",
          tag: "Day 0 -Day 2"
        },
        {
          step: 4,
          title: "Cleaning and restoration",
          desc: "Full visible cleaning: floors, walls, retained furniture. DASRI biological waste removal. Deep-action odour neutralisers applied throughout.",
          tag: "Day 1 -Day 3"
        },
        {
          step: 5,
          title: "Handover and certification",
          desc: "Property returned clean, healthy and odour-free. Decontamination certificate available on request for insurers, notaries or social landlords.",
          tag: "End of intervention"
        }
      ],
      clientExamples: [
        {
          avatar: "T",
          from: "Mr Thierry A. -Notary, Lyon 2nd",
          date: "January 2025",
          subject: "Estate -Diogenes syndrome apartment",
          message: "Hello, I am a notary managing the estate of a deceased person whose apartment is in a state of extreme deterioration. The accumulation of objects is massive, there are signs of pests and an unbearable smell. We need to restore the property for sale. Could you intervene and provide a detailed quote for clearance and full decontamination?"
        },
        {
          avatar: "S",
          from: "Mrs Sophie L. -Individual, Bourg-en-Bresse",
          date: "March 2025",
          subject: "Cleaning after my mother's passing",
          message: "Hello, my mother passed away in her apartment and was not discovered for several weeks. The property is in a state I cannot manage on my own. I need a professional and discreet intervention. My family does not want the neighbours to know about the situation."
        },
        {
          avatar: "P",
          from: "Mr Pierre-Yves M. -Housing manager, Grenoble",
          date: "November 2024",
          subject: "Unsanitary flat after tenant departure",
          message: "Hello, following a tenant's departure, the apartment is in a seriously unsanitary state: large amounts of waste, signs of pests, significant mould. We need it restored quickly for a new allocation. What are your timelines and rates for this type of intervention?"
        },
        {
          avatar: "C",
          from: "Cabinet Clairvaux -Property management, Villeurbanne",
          date: "September 2024",
          subject: "Diogenes syndrome -owner-occupier",
          message: "We manage a building where an owner-occupier has advanced Diogenes syndrome. The smell is affecting the common areas and we have received complaints. The occupant has agreed to an intervention. We are looking for a company that can handle the situation with discretion and full respect for the person involved."
        }
      ],
      faq: [
        {
          q: "What does after-death cleaning involve in practice?",
          a: "We start by securing and containing the area to prevent any spread of contamination. Our technicians, equipped with level 3 PPE, first carry out biological decontamination (fluids, bacteria, pathogens) using approved biocides, then odour treatment with deep-action professional neutralisers. Visible cleaning comes last. Depending on the condition of the property, the intervention takes from a few hours to several days."
        },
        {
          q: "Are you available at night and on public holidays?",
          a: "Yes, without exception. Our emergency line is active 24/7, including nights, weekends and public holidays. We commit to calling you back within the hour and intervening in under 4 hours for emergencies in the Lyon–Rhône-Alpes area."
        },
        {
          q: "Will neighbours know what happened?",
          a: "Discretion is our absolute priority. We use unmarked vehicles (no logo or signage), plain clothing in common areas, and never communicate about the nature of our interventions. On request, we can work at offset hours to minimise encounters with other residents."
        },
        {
          q: "How long does the intervention take?",
          a: "It depends on the size of the property, duration of exposure and nature of contamination. After-death cleaning in a recent studio may be completed in one day. A Diogenes apartment of 80 m² may require 3 to 5 days. We provide a precise estimate during the initial phone assessment."
        },
        {
          q: "Can personal items or documents be retrieved before the intervention?",
          a: "Yes, provided the area does not present an immediate biological hazard. During our on-site assessment we identify safe zones where objects may be retrieved. For contaminated areas, we carry out an inventory before any evacuation and preserve all identifiable sentimental or administrative items."
        },
        {
          q: "What are the risks of not using a professional?",
          a: "Biological hazards from bodily fluids (hepatitis B and C, various bacteria) remain active for several weeks after death. Non-professional cleaning often leaves invisible contamination on porous surfaces and underlays. Poorly treated odours return persistently. In the case of sale or reletting, these issues may also engage the owner's civil liability."
        },
        {
          q: "Do you provide a decontamination certificate?",
          a: "Yes. An intervention report and decontamination certificate can be provided at the end of the job. These documents are accepted by insurance companies, notarial offices and social landlords. They certify that the property has been treated according to current biological protocols and is safe for reoccupation."
        },
        {
          q: "How do I get a quote for extreme cleaning?",
          a: "Call our line on 06 49 50 28 01 (available 24/7) or use our online quote form. For this type of intervention we recommend a phone call, which allows a faster and more accurate assessment. You will receive an estimate within the hour and a formal quote within 24 hours."
        }
      ],
      relatedSlugs: ["sinistre", "debarras", "batiments", "particuliers"]
    }
  },

  sinistre: {
    fr: {
      seo: {
        title: "Nettoyage après sinistre -Incendie, Dégât des eaux, Inondation | BIONET SOLUTIONS",
        description: "Remise en état d'urgence après sinistre : incendie, dégât des eaux, inondation, vandalisme. Intervention 24h/24, attestation assureur -Lyon, Rhône-Alpes. Devis gratuit."
      },
      hero: {
        h1: "Expert nettoyage après sinistre -Incendie, Inondation, Dégât des eaux -Lyon & Rhône-Alpes",
        subtitle: "Intervention d'urgence certifiée disponible 24h/24. Remise en état complète après incendie, dégât des eaux ou inondation. Attestation fournie pour votre assureur.",
        badge: "Urgence 24h/24 · Attestation assureur · Lyon & Rhône-Alpes",
        image: "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?crop=entropy&cs=srgb&fm=jpg&q=85&w=900"
      },
      intro: {
        title: "Pourquoi confier la remise en état après sinistre à un professionnel ?",
        body: [
          "Un incendie, une inondation ou un dégât des eaux laisse des traces bien au-delà de ce qui est visible à l'œil nu. La suie se dépose dans les recoins les plus inaccessibles, l'eau stagnante provoque des moisissures en 24 à 48 heures, et les odeurs de fumée ou d'humidité persistent des mois si elles ne sont pas neutralisées à la source. Une intervention amateur risque d'empirer la situation et de compromettre votre dossier assurance.",
          "BIONET SOLUTIONS intervient en urgence sur tout type de sinistre avec des équipes formées, du matériel professionnel d'extraction d'eau, des sécheurs industriels et des produits biocides homologués. Nous documentons chaque étape de l'intervention pour constituer un dossier complet à remettre à votre compagnie d'assurance.",
          "Notre protocole couvre la sécurisation des locaux, l'extraction de l'eau résiduelle, le séchage par déshumidificateurs industriels, le nettoyage des suies et fumées, le traitement des moisissures et la neutralisation des odeurs. Nous intervenons dans le périmètre Lyon–Rhône-Alpes en moins de 4h et partout en France sous 24h."
        ]
      },
      whyUs: [
        {
          icon: "Zap",
          title: "Intervention en moins de 4h",
          desc: "Chaque heure compte après un sinistre. Notre équipe d'urgence est mobilisable 24h/24, 7j/7, avec une intervention garantie en moins de 4h dans le périmètre lyonnais."
        },
        {
          icon: "Users",
          title: "Équipe dédiée sinistre",
          desc: "Techniciens formés spécifiquement aux interventions post-sinistre : extraction d'eau, séchage industriel, traitement des suies et moisissures, neutralisation des odeurs."
        },
        {
          icon: "ShieldCheck",
          title: "Matériel industriel certifié",
          desc: "Déshumidificateurs industriels, extracteurs haute puissance, biocides homologués, détecteurs d'humidité. Nous utilisons les mêmes équipements que les experts en sinistres."
        },
        {
          icon: "Award",
          title: "Attestation pour votre assureur",
          desc: "Rapport d'intervention complet avec photos avant/après, protocole appliqué et attestation de remise en état. Document reconnu par toutes les compagnies d'assurance."
        }
      ],
      process: [
        {
          step: 1,
          title: "Appel d'urgence et évaluation",
          desc: "Vous nous appelez ou remplissez le formulaire. Nous vous recontactons dans les 30 minutes, évaluons l'ampleur du sinistre et planifions l'intervention.",
          tag: "< 30 min"
        },
        {
          step: 2,
          title: "Sécurisation et extraction",
          desc: "Sécurisation du périmètre, coupure des alimentations si nécessaire. Extraction de l'eau résiduelle avec pompes et aspirateurs industriels.",
          tag: "Arrivée J+0"
        },
        {
          step: 3,
          title: "Séchage et décontamination",
          desc: "Mise en place des déshumidificateurs industriels. Nettoyage des suies et fumées. Traitement biocide contre les moisissures et bactéries. Neutralisation des odeurs.",
          tag: "J+0 à J+3"
        },
        {
          step: 4,
          title: "Remise en état et attestation",
          desc: "Nettoyage final, restauration de l'état du bien. Remise du rapport d'intervention complet avec photos avant/après pour votre dossier assurance.",
          tag: "Fin d'intervention"
        }
      ],
      clientExamples: [
        {
          avatar: "J",
          from: "M. Jean-Marc B. -Propriétaire, Lyon 7e",
          date: "Février 2025",
          subject: "Dégât des eaux -appartement du dessus",
          message: "Suite à une rupture de canalisation chez le voisin du dessus, mon appartement a subi des dégâts importants. Plafonds effondrés, parquets gonflés, odeurs de moisissures après 3 jours. J'ai besoin d'une intervention rapide pour stopper les dégâts et d'un rapport complet pour mon assurance."
        },
        {
          avatar: "A",
          from: "Mme Amina K. -Gérante, Villeurbanne",
          date: "Octobre 2024",
          subject: "Incendie cuisine -restaurant",
          message: "Nous avons eu un départ de feu dans notre cuisine. Le sinistre est maîtrisé mais les dégâts sont importants : suies sur tous les murs, odeur de fumée, équipements recouverts de noir. Il faut tout nettoyer et fournir un rapport pour l'assurance avant la réouverture."
        },
        {
          avatar: "G",
          from: "M. Gilles T. -Syndic, Bron",
          date: "Janvier 2025",
          subject: "Inondation cave -copropriété",
          message: "Suite aux fortes pluies, la cave de notre immeuble a été inondée. Plusieurs centimètres d'eau, équipements endommagés, risque de moisissures. Nous avons besoin d'une intervention rapide avec extraction et séchage industriels."
        }
      ],
      faq: [
        {
          q: "Dans quel délai pouvez-vous intervenir après un sinistre ?",
          a: "Nous intervenons en moins de 4 heures dans le périmètre Lyon–Rhône-Alpes pour les urgences. Pour le reste de la France, le délai est de 24 à 48 heures maximum via notre réseau de techniciens déployés sur tout le territoire. Notre ligne d'urgence est active 24h/24, 7j/7."
        },
        {
          q: "Fournissez-vous un rapport pour l'assurance ?",
          a: "Oui, systématiquement. Nous réalisons une documentation complète avant/après avec photos géolocalisées, protocoles appliqués, produits utilisés et résultats obtenus. Ce rapport est accepté par toutes les compagnies d'assurance et experts en sinistres."
        },
        {
          q: "Peut-on habiter le logement pendant l'intervention ?",
          a: "Cela dépend de l'ampleur du sinistre. Pour un dégât des eaux limité, vous pouvez souvent rester dans les pièces non affectées. Après un incendie ou une inondation importante, nous recommandons de libérer les lieux pendant l'intervention pour des raisons de sécurité et d'efficacité."
        },
        {
          q: "Intervenez-vous aussi sur les moisissures après sinistre ?",
          a: "Oui. Le traitement des moisissures est une composante essentielle de notre protocole post-sinistre. Nous utilisons des biocides fongicides homologués et des techniques de séchage industriel pour éliminer les moisissures en profondeur et prévenir leur réapparition."
        },
        {
          q: "Comment neutralisez-vous les odeurs de fumée ou d'humidité ?",
          a: "Nous utilisons des neutralisants professionnels à action profonde -ozone, hydroxyle ou produits bioenzymatiques selon la nature de l'odeur -qui éliminent les molécules odorantes à la source plutôt que de les masquer. Les résultats sont durables et attestés."
        }
      ],
      relatedSlugs: ["extreme", "debarras", "batiments", "chantier"]
    },
    en: {
      seo: {
        title: "Post-disaster cleaning -Fire, Water damage, Flood | BIONET SOLUTIONS",
        description: "Emergency restoration after disasters: fire, water damage, flood, vandalism. 24/7 response, insurer certificate -Lyon, Rhône-Alpes. Free quote."
      },
      hero: {
        h1: "Expert post-disaster cleaning -Fire, Flood, Water damage -Lyon & Rhône-Alpes",
        subtitle: "Certified emergency response available 24/7. Full restoration after fire, water damage, flood or vandalism. Certificate provided for your insurer.",
        badge: "24/7 emergency · Insurer certificate · Lyon & Rhône-Alpes",
        image: "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?crop=entropy&cs=srgb&fm=jpg&q=85&w=900"
      },
      intro: {
        title: "Why trust a professional for post-disaster restoration?",
        body: [
          "A fire, flood or water damage leaves traces far beyond what is visible to the naked eye. Soot settles in the most inaccessible corners, standing water causes mould within 24 to 48 hours, and smoke or moisture odours persist for months if not neutralised at source. Amateur intervention risks making things worse and compromising your insurance claim.",
          "BIONET SOLUTIONS responds to emergencies on all types of disaster with trained teams, professional water extraction equipment, industrial dryers and approved biocidal products. We document every stage of the intervention to compile a full dossier for your insurance company.",
          "Our protocol covers securing the premises, extracting residual water, industrial drying, cleaning soot and smoke, treating mould and neutralising odours. We respond in the Lyon–Rhône-Alpes area within 4 hours and across France within 24 hours."
        ]
      },
      whyUs: [
        {
          icon: "Zap",
          title: "Response in under 4 hours",
          desc: "Every hour matters after a disaster. Our emergency team is on call 24/7 with guaranteed response in under 4 hours in the Lyon area."
        },
        {
          icon: "Users",
          title: "Dedicated disaster team",
          desc: "Technicians specifically trained for post-disaster operations: water extraction, industrial drying, soot and mould treatment, odour neutralisation."
        },
        {
          icon: "ShieldCheck",
          title: "Certified industrial equipment",
          desc: "Industrial dehumidifiers, high-power extractors, approved biocides, moisture detectors. We use the same equipment as disaster assessment experts."
        },
        {
          icon: "Award",
          title: "Certificate for your insurer",
          desc: "Full intervention report with before/after photos, applied protocol and restoration certificate. Accepted by all insurance companies."
        }
      ],
      process: [
        {
          step: 1,
          title: "Emergency call and assessment",
          desc: "Call us or fill in the form. We call back within 30 minutes, assess the extent of the disaster and schedule the intervention.",
          tag: "< 30 min"
        },
        {
          step: 2,
          title: "Securing and extraction",
          desc: "Perimeter secured, utilities shut off if necessary. Residual water extracted with industrial pumps and vacuums.",
          tag: "Day 0 -arrival"
        },
        {
          step: 3,
          title: "Drying and decontamination",
          desc: "Industrial dehumidifiers deployed. Soot and smoke cleaned. Biocidal treatment against mould and bacteria. Odours neutralised.",
          tag: "Day 0 to Day 3"
        },
        {
          step: 4,
          title: "Restoration and certificate",
          desc: "Final cleaning, property fully restored. Complete intervention report with before/after photos provided for your insurance claim.",
          tag: "End of intervention"
        }
      ],
      clientExamples: [
        {
          avatar: "J",
          from: "Mr Jean-Marc B. -Owner, Lyon 7th",
          date: "February 2025",
          subject: "Water damage -upstairs neighbour",
          message: "Following a burst pipe in the flat above, my apartment suffered significant damage. Collapsed ceilings, warped parquet, mould smell after 3 days. I need a fast response to stop the damage spreading and a full report for my insurer."
        },
        {
          avatar: "A",
          from: "Ms Amina K. -Manager, Villeurbanne",
          date: "October 2024",
          subject: "Kitchen fire -restaurant",
          message: "We had a fire start in our kitchen. The blaze is contained but the damage is serious: soot on all walls, smoke smell, equipment covered in black residue. Everything needs cleaning and a report for insurance before we can reopen."
        },
        {
          avatar: "G",
          from: "Mr Gilles T. -Property manager, Bron",
          date: "January 2025",
          subject: "Flooded basement -condo building",
          message: "Following heavy rains, our building's basement was flooded. Several centimetres of water, damaged equipment, mould risk. We need a fast intervention with industrial extraction and drying."
        }
      ],
      faq: [
        {
          q: "How quickly can you respond after a disaster?",
          a: "We respond within 4 hours in the Lyon–Rhône-Alpes area for emergencies. For the rest of France, the time is 24 to 48 hours maximum through our nationwide technician network. Our emergency line is active 24/7."
        },
        {
          q: "Do you provide a report for the insurance company?",
          a: "Yes, always. We produce complete before/after documentation with geolocated photos, applied protocols, products used and results obtained. This report is accepted by all insurance companies and loss adjusters."
        },
        {
          q: "Can we stay in the property during the intervention?",
          a: "It depends on the extent of the disaster. For minor water damage, you can often remain in unaffected rooms. After a fire or major flood, we recommend vacating the premises during the intervention for safety and efficiency."
        },
        {
          q: "Do you also treat mould after a disaster?",
          a: "Yes. Mould treatment is an essential part of our post-disaster protocol. We use approved fungicidal biocides and industrial drying techniques to eliminate mould in depth and prevent recurrence."
        },
        {
          q: "How do you neutralise smoke or moisture odours?",
          a: "We use professional deep-action neutralisers -ozone, hydroxyl or bio-enzymatic products depending on the odour -which eliminate odour molecules at source rather than masking them. Results are lasting and certified."
        }
      ],
      relatedSlugs: ["extreme", "debarras", "batiments", "chantier"]
    }
  },

  debarras: {
    fr: {
      seo: {
        title: "Débarras professionnel -Maison, Appartement, Succession, Cave | BIONET SOLUTIONS",
        description: "Débarras complet : maison, appartement, cave, garage, succession, logement insalubre. Tri, évacuation, nettoyage. Devis gratuit -Lyon, Rhône-Alpes."
      },
      hero: {
        h1: "Débarras professionnel -Maison, Appartement, Cave, Succession -Lyon & Rhône-Alpes",
        subtitle: "Tri sélectif, évacuation des encombrants et nettoyage complet. Intervention respectueuse pour les successions et les situations sensibles. Devis gratuit sous 24h.",
        badge: "Tri & Valorisation · Successions · Lyon & Rhône-Alpes",
        image: "https://images.unsplash.com/photo-1558618047-3c8c76ca7d13?crop=entropy&cs=srgb&fm=jpg&q=85&w=900"
      },
      intro: {
        title: "Un débarras professionnel : bien plus qu'une simple évacuation",
        body: [
          "Un débarras ne se résume pas à sortir des meubles et des cartons. Il implique un tri rigoureux pour identifier ce qui peut être conservé, donné, recyclé ou évacué. BIONET SOLUTIONS adopte une approche sélective et responsable : nous valorisons au maximum les objets récupérables en les orientant vers des filières de réemploi ou de don, et n'évacuons que ce qui ne peut pas être sauvé.",
          "Les situations de débarras sont souvent liées à des moments de vie délicats : décès, succession, départ en maison de retraite, séparation, ou logement longtemps inoccupé. Notre équipe intervient avec tact et respect, en préservant tout document, objet de valeur ou souvenir personnel identifiable. Nous pouvons travailler en présence de la famille ou de façon totalement autonome selon vos préférences.",
          "Après le débarras, nous assurons un nettoyage complet du logement pour le remettre dans un état propre et neutre, prêt pour une remise en location, une vente ou une nouvelle occupation. L'ensemble du processus -de l'évaluation au nettoyage final -est géré par nos équipes en une seule intervention coordonnée."
        ]
      },
      whyUs: [
        {
          icon: "Star",
          title: "Approche sélective et valorisation",
          desc: "Nous trions chaque objet avant évacuation : don aux associations, vente aux récupérateurs, recyclage filières adaptées. Zéro gaspillage inutile, rapport de valorisation fourni."
        },
        {
          icon: "Heart",
          title: "Respect total en situation de succession",
          desc: "Formation spécifique de nos équipes aux situations de deuil. Nous préservons tout objet, document ou souvenir identifiable et vous remettons un inventaire avant évacuation."
        },
        {
          icon: "Users",
          title: "Équipe complète clé en main",
          desc: "Manutentionnaires, chauffeurs, agents de nettoyage : toute l'équipe est coordonnée pour une intervention en une seule fois, sans multiplier les prestataires."
        },
        {
          icon: "ShieldCheck",
          title: "Devis gratuit et transparent",
          desc: "Évaluation sur site gratuite sous 24h. Devis détaillé par poste : tri, évacuation, nettoyage, valorisation. Aucun coût caché, aucune mauvaise surprise."
        }
      ],
      process: [
        {
          step: 1,
          title: "Évaluation gratuite sur site",
          desc: "Un technicien se déplace gratuitement pour évaluer le volume, la nature des objets et l'état du logement. Devis détaillé remis sous 24h.",
          tag: "Gratuit"
        },
        {
          step: 2,
          title: "Tri et inventaire",
          desc: "Passage en revue de l'ensemble du contenu. Identification des objets à conserver, à donner, à recycler ou à évacuer. Inventaire remis à la famille sur demande.",
          tag: "Jour J"
        },
        {
          step: 3,
          title: "Évacuation et valorisation",
          desc: "Évacuation des encombrants et gravats dans nos véhicules. Acheminement vers les filières de réemploi, recyclage ou déchetterie agréée. Rapport de valorisation fourni.",
          tag: "Jour J"
        },
        {
          step: 4,
          title: "Nettoyage et remise en état",
          desc: "Nettoyage complet du logement vide : sols, murs, sanitaires, cuisine. Le bien est remis dans un état propre et neutre, prêt à la visite ou à la remise en location.",
          tag: "Fin d'intervention"
        }
      ],
      clientExamples: [
        {
          avatar: "M",
          from: "Mme Marie-France D. -Notaire, Lyon 3e",
          date: "Avril 2025",
          subject: "Débarras succession -maison 120 m²",
          message: "Je gère la succession d'un client décédé. La maison contient beaucoup de meubles anciens, des objets de valeur potentielle et des archives à trier. La famille souhaite un inventaire complet avant tout enlèvement. Pouvez-vous intervenir avec une approche respectueuse et fournir un document de valorisation ?"
        },
        {
          avatar: "R",
          from: "M. Robert C. -Particulier, Meyzieu",
          date: "Mars 2025",
          subject: "Débarras grenier et cave -maison familiale",
          message: "Nous vendons la maison de famille et devons vider le grenier et la cave accumulés depuis 40 ans. Beaucoup d'objets, certains potentiellement récupérables. Nous souhaitons que tout ce qui peut être donné soit valorisé plutôt que jeté."
        },
        {
          avatar: "I",
          from: "M. Ibrahim S. -Bailleur, Décines",
          date: "Décembre 2024",
          subject: "Débarras après départ locataire -logement insalubre",
          message: "Un locataire est parti en laissant un appartement dans un état catastrophique : meubles abandonnés, déchets, dégradations. J'ai besoin d'un débarras complet suivi d'un nettoyage en profondeur pour pouvoir remettre le bien en location rapidement."
        }
      ],
      faq: [
        {
          q: "Comment se calcule le prix d'un débarras ?",
          a: "Le prix dépend du volume à évacuer, de la superficie du logement, du nombre d'étages (sans ascenseur), de la distance à la déchetterie et de l'état général. Nous proposons une évaluation gratuite sur site pour établir un devis précis. En général, un appartement de 50 m² vide se débarras en une demi-journée."
        },
        {
          q: "Que faites-vous des objets encore en bon état ?",
          a: "Nous trions systématiquement avant évacuation. Les meubles et objets en bon état sont orientés vers des associations de réemploi, des ressourceries ou des particuliers. Ce que nous ne pouvons pas valoriser est évacué vers les filières de recyclage ou la déchetterie agréée. Nous vous fournissons un rapport de valorisation."
        },
        {
          q: "Pouvez-vous intervenir sans que la famille soit présente ?",
          a: "Oui, nous pouvons travailler de façon totalement autonome avec un double de clé. Nous réalisons un inventaire photo avant toute évacuation et vous le transmettons. Sur demande, nous pouvons aussi travailler en présence d'un membre de la famille pour les décisions de tri."
        },
        {
          q: "Effectuez-vous le nettoyage après le débarras ?",
          a: "Oui, c'est une prestation que nous incluons systématiquement ou sur demande. Un nettoyage complet est réalisé une fois le logement vidé : sols, murs, sanitaires, cuisine, vitres. Le bien est remis dans un état propre et neutre, prêt pour une visite de vente ou une remise en location."
        },
        {
          q: "Pouvez-vous débarras un logement Diogène ou insalubre ?",
          a: "Oui, c'est l'une de nos spécialités. Ces interventions combinent débarras sélectif, désinfection complète et traitement des odeurs. Nos équipes sont formées et équipées pour travailler dans des conditions difficiles (nuisibles, moisissures, encrassement extrême) dans le respect total de la personne concernée."
        }
      ],
      relatedSlugs: ["extreme", "sinistre", "particuliers", "professionnels"]
    },
    en: {
      seo: {
        title: "Professional clearance -House, Apartment, Estate, Cellar | BIONET SOLUTIONS",
        description: "Full clearance: house, apartment, cellar, garage, estate, unsanitary housing. Sorting, removal, cleaning. Free quote -Lyon, Rhône-Alpes."
      },
      hero: {
        h1: "Professional clearance -House, Apartment, Cellar, Estate -Lyon & Rhône-Alpes",
        subtitle: "Selective sorting, bulky waste removal and full cleaning. Respectful service for estates and sensitive situations. Free quote within 24 hours.",
        badge: "Sorting & Recycling · Estates · Lyon & Rhône-Alpes",
        image: "https://images.unsplash.com/photo-1558618047-3c8c76ca7d13?crop=entropy&cs=srgb&fm=jpg&q=85&w=900"
      },
      intro: {
        title: "Professional clearance: much more than just removal",
        body: [
          "A clearance is not simply about moving furniture and boxes out. It involves rigorous sorting to identify what can be kept, donated, recycled or removed. BIONET SOLUTIONS takes a selective and responsible approach: we maximise the reuse of salvageable items by directing them to second-hand or donation channels, and only remove what cannot be saved.",
          "Clearance situations are often linked to difficult life events: bereavement, estate management, move to care, separation, or long-unoccupied properties. Our team works with tact and respect, preserving any identifiable documents, valuables or personal mementos. We can work in the presence of family or fully independently according to your preference.",
          "After clearance, we carry out a full clean of the property to leave it in a clean, neutral state ready for rental, sale or reoccupation. The entire process -from assessment to final clean -is managed by our teams in a single coordinated intervention."
        ]
      },
      whyUs: [
        {
          icon: "Star",
          title: "Selective approach and valorisation",
          desc: "We sort every item before removal: donation to associations, sale to dealers, recycling to appropriate channels. Zero unnecessary waste, valorisation report provided."
        },
        {
          icon: "Heart",
          title: "Full respect in estate situations",
          desc: "Our teams are specifically trained for bereavement situations. We preserve all identifiable objects, documents or mementos and provide an inventory before removal."
        },
        {
          icon: "Users",
          title: "Complete turnkey team",
          desc: "Handlers, drivers, cleaning agents: the whole team is coordinated for a single intervention, no need to manage multiple contractors."
        },
        {
          icon: "ShieldCheck",
          title: "Free and transparent quote",
          desc: "Free on-site assessment within 24 hours. Detailed quote by line: sorting, removal, cleaning, valorisation. No hidden costs, no surprises."
        }
      ],
      process: [
        {
          step: 1,
          title: "Free on-site assessment",
          desc: "A technician visits free of charge to assess volume, item types and property condition. Detailed quote provided within 24 hours.",
          tag: "Free"
        },
        {
          step: 2,
          title: "Sorting and inventory",
          desc: "Full review of all contents. Items identified for keeping, donation, recycling or removal. Inventory provided to family on request.",
          tag: "Day of works"
        },
        {
          step: 3,
          title: "Removal and valorisation",
          desc: "Bulky waste and rubble loaded into our vehicles. Directed to reuse, recycling or approved waste facilities. Valorisation report provided.",
          tag: "Day of works"
        },
        {
          step: 4,
          title: "Cleaning and handover",
          desc: "Full clean of the empty property: floors, walls, bathrooms, kitchen. Property returned in a clean neutral state ready for viewing or reletting.",
          tag: "End of works"
        }
      ],
      clientExamples: [
        {
          avatar: "M",
          from: "Ms Marie-France D. -Notary, Lyon 3rd",
          date: "April 2025",
          subject: "Estate clearance -120 m² house",
          message: "I am managing the estate of a deceased client. The house contains much antique furniture, potentially valuable objects and archives to be sorted. The family wants a full inventory before any removal. Can you intervene with a respectful approach and provide a valorisation document?"
        },
        {
          avatar: "R",
          from: "Mr Robert C. -Individual, Meyzieu",
          date: "March 2025",
          subject: "Attic and cellar clearance -family home",
          message: "We are selling the family home and need to clear the attic and cellar accumulated over 40 years. Many items, some potentially recoverable. We want everything that can be donated to be valorised rather than thrown away."
        },
        {
          avatar: "I",
          from: "Mr Ibrahim S. -Landlord, Décines",
          date: "December 2024",
          subject: "Clearance after tenant departure -unsanitary property",
          message: "A tenant left the apartment in a disastrous state: abandoned furniture, rubbish, damage. I need a full clearance followed by deep cleaning to get the property back on the rental market quickly."
        }
      ],
      faq: [
        {
          q: "How is the price of a clearance calculated?",
          a: "The price depends on the volume to be removed, the property size, the number of floors (no lift), the distance to the waste facility and the overall condition. We offer a free on-site assessment to provide an accurate quote. Generally a 50 m² empty apartment can be cleared in half a day."
        },
        {
          q: "What do you do with items still in good condition?",
          a: "We always sort before removal. Furniture and objects in good condition are directed to reuse associations, second-hand shops or individuals. What we cannot valorise is taken to recycling or an approved waste facility. We provide a valorisation report."
        },
        {
          q: "Can you work without the family being present?",
          a: "Yes, we can work fully independently with a spare key. We take a photo inventory before any removal and send it to you. On request, we can also work with a family member present for sorting decisions."
        },
        {
          q: "Do you clean after the clearance?",
          a: "Yes, this is a service we include as standard or on request. A full clean is carried out once the property is empty: floors, walls, bathrooms, kitchen, windows. The property is returned in a clean neutral state ready for a sales viewing or reletting."
        },
        {
          q: "Can you clear a Diogenes syndrome or unsanitary property?",
          a: "Yes, this is one of our specialities. These interventions combine selective clearance, full disinfection and odour treatment. Our teams are trained and equipped to work in difficult conditions (pests, mould, extreme dirt) with full respect for the person involved."
        }
      ],
      relatedSlugs: ["extreme", "sinistre", "particuliers", "professionnels"]
    }
  },

  particuliers: {
    fr: {
      seo: {
        title: "Ménage et nettoyage à domicile -Lyon & Rhône-Alpes | BIONET SOLUTIONS",
        description: "Service ménage professionnel à domicile : ménage régulier, grand nettoyage, déménagement, nettoyage de printemps. Devis gratuit -Lyon, Auvergne-Rhône-Alpes."
      },
      hero: {
        h1: "Service ménage et nettoyage à domicile -Lyon & Auvergne-Rhône-Alpes",
        subtitle: "Ménage régulier, grand nettoyage, nettoyage avant ou après déménagement. Des agents de ménage professionnels, formés et assurés, disponibles selon vos horaires.",
        badge: "Agents formés & assurés · Produits professionnels · Horaires flexibles",
        image: "https://images.unsplash.com/photo-1527515637462-cff94edd0f9f?crop=entropy&cs=srgb&fm=jpg&q=85&w=900"
      },
      intro: {
        title: "Un ménage professionnel, c'est la différence que vous voyez et sentez",
        body: [
          "Le ménage professionnel ne se résume pas à passer l'aspirateur et essuyer les surfaces. Nos agents formés maîtrisent les techniques de nettoyage adaptées à chaque type de surface -carrelage, parquet, marbre, inox, vitrocéramique -et utilisent des produits professionnels qui désincrustent en profondeur sans abîmer les matériaux. Le résultat est visible immédiatement et dure plus longtemps qu'avec des produits grande distribution.",
          "Nous intervenons chez les particuliers pour tous types de prestations : ménage régulier (hebdomadaire ou bimensuel), ménage ponctuel, grand nettoyage de printemps, nettoyage avant ou après déménagement, nettoyage après soirée ou événement privé. Chaque prestation est calibrée selon la superficie de votre logement et vos priorités.",
          "Tous nos agents sont formés, assurés en responsabilité civile professionnelle et passés au contrôle de référence. Nous intervenons dans le périmètre Lyon–Auvergne-Rhône-Alpes avec des créneaux disponibles en semaine et le week-end. Votre domicile, votre tranquillité."
        ]
      },
      whyUs: [
        {
          icon: "Award",
          title: "Agents formés et certifiés",
          desc: "Chaque agent suit une formation interne aux techniques et produits professionnels. Responsabilité civile professionnelle incluse. Résultats garantis ou intervention refaite."
        },
        {
          icon: "ShieldCheck",
          title: "Produits professionnels sûrs",
          desc: "Produits de nettoyage professionnels adaptés à chaque surface. Formules sans rinçage toxique, respectueuses des enfants et animaux. Microfibres haute performance."
        },
        {
          icon: "Clock",
          title: "Horaires 100 % flexibles",
          desc: "Créneaux disponibles en semaine, week-end et jours fériés. Intervention à l'heure qui vous convient, avec la même équipe à chaque passage pour votre tranquillité."
        },
        {
          icon: "Star",
          title: "Satisfaction garantie",
          desc: "Vous n'êtes pas satisfait du résultat ? Nous revenons sans frais dans les 48h. Plus de 98 % de nos clients renouvellent leur contrat ménage régulier."
        }
      ],
      process: [
        {
          step: 1,
          title: "Demande et devis gratuit",
          desc: "Remplissez notre formulaire ou appelez-nous. Nous vous rappelons sous 2h pour établir un devis sur mesure selon votre superficie et vos besoins.",
          tag: "Gratuit"
        },
        {
          step: 2,
          title: "Première intervention et état des lieux",
          desc: "Lors de la première venue, notre agent réalise un état des lieux de votre logement pour identifier les zones prioritaires et les matériaux à traiter avec attention.",
          tag: "J+1 à J+3"
        },
        {
          step: 3,
          title: "Ménage professionnel complet",
          desc: "Nettoyage méthodique pièce par pièce : dépoussiérage, surfaces, sols, sanitaires, cuisine. Produits professionnels adaptés à chaque surface.",
          tag: "Selon prestation"
        },
        {
          step: 4,
          title: "Contrôle qualité et retour",
          desc: "Notre agent effectue un contrôle qualité avant de partir. Vous pouvez nous faire part de vos retours pour affiner les prochaines interventions.",
          tag: "Fin de passage"
        }
      ],
      clientExamples: [
        {
          avatar: "L",
          from: "Mme Laure P. -Cadre, Lyon 6e",
          date: "Mai 2025",
          subject: "Ménage hebdomadaire -appartement 70 m²",
          message: "Je cherche un service de ménage régulier fiable pour mon appartement de 70 m². Je travaille toute la semaine et n'ai pas le temps de m'en occuper correctement. Je souhaite le même agent à chaque fois pour créer une relation de confiance."
        },
        {
          avatar: "V",
          from: "M. Vincent R. -Propriétaire, Saint-Priest",
          date: "Janvier 2025",
          subject: "Grand nettoyage avant mise en vente",
          message: "Nous mettons notre maison de 120 m² en vente et souhaitons un grand nettoyage complet pour la remettre en valeur : nettoyage des vitres, récurage des sanitaires, nettoyage des joints, lessivage des murs. Vous intervenez aussi sur les appareils électroménagers ?"
        },
        {
          avatar: "N",
          from: "Mme Nadia F. -Particulière, Caluire",
          date: "Mars 2025",
          subject: "Nettoyage après déménagement",
          message: "Nous venons de déménager dans un appartement dont les anciens locataires n'ont visiblement pas nettoyé avant de partir. J'ai besoin d'un nettoyage en profondeur de l'intégralité de l'appartement avant d'y installer nos affaires."
        }
      ],
      faq: [
        {
          q: "Quelle est la différence entre un ménage régulier et un grand nettoyage ?",
          a: "Le ménage régulier (hebdomadaire ou bimensuel) couvre l'entretien courant : aspiration, nettoyage des surfaces, sanitaires, cuisine. Le grand nettoyage est une intervention ponctuelle plus approfondie qui inclut le lessivage des murs et plafonds, le nettoyage des joints, des cadrages, des appareils électroménagers, des vitres intérieures et extérieures et des espaces habituellement peu accessibles."
        },
        {
          q: "Fournissez-vous les produits et le matériel ?",
          a: "Oui, nos agents apportent l'intégralité du matériel et des produits nécessaires : aspirateurs professionnels, microfibres haute performance, produits de nettoyage professionnels adaptés à chaque surface. Vous n'avez rien à fournir."
        },
        {
          q: "Est-ce que le même agent intervient à chaque passage ?",
          a: "Nous faisons tout notre possible pour maintenir le même agent à chaque passage dans le cadre d'un contrat ménage régulier. En cas d'absence, nous vous prévenons et envoyons un remplaçant formé qui a accès aux consignes spécifiques à votre logement."
        },
        {
          q: "Intervenez-vous en mon absence ?",
          a: "Oui, la majorité de nos clients nous confient un double de clé ou un code d'entrée. Tous nos agents signent un accord de confidentialité et de responsabilité. En cas de problème constaté lors du passage, nous vous contactons immédiatement."
        },
        {
          q: "Comment se déroule un nettoyage avant ou après déménagement ?",
          a: "Avant déménagement, nous nettoyons le logement vide ou en cours de vidage pour le rendre impeccable avant l'état des lieux sortant. Après déménagement, nous intervenons dans votre nouveau logement pour un nettoyage complet avant installation. Ces prestations incluent vitres, joints, appareils électroménagers laissés en place, sanitaires et sols."
        }
      ],
      relatedSlugs: ["professionnels", "sols", "debarras", "chantier"]
    },
    en: {
      seo: {
        title: "Home cleaning service -Lyon & Rhône-Alpes | BIONET SOLUTIONS",
        description: "Professional home cleaning: regular cleaning, deep clean, moving in/out, spring cleaning. Free quote -Lyon, Auvergne-Rhône-Alpes."
      },
      hero: {
        h1: "Home cleaning service -Lyon & Auvergne-Rhône-Alpes",
        subtitle: "Regular cleaning, deep cleaning, pre- and post-move cleaning. Trained, insured professional cleaners available around your schedule.",
        badge: "Trained & insured cleaners · Professional products · Flexible hours",
        image: "https://images.unsplash.com/photo-1527515637462-cff94edd0f9f?crop=entropy&cs=srgb&fm=jpg&q=85&w=900"
      },
      intro: {
        title: "Professional cleaning: the difference you see and feel",
        body: [
          "Professional cleaning is not just vacuuming and wiping surfaces. Our trained agents master cleaning techniques adapted to each surface type -tiles, parquet, marble, stainless steel, ceramic hobs -and use professional products that deep-clean without damaging materials. Results are immediately visible and last longer than with retail products.",
          "We provide residential cleaning for all types of service: regular cleaning (weekly or fortnightly), one-off cleaning, spring deep cleaning, pre- or post-move cleaning, and post-party or private event cleaning. Each service is calibrated to your property size and priorities.",
          "All our agents are trained, professionally insured and reference-checked. We operate in the Lyon–Auvergne-Rhône-Alpes area with slots available on weekdays and weekends. Your home, your peace of mind."
        ]
      },
      whyUs: [
        {
          icon: "Award",
          title: "Trained and certified agents",
          desc: "Each agent completes in-house training on professional techniques and products. Professional liability insurance included. Results guaranteed or we come back free of charge."
        },
        {
          icon: "ShieldCheck",
          title: "Safe professional products",
          desc: "Professional cleaning products adapted to each surface. Formulations safe for children and pets. High-performance microfibre cloths."
        },
        {
          icon: "Clock",
          title: "100% flexible hours",
          desc: "Slots available on weekdays, weekends and public holidays. Intervention at the time that suits you, with the same agent each visit for your peace of mind."
        },
        {
          icon: "Star",
          title: "Satisfaction guaranteed",
          desc: "Not satisfied with the result? We return at no charge within 48 hours. Over 98% of our clients renew their regular cleaning contract."
        }
      ],
      process: [
        {
          step: 1,
          title: "Request and free quote",
          desc: "Fill in our form or call us. We call back within 2 hours to provide a tailored quote based on your property size and needs.",
          tag: "Free"
        },
        {
          step: 2,
          title: "First visit and assessment",
          desc: "On the first visit our agent assesses your property to identify priority areas and materials that require special care.",
          tag: "Day 1 to 3"
        },
        {
          step: 3,
          title: "Full professional clean",
          desc: "Systematic room-by-room cleaning: dusting, surfaces, floors, bathrooms, kitchen. Professional products adapted to each surface.",
          tag: "Per service"
        },
        {
          step: 4,
          title: "Quality check and feedback",
          desc: "Our agent performs a quality check before leaving. You can share feedback to fine-tune future visits.",
          tag: "End of visit"
        }
      ],
      clientExamples: [
        {
          avatar: "L",
          from: "Ms Laure P. -Executive, Lyon 6th",
          date: "May 2025",
          subject: "Weekly cleaning -70 m² apartment",
          message: "I'm looking for a reliable regular cleaning service for my 70 m² apartment. I work all week and have no time to keep up with it properly. I'd like the same agent each time to build a relationship of trust."
        },
        {
          avatar: "V",
          from: "Mr Vincent R. -Owner, Saint-Priest",
          date: "January 2025",
          subject: "Deep clean before sale",
          message: "We're putting our 120 m² house on the market and want a full deep clean to showcase it: window cleaning, bathroom scrubbing, joint cleaning, wall washing. Do you also cover appliances?"
        },
        {
          avatar: "N",
          from: "Ms Nadia F. -Individual, Caluire",
          date: "March 2025",
          subject: "Post-move cleaning",
          message: "We've just moved into an apartment the previous tenants clearly didn't clean before leaving. I need a thorough deep clean of the entire flat before we move our belongings in."
        }
      ],
      faq: [
        {
          q: "What is the difference between regular cleaning and a deep clean?",
          a: "Regular cleaning (weekly or fortnightly) covers routine maintenance: vacuuming, surface wiping, bathrooms, kitchen. A deep clean is a one-off intensive service that includes washing walls and ceilings, cleaning joints, door frames, appliances, inside and outside windows, and hard-to-reach areas."
        },
        {
          q: "Do you bring your own products and equipment?",
          a: "Yes, our agents bring everything needed: professional vacuums, high-performance microfibres, professional cleaning products adapted to each surface. You don't need to provide anything."
        },
        {
          q: "Will the same agent come each time?",
          a: "We do everything possible to keep the same agent for each visit under a regular cleaning contract. In case of absence we notify you and send a trained replacement who has access to your specific instructions."
        },
        {
          q: "Can you work while I'm away?",
          a: "Yes, most of our clients give us a spare key or entry code. All agents sign a confidentiality and responsibility agreement. If we notice a problem during the visit, we contact you immediately."
        },
        {
          q: "How does pre- or post-move cleaning work?",
          a: "Pre-move, we clean the empty or being-vacated property to perfection before the outgoing inspection. Post-move, we carry out a full clean of your new home before you move in. These services include windows, joints, appliances left in place, bathrooms and floors."
        }
      ],
      relatedSlugs: ["professionnels", "sols", "debarras", "chantier"]
    }
  },

  professionnels: {
    fr: {
      seo: {
        title: "Nettoyage locaux professionnels -Bureaux, Commerces, Industrie | BIONET SOLUTIONS",
        description: "Entretien professionnel de vos locaux : bureaux, commerces, restaurants, entrepôts, industries. Contrats réguliers ou ponctuel -Lyon, Rhône-Alpes. Devis gratuit."
      },
      hero: {
        h1: "Expert nettoyage locaux professionnels -Bureaux, Commerces, Industrie -Lyon & Rhône-Alpes",
        subtitle: "Entretien régulier ou ponctuel de vos bureaux, commerces, restaurants, entrepôts et locaux industriels. Interventions hors heures ouvrées pour ne pas perturber votre activité.",
        badge: "Hors heures ouvrées · Contrats sur mesure · Certifié",
        image: "https://images.unsplash.com/photo-1497366216548-37526070297c?crop=entropy&cs=srgb&fm=jpg&q=85&w=900"
      },
      intro: {
        title: "Des locaux propres : un enjeu d'image, de santé et de productivité",
        body: [
          "Des locaux professionnels propres ne sont pas un luxe -c'est un prérequis. Pour vos collaborateurs, la propreté du lieu de travail a un impact direct sur leur bien-être, leur concentration et leur taux d'absentéisme. Pour vos clients et partenaires, c'est le premier signal de sérieux que vous leur envoyez. Pour votre activité en cuisine ou restauration, c'est une obligation réglementaire sous contrôle des services d'hygiène.",
          "BIONET SOLUTIONS prend en charge l'entretien de tous types de locaux professionnels : bureaux et open spaces, commerces et boutiques, restaurants et cuisines professionnelles, entrepôts et ateliers, showrooms, centres commerciaux et parkings. Nous intervenons le soir, la nuit, le week-end ou tôt le matin pour ne jamais perturber votre activité.",
          "Chaque contrat est sur mesure : fréquence, périmètre, protocoles spécifiques (HACCP pour les cuisines, ISO pour certains secteurs industriels), produits adaptés à vos contraintes. Un interlocuteur dédié, un carnet de liaison et des rapports d'intervention réguliers vous garantissent un suivi transparent."
        ]
      },
      whyUs: [
        {
          icon: "Zap",
          title: "Interventions hors heures ouvrées",
          desc: "Soir, nuit, week-end, jours fériés : nous nous adaptons à vos contraintes d'exploitation pour ne jamais perturber votre activité ou vos clients."
        },
        {
          icon: "ShieldCheck",
          title: "Protocoles certifiés par secteur",
          desc: "HACCP pour les cuisines professionnelles, protocoles ISO pour l'industrie, traçabilité des produits. Chaque secteur a ses exigences -nous les maîtrisons."
        },
        {
          icon: "Award",
          title: "Contrats sur mesure",
          desc: "Fréquence, périmètre, niveau de service : votre contrat est adapté à vos besoins et votre budget. Tarification transparente par m² ou par prestation."
        },
        {
          icon: "Clock",
          title: "Interlocuteur dédié et suivi",
          desc: "Un responsable de compte unique, un carnet de liaison numérique, des rapports d'intervention mensuels. Vous êtes informé et maîtrisez la qualité du service."
        }
      ],
      process: [
        {
          step: 1,
          title: "Audit gratuit de vos locaux",
          desc: "Visite de vos locaux pour évaluer les surfaces, les contraintes d'accès, les protocoles spécifiques et vos attentes en termes de résultats.",
          tag: "Gratuit"
        },
        {
          step: 2,
          title: "Proposition de contrat sur mesure",
          desc: "Nous vous remettons une proposition détaillée : fréquence, périmètre, protocoles, équipe affectée, tarif mensuel tout inclus.",
          tag: "Sous 48h"
        },
        {
          step: 3,
          title: "Mise en place et formation équipe",
          desc: "Briefing de l'équipe dédiée à vos locaux, remise des consignes spécifiques, test de la première intervention avec contrôle qualité renforcé.",
          tag: "Démarrage J+5"
        },
        {
          step: 4,
          title: "Suivi et optimisation continue",
          desc: "Carnet de liaison numérique, rapports mensuels, point qualité trimestriel. Nous ajustons le périmètre et les protocoles selon l'évolution de vos locaux.",
          tag: "En continu"
        }
      ],
      clientExamples: [
        {
          avatar: "F",
          from: "M. François B. -DRH, PME industrielle, Vénissieux",
          date: "Novembre 2024",
          subject: "Entretien quotidien -bureaux + atelier 800 m²",
          message: "Nous cherchons une entreprise de nettoyage sérieuse pour prendre en charge l'entretien quotidien de notre site : 300 m² de bureaux + 500 m² d'atelier. Intervention souhaitée avant 7h du matin du lundi au vendredi. Nos locaux précédents prestataire n'étaient plus propres selon nos standards."
        },
        {
          avatar: "H",
          from: "Mme Hélène M. -Gérante, restaurant Lyon 1er",
          date: "Février 2025",
          subject: "Nettoyage cuisine professionnelle HACCP",
          message: "Nous avons eu un contrôle hygiène avec des remarques sur notre cuisine. Je cherche un prestataire spécialisé dans le nettoyage de cuisines professionnelles selon les normes HACCP, avec traçabilité des produits et des interventions pour nos prochains contrôles."
        },
        {
          avatar: "C",
          from: "M. Christophe V. -Directeur, centre commercial, Écully",
          date: "Septembre 2024",
          subject: "Nettoyage quotidien -galerie marchande",
          message: "Nous gérons une galerie marchande de 4 000 m² et cherchons à changer de prestataire de nettoyage. Nous avons besoin d'une couverture 7j/7 avec intervention le matin avant l'ouverture et en soirée après fermeture."
        }
      ],
      faq: [
        {
          q: "Intervenez-vous en dehors des heures de travail ?",
          a: "Oui, systématiquement. La grande majorité de nos interventions en locaux professionnels se déroulent le soir après fermeture, tôt le matin avant l'ouverture, ou le week-end. Nous avons accès à vos locaux par badge, clé ou code selon vos préférences de sécurité."
        },
        {
          q: "Pouvez-vous nettoyer des cuisines professionnelles selon les normes HACCP ?",
          a: "Oui. Nos équipes sont formées aux protocoles HACCP pour les cuisines professionnelles : traçabilité des produits, séparation des zones, nettoyage/désinfection dissociés, documentation. Nous fournissons un carnet de traçabilité complet pour vos contrôles d'hygiène."
        },
        {
          q: "Quels types de locaux professionnels prenez-vous en charge ?",
          a: "Bureaux et open spaces, commerces, boutiques et magasins, restaurants et cuisines professionnelles, entrepôts et ateliers, showrooms, centres commerciaux, parkings, établissements de santé, établissements recevant du public. Contactez-nous pour tout autre type de local."
        },
        {
          q: "Proposez-vous des contrats d'entretien longue durée ?",
          a: "Oui, c'est notre offre principale. Les contrats annuels offrent des tarifs plus avantageux et garantissent la continuité du service avec une équipe dédiée. Nous proposons aussi des prestations ponctuelles sans engagement pour les besoins occasionnels."
        },
        {
          q: "Comment gérez-vous la qualité au quotidien ?",
          a: "Chaque intervention est tracée dans notre carnet de liaison numérique accessible en ligne. Un responsable qualité effectue des contrôles inopinés. Des points qualité trimestriels avec votre interlocuteur dédié permettent d'ajuster les protocoles si nécessaire."
        }
      ],
      relatedSlugs: ["particuliers", "immeubles", "chantier", "sols"]
    },
    en: {
      seo: {
        title: "Professional premises cleaning -Offices, Retail, Industry | BIONET SOLUTIONS",
        description: "Professional maintenance of your premises: offices, retail, restaurants, warehouses, industry. Regular or one-off contracts -Lyon, Rhône-Alpes. Free quote."
      },
      hero: {
        h1: "Expert professional premises cleaning -Offices, Retail, Industry -Lyon & Rhône-Alpes",
        subtitle: "Regular or one-off maintenance of your offices, shops, restaurants, warehouses and industrial premises. Out-of-hours interventions to keep your operations running smoothly.",
        badge: "Out-of-hours · Tailored contracts · Certified",
        image: "https://images.unsplash.com/photo-1497366216548-37526070297c?crop=entropy&cs=srgb&fm=jpg&q=85&w=900"
      },
      intro: {
        title: "Clean premises: an image, health and productivity imperative",
        body: [
          "Clean professional premises are not a luxury -they are a prerequisite. For your employees, workplace cleanliness has a direct impact on their wellbeing, concentration and absenteeism. For your clients and partners, it is the first signal of professionalism you send. For food service or catering operations, it is a regulatory obligation subject to health inspections.",
          "BIONET SOLUTIONS handles the maintenance of all types of professional premises: offices and open spaces, retail and shops, restaurants and professional kitchens, warehouses and workshops, showrooms, shopping centres and car parks. We operate evenings, nights, weekends or early mornings to never disrupt your business.",
          "Each contract is tailored: frequency, scope, specific protocols (HACCP for kitchens, ISO for certain industrial sectors), products suited to your constraints. A dedicated account manager, liaison log and regular intervention reports guarantee transparent service."
        ]
      },
      whyUs: [
        {
          icon: "Zap",
          title: "Out-of-hours interventions",
          desc: "Evenings, nights, weekends, public holidays: we adapt to your operating constraints to never disrupt your business or clients."
        },
        {
          icon: "ShieldCheck",
          title: "Sector-certified protocols",
          desc: "HACCP for professional kitchens, ISO protocols for industry, product traceability. Every sector has its requirements -we know them all."
        },
        {
          icon: "Award",
          title: "Tailored contracts",
          desc: "Frequency, scope, service level: your contract is adapted to your needs and budget. Transparent pricing per m² or per service."
        },
        {
          icon: "Clock",
          title: "Dedicated account manager",
          desc: "A single point of contact, a digital liaison log, monthly intervention reports. You are informed and in control of service quality."
        }
      ],
      process: [
        {
          step: 1,
          title: "Free premises audit",
          desc: "Site visit to assess surfaces, access constraints, specific protocols and your expected results.",
          tag: "Free"
        },
        {
          step: 2,
          title: "Tailored contract proposal",
          desc: "We provide a detailed proposal: frequency, scope, protocols, dedicated team, all-inclusive monthly rate.",
          tag: "Within 48h"
        },
        {
          step: 3,
          title: "Setup and team briefing",
          desc: "Briefing of the team dedicated to your premises, specific instructions issued, first intervention tested with enhanced quality control.",
          tag: "Start Day+5"
        },
        {
          step: 4,
          title: "Ongoing monitoring and optimisation",
          desc: "Digital liaison log, monthly reports, quarterly quality review. We adjust scope and protocols as your premises evolve.",
          tag: "Ongoing"
        }
      ],
      clientExamples: [
        {
          avatar: "F",
          from: "Mr François B. -HR Director, industrial SME, Vénissieux",
          date: "November 2024",
          subject: "Daily maintenance -offices + workshop 800 m²",
          message: "We are looking for a reliable cleaning company to handle daily maintenance of our site: 300 m² of offices and 500 m² of workshop. Intervention required before 7am Monday to Friday. Our previous contractor no longer met our cleanliness standards."
        },
        {
          avatar: "H",
          from: "Ms Hélène M. -Manager, restaurant Lyon 1st",
          date: "February 2025",
          subject: "HACCP professional kitchen cleaning",
          message: "We had a hygiene inspection with remarks about our kitchen. I'm looking for a specialist in professional kitchen cleaning to HACCP standards, with product and intervention traceability for our next inspections."
        },
        {
          avatar: "C",
          from: "Mr Christophe V. -Director, shopping centre, Écully",
          date: "September 2024",
          subject: "Daily cleaning -shopping gallery",
          message: "We manage a 4,000 m² shopping gallery and are looking to change our cleaning contractor. We need 7-day coverage with intervention in the morning before opening and in the evening after closing."
        }
      ],
      faq: [
        {
          q: "Do you work outside business hours?",
          a: "Yes, as standard. The vast majority of our professional premises interventions take place in the evening after closing, early morning before opening, or at weekends. We access your premises by badge, key or code according to your security preferences."
        },
        {
          q: "Can you clean professional kitchens to HACCP standards?",
          a: "Yes. Our teams are trained in HACCP protocols for professional kitchens: product traceability, zone separation, cleaning and disinfection as separate stages, documentation. We provide a full traceability log for your hygiene inspections."
        },
        {
          q: "What types of professional premises do you service?",
          a: "Offices and open spaces, retail and shops, restaurants and professional kitchens, warehouses and workshops, showrooms, shopping centres, car parks, healthcare facilities, public-access buildings. Contact us for any other type of premises."
        },
        {
          q: "Do you offer long-term maintenance contracts?",
          a: "Yes, that is our main offer. Annual contracts provide better rates and guarantee service continuity with a dedicated team. We also offer one-off services with no commitment for occasional needs."
        },
        {
          q: "How do you manage daily quality?",
          a: "Each intervention is logged in our digital liaison system accessible online. A quality manager carries out unannounced checks. Quarterly quality reviews with your dedicated account manager allow protocols to be adjusted as needed."
        }
      ],
      relatedSlugs: ["particuliers", "immeubles", "chantier", "sols"]
    }
  },

  immeubles: {
    fr: {
      seo: {
        title: "Entretien parties communes -Immeubles, Copropriétés | BIONET SOLUTIONS",
        description: "Nettoyage et entretien des parties communes d'immeubles et copropriétés : halls, escaliers, ascenseurs, parkings. Contrats syndicats -Lyon, Rhône-Alpes. Devis gratuit."
      },
      hero: {
        h1: "Entretien parties communes -Immeubles, Copropriétés -Lyon & Auvergne-Rhône-Alpes",
        subtitle: "Nettoyage régulier des halls, escaliers, ascenseurs et parkings. Partenaire de confiance des syndics et régies pour maintenir votre immeuble dans un état impeccable.",
        badge: "Contrats syndics · 7j/7 · Tarifs copropriété",
        image: "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?crop=entropy&cs=srgb&fm=jpg&q=85&w=900"
      },
      intro: {
        title: "L'entretien des parties communes : la première impression de votre immeuble",
        body: [
          "Les parties communes d'un immeuble sont le premier contact que résidents, visiteurs et acheteurs potentiels ont avec votre copropriété. Un hall propre, un escalier bien entretenu et un ascenseur impeccable valorisent le bien de chaque copropriétaire et contribuent à la sécurité et au bien-être des résidents. À l'inverse, un immeuble mal entretenu génère des conflits en AG et fait fuir les acquéreurs.",
          "BIONET SOLUTIONS propose des contrats d'entretien sur mesure pour les syndicats de copropriété et les régies immobilières : nettoyage hebdomadaire ou bimensuel des halls, escaliers, vitres de cage, locaux poubelles, parkings souterrains et ascenseurs. Nous gérons également la sortie et la rentrée des containers et les interventions ponctuelles après dégâts ou travaux.",
          "Chaque immeuble est différent. Nous établissons un cahier des charges précis avec votre syndic : surfaces à traiter, fréquence, protocoles spécifiques, signalement des anomalies constatées (dégradations, ampoules, fuites). Un carnet de liaison mensuel permet au syndic de suivre les passages et de valider la qualité des interventions."
        ]
      },
      whyUs: [
        {
          icon: "Users",
          title: "Partenaire des syndics et régies",
          desc: "Expérience spécifique en gestion de copropriété. Nous comprenons les contraintes des syndics : AG, charges, copropriétaires exigeants. Facturation mensuelle simplifiée."
        },
        {
          icon: "Zap",
          title: "Interventions régulières garanties",
          desc: "Jours et horaires fixes chaque semaine. En cas d'absence de notre agent, un remplaçant formé est systématiquement envoyé. Aucun passage manqué."
        },
        {
          icon: "ShieldCheck",
          title: "Signalement des anomalies",
          desc: "Nos agents signalent toute anomalie constatée lors des passages : ampoule grillée, interphone défaillant, fuite, dégradation. Votre syndic est informé en temps réel."
        },
        {
          icon: "Award",
          title: "Carnet de liaison et traçabilité",
          desc: "Chaque passage est tracé avec date, heure, agent et zones traitées. Le syndic accède au récapitulatif mensuel en ligne pour le contrôle qualité et les AG."
        }
      ],
      process: [
        {
          step: 1,
          title: "Visite et audit de l'immeuble",
          desc: "Visite gratuite pour cartographier les zones à traiter, mesurer les surfaces, identifier les contraintes d'accès et les spécificités de l'immeuble.",
          tag: "Gratuit"
        },
        {
          step: 2,
          title: "Cahier des charges et devis",
          desc: "Rédaction du cahier des charges avec le syndic : fréquences, prestations détaillées, protocoles, tarif mensuel tout inclus. Validé en AG ou par le conseil syndical.",
          tag: "Sous 48h"
        },
        {
          step: 3,
          title: "Démarrage et mise en route",
          desc: "Remise des accès, briefing de l'équipe dédiée, premier passage avec contrôle qualité renforcé. Carnet de liaison ouvert et accessible.",
          tag: "Démarrage J+7"
        },
        {
          step: 4,
          title: "Suivi mensuel et bilan annuel",
          desc: "Rapport mensuel transmis au syndic. Bilan annuel avec proposition d'optimisation. Point de satisfaction en AG sur demande.",
          tag: "En continu"
        }
      ],
      clientExamples: [
        {
          avatar: "B",
          from: "Cabinet Bertrand -Syndic, Lyon 3e",
          date: "Octobre 2024",
          subject: "Entretien 3 immeubles -contrat annuel",
          message: "Nous gérons 3 copropriétés de 20 à 45 logements sur Lyon et cherchons à centraliser l'entretien des parties communes avec un prestataire unique fiable. Nous avons eu des problèmes avec notre précédent prestataire sur la régularité des passages. Pouvez-vous nous proposer un contrat annuel avec carnet de liaison ?"
        },
        {
          avatar: "D",
          from: "M. Daniel P. -Président CS, Bron",
          date: "Janvier 2025",
          subject: "Nettoyage après travaux cage d'escalier",
          message: "Notre immeuble vient de terminer une rénovation de cage d'escalier (ravalement, peinture). Il reste beaucoup de poussière, traces de plâtre et de peinture partout. J'ai besoin d'un nettoyage complet avant que les résidents reprennent possession des parties communes."
        },
        {
          avatar: "E",
          from: "Mme Émilie R. -Régisseure, Villeurbanne",
          date: "Mars 2025",
          subject: "Entretien parking souterrain -80 places",
          message: "Notre résidence dispose d'un parking souterrain de 80 places très sale (taches d'huile, déchets, poussière). Nous souhaitons un nettoyage approfondi puis un entretien mensuel. Intervenez-vous sur les parkings souterrains ?"
        }
      ],
      faq: [
        {
          q: "Comment se passe la prise en charge d'un immeuble en contrat ?",
          a: "Après visite gratuite et validation du cahier des charges par le syndic ou le conseil syndical, nous intervenons à fréquence fixe chaque semaine. Nos agents ont les accès nécessaires (badge, clé boîte à clés ou code). Un carnet de liaison numérique est accessible au syndic à tout moment."
        },
        {
          q: "Gérez-vous la sortie et la rentrée des poubelles ?",
          a: "Oui, c'est une prestation que nous intégrons dans les contrats sur demande. Nos agents sortent les containers aux jours de collecte et les rentrent dans les locaux poubelles après passage du camion."
        },
        {
          q: "Intervenez-vous aussi sur les parkings souterrains ?",
          a: "Oui. Nous nettoyons les parkings souterrains avec du matériel adapté : autolaveuse compacte, haute pression, traitement des taches d'huile et de graisse. Ces interventions sont généralement mensuelles ou trimestrielles."
        },
        {
          q: "Que se passe-t-il si notre agent est absent ?",
          a: "En cas d'absence imprévue, nous envoyons systématiquement un remplaçant formé pour que le passage ne soit jamais manqué. Vous en êtes informé via le carnet de liaison. Nos contrats garantissent une continuité de service sans défaut."
        },
        {
          q: "Pouvez-vous intervenir après des dégâts ou un sinistre dans les parties communes ?",
          a: "Oui, nous proposons des interventions ponctuelles après sinistre (dégât des eaux, incendie, vandalisme) en dehors du contrat régulier. Ces interventions font l'objet d'un devis spécifique et peuvent être prises en charge par l'assurance de la copropriété."
        }
      ],
      relatedSlugs: ["professionnels", "exterieur", "particuliers", "chantier"]
    },
    en: {
      seo: {
        title: "Common areas maintenance -Buildings, Condos | BIONET SOLUTIONS",
        description: "Cleaning and maintenance of common areas in buildings and condominiums: lobbies, stairs, lifts, car parks. Property manager contracts -Lyon, Rhône-Alpes. Free quote."
      },
      hero: {
        h1: "Common areas maintenance -Buildings, Condominiums -Lyon & Auvergne-Rhône-Alpes",
        subtitle: "Regular cleaning of lobbies, staircases, lifts and car parks. Trusted partner of property managers and syndicates for keeping your building in perfect condition.",
        badge: "Property manager contracts · 7 days/week · Condo rates",
        image: "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?crop=entropy&cs=srgb&fm=jpg&q=85&w=900"
      },
      intro: {
        title: "Common areas maintenance: your building's first impression",
        body: [
          "A building's common areas are the first contact residents, visitors and potential buyers have with your property. A clean lobby, well-maintained staircase and spotless lift add value to every owner's property and contribute to residents' safety and wellbeing. Conversely, a poorly maintained building generates AGM disputes and puts off buyers.",
          "BIONET SOLUTIONS offers tailored maintenance contracts for condominium syndicates and property managers: weekly or fortnightly cleaning of lobbies, staircases, lift shafts, bin rooms, underground car parks and lifts. We also handle bin container in/out management and one-off interventions after damage or construction works.",
          "Each building is different. We establish a precise specification with your property manager: surfaces to treat, frequencies, specific protocols, anomaly reporting (damage, bulbs, leaks). A monthly liaison log allows the property manager to track visits and validate service quality."
        ]
      },
      whyUs: [
        {
          icon: "Users",
          title: "Trusted by property managers",
          desc: "Specific experience in condominium management. We understand property manager constraints: AGMs, charges, demanding owners. Simplified monthly invoicing."
        },
        {
          icon: "Zap",
          title: "Guaranteed regular interventions",
          desc: "Fixed days and times every week. If our agent is absent, a trained replacement is systematically sent. No missed visits."
        },
        {
          icon: "ShieldCheck",
          title: "Anomaly reporting",
          desc: "Our agents report any anomaly spotted during visits: blown bulb, faulty intercom, leak, damage. Your property manager is notified in real time."
        },
        {
          icon: "Award",
          title: "Liaison log and traceability",
          desc: "Every visit is logged with date, time, agent and areas covered. The property manager accesses the monthly summary online for quality control and AGM reporting."
        }
      ],
      process: [
        {
          step: 1,
          title: "Building visit and audit",
          desc: "Free visit to map areas to be treated, measure surfaces, identify access constraints and building-specific requirements.",
          tag: "Free"
        },
        {
          step: 2,
          title: "Specification and quote",
          desc: "Specification drafted with the property manager: frequencies, detailed services, protocols, all-inclusive monthly rate. Validated at AGM or by the syndicate council.",
          tag: "Within 48h"
        },
        {
          step: 3,
          title: "Start and setup",
          desc: "Access handed over, dedicated team briefed, first visit with enhanced quality control. Liaison log opened and accessible.",
          tag: "Start Day+7"
        },
        {
          step: 4,
          title: "Monthly monitoring and annual review",
          desc: "Monthly report sent to property manager. Annual review with optimisation proposal. Satisfaction update at AGM on request.",
          tag: "Ongoing"
        }
      ],
      clientExamples: [
        {
          avatar: "B",
          from: "Cabinet Bertrand -Property manager, Lyon 3rd",
          date: "October 2024",
          subject: "3 buildings maintenance -annual contract",
          message: "We manage 3 condominiums of 20 to 45 units in Lyon and want to centralise common areas maintenance with a single reliable contractor. We had problems with our previous contractor on visit regularity. Can you propose an annual contract with a liaison log?"
        },
        {
          avatar: "D",
          from: "Mr Daniel P. -Syndicate president, Bron",
          date: "January 2025",
          subject: "Post-works cleaning -staircase",
          message: "Our building has just finished a staircase renovation (rendering, painting). There is a lot of dust, plaster and paint marks everywhere. I need a full clean before residents get back access to the common areas."
        },
        {
          avatar: "E",
          from: "Ms Émilie R. -Property manager, Villeurbanne",
          date: "March 2025",
          subject: "Underground car park maintenance -80 spaces",
          message: "Our residential complex has a very dirty 80-space underground car park (oil stains, rubbish, dust). We'd like a thorough clean followed by monthly maintenance. Do you work on underground car parks?"
        }
      ],
      faq: [
        {
          q: "How does taking on a building under contract work?",
          a: "After a free visit and validation of the specification by the property manager or syndicate council, we intervene at a fixed frequency each week. Our agents have the necessary access (badge, key box or code). A digital liaison log is accessible to the property manager at any time."
        },
        {
          q: "Do you manage bin container in/out?",
          a: "Yes, this is a service we include in contracts on request. Our agents take containers out on collection days and return them to the bin room after the lorry has passed."
        },
        {
          q: "Do you also service underground car parks?",
          a: "Yes. We clean underground car parks with appropriate equipment: compact scrubber-dryer, high pressure, oil and grease stain treatment. These interventions are generally monthly or quarterly."
        },
        {
          q: "What happens if our agent is absent?",
          a: "In case of unexpected absence, we systematically send a trained replacement so no visit is ever missed. You are notified via the liaison log. Our contracts guarantee uninterrupted service."
        },
        {
          q: "Can you intervene after damage or a disaster in the common areas?",
          a: "Yes, we offer one-off interventions after disasters (water damage, fire, vandalism) outside the regular contract. These are quoted separately and may be covered by the condominium's insurance."
        }
      ],
      relatedSlugs: ["professionnels", "exterieur", "particuliers", "chantier"]
    }
  },

  chantier: {
    fr: {
      seo: {
        title: "Nettoyage fin de chantier et après travaux -BTP, Rénovation | BIONET SOLUTIONS",
        description: "Nettoyage professionnel fin de chantier : dépoussiérage, vitres, sols, peinture. Remise en état pour livraison. Devis gratuit -Lyon, Rhône-Alpes."
      },
      hero: {
        h1: "Nettoyage fin de chantier et après travaux -BTP, Rénovation -Lyon & Rhône-Alpes",
        subtitle: "Remise en état complète avant livraison : dépoussiérage intégral, nettoyage des vitres, sols, sanitaires et enlèvement des traces de peinture. Délais BTP respectés.",
        badge: "Délais BTP · Remise en état livraison · Certifié",
        image: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?crop=entropy&cs=srgb&fm=jpg&q=85&w=900"
      },
      intro: {
        title: "Le nettoyage fin de chantier : la dernière étape avant la livraison",
        body: [
          "Un chantier terminé n'est pas un chantier livrable. La poussière de plâtre s'insinue dans chaque interstice, les traces de peinture marquent les vitres et les sols, les résidus de colle restent incrustés dans le carrelage, et les gravats encombrent les espaces. Un nettoyage professionnel fin de chantier transforme un chantier achevé en un bien prêt à être livré, visité ou occupé.",
          "BIONET SOLUTIONS travaille en étroite collaboration avec les entreprises du BTP, les promoteurs immobiliers et les particuliers en rénovation. Nous intervenons dans les délais imposés par votre planning de livraison, avec les équipes et les équipements nécessaires pour traiter les surfaces les plus délicates -vitres anti-rayures, parquets fraîchement posés, carrelage en grès cérame -sans les endommager.",
          "Notre prestation couvre le dépoussiérage complet (y compris VMC, bouches d'aération, caissons de volets roulants), le nettoyage des vitres intérieures et extérieures, le traitement des sols (carrelage, parquet, béton ciré, résine), le nettoyage des sanitaires, des cuisines et l'enlèvement de toutes les traces de chantier."
        ]
      },
      whyUs: [
        {
          icon: "ShieldCheck",
          title: "Respect des délais BTP",
          desc: "Nous intégrons votre planning de livraison et mobilisons les équipes nécessaires pour respecter vos délais, même sur des surfaces importantes en peu de temps."
        },
        {
          icon: "Zap",
          title: "Matériel adapté aux grands chantiers",
          desc: "Aspirateurs industriels HEPA, autolaveuses, haute pression, équipements d'accès en hauteur. Nous intervenons sur tous types de chantiers de 20 m² à plusieurs milliers de m²."
        },
        {
          icon: "Award",
          title: "Expertise matériaux neufs",
          desc: "Chaque matériau neuf nécessite un traitement spécifique. Nos techniciens connaissent les produits adaptés au parquet, à la pierre, au verre feuilleté et aux revêtements modernes."
        },
        {
          icon: "Star",
          title: "Remise en état livraison garantie",
          desc: "Nous assurons un résultat impeccable pour la livraison. Contrôle qualité avant remise des clés. Si ce n'est pas parfait, nous revenons sans frais."
        }
      ],
      process: [
        {
          step: 1,
          title: "Visite chantier et planning",
          desc: "Visite des locaux en fin de chantier pour évaluer les surfaces, les matériaux et planifier l'intervention en fonction de votre date de livraison.",
          tag: "Gratuit"
        },
        {
          step: 2,
          title: "Évacuation des gravats et déchets",
          desc: "Collecte et évacuation de tous les déchets de chantier résiduels. Bennes si nécessaire. Le site est dégagé avant le début du nettoyage.",
          tag: "Jour J"
        },
        {
          step: 3,
          title: "Dépoussiérage et nettoyage en profondeur",
          desc: "Dépoussiérage intégral du sol au plafond. Nettoyage des vitres, sanitaires, cuisine. Traitement des traces de peinture, colle et silicone. Nettoyage des sols selon matériaux.",
          tag: "Jour J à J+2"
        },
        {
          step: 4,
          title: "Contrôle qualité et livraison",
          desc: "Passage en revue de chaque pièce avec le chef de chantier ou le maître d'ouvrage. Remise du bien dans un état impeccable, prêt pour la livraison officielle.",
          tag: "Fin d'intervention"
        }
      ],
      clientExamples: [
        {
          avatar: "O",
          from: "M. Olivier M. -Chef de chantier, promoteur, Lyon",
          date: "Avril 2025",
          subject: "Nettoyage livraison -programme neuf 24 appartements",
          message: "Nous livrons un programme de 24 appartements neufs dans 10 jours. J'ai besoin d'une équipe capable de nettoyer l'intégralité du programme -parties privatives et parties communes -en 4 jours maximum. Avez-vous la capacité et les équipes pour ce volume ?"
        },
        {
          avatar: "K",
          from: "Mme Karine L. -Particulière, Tassin-la-Demi-Lune",
          date: "Février 2025",
          subject: "Nettoyage après rénovation complète maison",
          message: "Nous venons de terminer une rénovation complète de notre maison de 150 m² (sols, peintures, cuisine, salle de bain). Il y a de la poussière partout, des traces de plâtre sur les vitres et des résidus de colle sur le carrelage neuf. Nous souhaitons un nettoyage complet avant de réinstaller nos meubles."
        },
        {
          avatar: "T",
          from: "M. Thomas B. -Responsable travaux, promoteur, Grenoble",
          date: "Décembre 2024",
          subject: "Nettoyage résidence étudiante -80 studios",
          message: "Nous ouvrons une résidence étudiante de 80 studios en janvier. Les travaux se terminent fin décembre. J'ai besoin d'un prestataire fiable pour nettoyer l'ensemble de la résidence en moins d'une semaine avant les premières entrées."
        }
      ],
      faq: [
        {
          q: "Quelle est la différence entre nettoyage fin de chantier et nettoyage courant ?",
          a: "Le nettoyage fin de chantier est beaucoup plus approfondi qu'un ménage classique. Il inclut le dépoussiérage des caissons de volets roulants, VMC et bouches de ventilation, le traitement des traces de colle, plâtre, ciment et peinture, le nettoyage en profondeur des vitres (intérieur et extérieur), le premier nettoyage des matériaux neufs selon leurs spécificités, et l'évacuation des derniers déchets de chantier."
        },
        {
          q: "Pouvez-vous intervenir en urgence sur un chantier en retard ?",
          a: "Oui. Nous sommes habitués à travailler en mode urgence avec les entreprises du BTP. Si votre livraison est avancée ou si vous avez besoin de mobiliser une grande équipe rapidement, appelez-nous. Nous avons la capacité de déployer des équipes importantes sur court préavis."
        },
        {
          q: "Intervenez-vous sur les chantiers de rénovation chez les particuliers ?",
          a: "Oui, nous intervenons aussi bien chez les particuliers en rénovation que sur les chantiers professionnels. Que vous ayez rénové une salle de bain, une cuisine ou la totalité de votre maison, nous assurons le nettoyage de fin de travaux pour que vous puissiez réinstaller vos affaires dans un intérieur impeccable."
        },
        {
          q: "Comment traitez-vous les matériaux neufs sensibles (parquet, marbre, verre feuilleté) ?",
          a: "Chaque matériau nécessite des produits et des techniques spécifiques. Nos techniciens sont formés au nettoyage des matériaux neufs et utilisent des produits neutres adaptés, des microfibres non abrasives et des techniques qui préservent les traitements de surface (vernis, lasure, protection vitrifiée). Nous ne risquons jamais d'endommager des matériaux neufs."
        }
      ],
      relatedSlugs: ["professionnels", "sols", "immeubles", "exterieur"]
    },
    en: {
      seo: {
        title: "Post-construction and after-works cleaning -BTP, Renovation | BIONET SOLUTIONS",
        description: "Professional post-construction cleaning: full dusting, windows, floors, paint removal. Delivery-ready restoration. Free quote -Lyon, Rhône-Alpes."
      },
      hero: {
        h1: "Post-construction and after-works cleaning -BTP, Renovation -Lyon & Rhône-Alpes",
        subtitle: "Full restoration before handover: complete dusting, window, floor and bathroom cleaning, paint mark removal. BTP deadlines respected.",
        badge: "BTP deadlines · Delivery-ready · Certified",
        image: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?crop=entropy&cs=srgb&fm=jpg&q=85&w=900"
      },
      intro: {
        title: "Post-construction cleaning: the last step before handover",
        body: [
          "A finished construction site is not a deliverable one. Plaster dust seeps into every gap, paint marks stain windows and floors, adhesive residue is embedded in tiles, and rubble clutters the spaces. Professional post-construction cleaning transforms a completed site into a property ready for handover, viewing or occupation.",
          "BIONET SOLUTIONS works closely with construction companies, property developers and private renovation clients. We work within the deadlines set by your handover schedule, with the teams and equipment needed to handle the most delicate surfaces -scratch-resistant glass, freshly laid parquet, porcelain stoneware -without damaging them.",
          "Our service covers complete dusting (including HVAC, ventilation grilles, roller shutter boxes), interior and exterior window cleaning, floor treatment (tiles, parquet, polished concrete, resin), bathroom and kitchen cleaning and removal of all construction marks."
        ]
      },
      whyUs: [
        {
          icon: "ShieldCheck",
          title: "BTP deadlines respected",
          desc: "We integrate your delivery schedule and mobilise the necessary teams to meet your deadlines, even for large surfaces in short timeframes."
        },
        {
          icon: "Zap",
          title: "Equipment for large sites",
          desc: "Industrial HEPA vacuums, scrubber-dryers, high pressure, elevated access equipment. We work on all types of site from 20 m² to several thousand m²."
        },
        {
          icon: "Award",
          title: "New materials expertise",
          desc: "Each new material requires specific treatment. Our technicians know the right products for parquet, stone, laminated glass and modern finishes."
        },
        {
          icon: "Star",
          title: "Delivery-ready finish guaranteed",
          desc: "We guarantee an impeccable result for handover. Quality check before keys are handed over. If it's not perfect, we come back free of charge."
        }
      ],
      process: [
        {
          step: 1,
          title: "Site visit and planning",
          desc: "Visit to assess surfaces, materials and plan the intervention around your delivery date.",
          tag: "Free"
        },
        {
          step: 2,
          title: "Rubble and waste removal",
          desc: "Collection and removal of all residual construction waste. Skips if needed. Site cleared before cleaning begins.",
          tag: "Day of works"
        },
        {
          step: 3,
          title: "Full dusting and deep cleaning",
          desc: "Complete floor-to-ceiling dusting. Window, bathroom and kitchen cleaning. Paint, adhesive and silicone mark treatment. Floor cleaning per material type.",
          tag: "Day 0 to Day+2"
        },
        {
          step: 4,
          title: "Quality check and handover",
          desc: "Room-by-room review with site manager or client. Property handed over in impeccable condition, ready for official delivery.",
          tag: "End of works"
        }
      ],
      clientExamples: [
        {
          avatar: "O",
          from: "Mr Olivier M. -Site manager, developer, Lyon",
          date: "April 2025",
          subject: "Delivery clean -new 24-apartment development",
          message: "We are delivering a 24-apartment new development in 10 days. I need a team able to clean the entire development -private units and common areas -in a maximum of 4 days. Do you have the capacity and teams for this volume?"
        },
        {
          avatar: "K",
          from: "Ms Karine L. -Individual, Tassin-la-Demi-Lune",
          date: "February 2025",
          subject: "Post full renovation clean -house",
          message: "We've just finished a full renovation of our 150 m² house (floors, painting, kitchen, bathroom). Dust everywhere, plaster marks on the windows, adhesive residue on the new tiles. We want a full clean before moving our furniture back in."
        },
        {
          avatar: "T",
          from: "Mr Thomas B. -Works manager, developer, Grenoble",
          date: "December 2024",
          subject: "Student residence cleaning -80 studios",
          message: "We are opening an 80-studio student residence in January. Works finish at end of December. I need a reliable contractor to clean the full residence in under a week before the first tenants move in."
        }
      ],
      faq: [
        {
          q: "What is the difference between post-construction cleaning and regular cleaning?",
          a: "Post-construction cleaning is far more intensive than routine cleaning. It includes dusting roller shutter boxes, HVAC and ventilation grilles, treating adhesive, plaster, cement and paint marks, deep cleaning of windows inside and out, first cleaning of new materials according to their specific requirements, and removing the last construction waste."
        },
        {
          q: "Can you respond urgently to a delayed site?",
          a: "Yes. We are accustomed to working in emergency mode with construction companies. If your handover is brought forward or you need a large team mobilised quickly, call us. We have the capacity to deploy substantial teams at short notice."
        },
        {
          q: "Do you work on private renovation sites?",
          a: "Yes, we work with both private renovation clients and professional sites. Whether you've renovated a bathroom, kitchen or your entire home, we provide end-of-works cleaning so you can move your belongings back into an immaculate space."
        },
        {
          q: "How do you treat sensitive new materials (parquet, marble, laminated glass)?",
          a: "Each material requires specific products and techniques. Our technicians are trained in new materials cleaning and use appropriate neutral products, non-abrasive microfibres and techniques that preserve surface treatments (varnish, stain, vitrified protection). We never risk damaging new materials."
        }
      ],
      relatedSlugs: ["professionnels", "sols", "immeubles", "exterieur"]
    }
  },

  sols: {
    fr: {
      seo: {
        title: "Nettoyage et rénovation de sols -Carrelage, Parquet, Marbre | BIONET SOLUTIONS",
        description: "Nettoyage professionnel des sols : décapage, cristallisation marbre, rénovation parquet, nettoyage carrelage, sols industriels. Devis gratuit -Lyon, Rhône-Alpes."
      },
      hero: {
        h1: "Nettoyage et rénovation de sols -Carrelage, Parquet, Marbre -Lyon & Rhône-Alpes",
        subtitle: "Décapage, cristallisation, métallisation, lavage mécanisé. Redonner leur éclat à tous types de sols : marbre, parquet, carrelage, béton, moquette, résine.",
        badge: "Décapage · Cristallisation · Tous types de sols",
        image: "https://images.unsplash.com/photo-1563453392212-326f5e854473?crop=entropy&cs=srgb&fm=jpg&q=85&w=900"
      },
      intro: {
        title: "Vos sols méritent un traitement professionnel adapté à leur nature",
        body: [
          "Chaque type de sol a ses caractéristiques propres et nécessite des techniques et produits spécifiques. Nettoyer un marbre avec des produits acides le ternit définitivement. Traiter un parquet avec trop d'eau le gondole. Décaper un sol industriel sans les bonnes machines laisse des résidus incrustés. BIONET SOLUTIONS maîtrise les techniques adaptées à chaque matériau et dispose du matériel professionnel pour obtenir des résultats durables.",
          "Nos prestations sols couvrent l'ensemble du cycle : du décapage de l'ancienne protection à l'application de la nouvelle, en passant par le nettoyage en profondeur, le ponçage pour les parquets et pierres, la cristallisation pour les marbres et pierres calcaires, et la métallisation pour les sols de grande surface. Pour les moquettes et tapis, nous utilisons des machines d'extraction à eau chaude qui nettoient en profondeur sans détremper les fibres.",
          "Nous intervenons chez les particuliers, dans les locaux professionnels, les hôtels, les établissements de santé et les grandes surfaces. Chaque intervention commence par une analyse du sol pour identifier son état, ses besoins et les traitements appropriés."
        ]
      },
      whyUs: [
        {
          icon: "ShieldCheck",
          title: "Produits adaptés à chaque matériau",
          desc: "Acides doux pour les joints, produits neutres pour le marbre, décapants spécifiques pour les résines. Jamais de produit inadapté qui risque d'endommager votre sol."
        },
        {
          icon: "Star",
          title: "Résultats visibles et durables",
          desc: "Un sol après cristallisation ou métallisation retrouve 80 à 95 % de son éclat d'origine. Nous appliquons des protections durables qui facilitent l'entretien futur."
        },
        {
          icon: "Clock",
          title: "Intervention sans perturber votre activité",
          desc: "Machines silencieuses, produits à séchage rapide (30 à 60 min). Pour les locaux professionnels, intervention le soir ou le week-end pour une reprise d'activité sans délai."
        },
        {
          icon: "Award",
          title: "Expertise en sols anciens et délicats",
          desc: "Marbres, pierres, tomettes, parquets anciens : nos techniciens sont formés aux matériaux rares et délicats qui nécessitent une attention particulière."
        }
      ],
      process: [
        {
          step: 1,
          title: "Diagnostic du sol",
          desc: "Identification du matériau, état de la protection actuelle, type de salissures, zones abîmées. Recommandation du traitement optimal et devis détaillé.",
          tag: "Gratuit"
        },
        {
          step: 2,
          title: "Préparation et décapage",
          desc: "Enlèvement de l'ancienne protection (cire, polish, vernis selon le sol). Nettoyage en profondeur pour éliminer toutes les salissures incrustées.",
          tag: "Jour J"
        },
        {
          step: 3,
          title: "Traitement spécialisé",
          desc: "Cristallisation (marbre), métallisation (sols industriels), ponçage (parquet/pierre), extraction vapeur (moquette). Technique adaptée au matériau.",
          tag: "Jour J à J+1"
        },
        {
          step: 4,
          title: "Protection et finition",
          desc: "Application de la protection adaptée (cire, polish, vitrificateur, imprégnation). Brillance optimisée. Conseils d'entretien pour préserver le résultat.",
          tag: "Fin d'intervention"
        }
      ],
      clientExamples: [
        {
          avatar: "A",
          from: "Mme Anne-Sophie V. -Hôtelière, Lyon 1er",
          date: "Mars 2025",
          subject: "Rénovation sols marbre -hall hôtel",
          message: "Le hall de notre hôtel 4 étoiles possède des sols en marbre blanc de Carrare. Après des années d'entretien inadapté, ils sont ternes et présentent des rayures légères. Je cherche un spécialiste de la cristallisation marbre pour leur redonner leur brillance d'origine sans les endommager."
        },
        {
          avatar: "P",
          from: "M. Paul T. -Gérant, surface commerciale, Bron",
          date: "Janvier 2025",
          subject: "Décapage et métallisation -grande surface 2 000 m²",
          message: "Nos sols carrelage de la galerie marchande de 2 000 m² sont encrassés et la protection est usée. Nous cherchons un prestataire capable d'intervenir le week-end pour décaper et métalliser l'ensemble en 2 nuits et 1 journée afin de ne pas fermer."
        },
        {
          avatar: "C",
          from: "Mme Claire B. -Particulière, Lyon 4e",
          date: "Novembre 2024",
          subject: "Rénovation parquet chêne -appartement haussmannien",
          message: "Notre appartement haussmannien a un parquet en chêne ancien très abîmé : taches, rayures profondes, vernis écaillé. Nous souhaitons le faire rénover (ponçage + vitrification) sans déménager. Intervenez-vous sur site et combien de temps faut-il prévoir ?"
        }
      ],
      faq: [
        {
          q: "Qu'est-ce que la cristallisation de marbre ?",
          a: "La cristallisation est un traitement chimico-mécanique qui redonne au marbre et aux pierres calcaires leur brillance d'origine. Un produit cristallisant est appliqué sur le sol puis travaillé à la machine avec des disques en acier inoxydable. La chaleur générée crée une réaction chimique qui durcit la surface et lui rend son éclat. Le résultat est plus durable qu'un simple lustrage."
        },
        {
          q: "Pouvez-vous rénover un parquet sans déménagement ?",
          a: "Oui. Nous travaillons en décapant et ponçant pièce par pièce pour vous permettre de rester dans votre domicile. Les produits de vitrification modernes sèchent en 2 à 4 heures et permettent de réoccuper la pièce le soir. Nous vous fournirons un plan d'intervention précis pour organiser votre cohabitation pendant les travaux."
        },
        {
          q: "Quelle est la différence entre décapage et nettoyage profond ?",
          a: "Le nettoyage profond enlève les salissures et les dépôts de surface. Le décapage va plus loin : il élimine l'ancienne couche de protection (cire, emulsion, polish) pour remettre le sol à nu. Le décapage est nécessaire avant toute réapplication de protection ou tout traitement de rénovation."
        },
        {
          q: "Combien de temps dure la protection après cristallisation ou métallisation ?",
          a: "La durée dépend du trafic et de l'entretien quotidien. Une cristallisation de marbre dans une résidence privée dure 2 à 5 ans. Dans un hall d'hôtel ou une galerie commerciale à fort trafic, un entretien annuel est recommandé. Une métallisation de sol carrelage dure 1 à 3 ans selon le trafic."
        },
        {
          q: "Intervenez-vous sur les moquettes et tapis ?",
          a: "Oui. Nous nettoyons les moquettes et tapis par extraction à eau chaude (shampouinage extracteur) : le produit moussant est injecté sous pression dans les fibres et immédiatement aspiré avec l'eau sale. Le résultat est remarquable sur les taches et salissures profondes. Temps de séchage : 2 à 4 heures."
        }
      ],
      relatedSlugs: ["chantier", "particuliers", "professionnels", "immeubles"]
    },
    en: {
      seo: {
        title: "Floor cleaning and renovation -Tiles, Parquet, Marble | BIONET SOLUTIONS",
        description: "Professional floor cleaning: stripping, marble crystallisation, parquet restoration, tile cleaning, industrial floors. Free quote -Lyon, Rhône-Alpes."
      },
      hero: {
        h1: "Floor cleaning and renovation -Tiles, Parquet, Marble -Lyon & Rhône-Alpes",
        subtitle: "Stripping, crystallisation, metallisation, mechanical washing. Restoring the shine to all floor types: marble, parquet, tiles, concrete, carpet, resin.",
        badge: "Stripping · Crystallisation · All floor types",
        image: "https://images.unsplash.com/photo-1563453392212-326f5e854473?crop=entropy&cs=srgb&fm=jpg&q=85&w=900"
      },
      intro: {
        title: "Your floors deserve professional treatment matched to their nature",
        body: [
          "Each floor type has its own characteristics and requires specific techniques and products. Cleaning marble with acidic products permanently dulls it. Treating parquet with too much water causes warping. Stripping an industrial floor without the right machines leaves embedded residue. BIONET SOLUTIONS masters the techniques adapted to each material and has the professional equipment to achieve lasting results.",
          "Our floor services cover the full cycle: from stripping old protection to applying new, including deep cleaning, sanding for parquet and stone, crystallisation for marble and limestone, and metallisation for large-area floors. For carpets and rugs, we use hot-water extraction machines that deep-clean without soaking the fibres.",
          "We work for private clients, professional premises, hotels, healthcare facilities and large retail spaces. Every intervention starts with a floor analysis to identify its condition, needs and appropriate treatments."
        ]
      },
      whyUs: [
        {
          icon: "ShieldCheck",
          title: "Products matched to each material",
          desc: "Mild acids for joints, neutral products for marble, specific strippers for resins. Never an inappropriate product that could damage your floor."
        },
        {
          icon: "Star",
          title: "Visible and lasting results",
          desc: "A floor after crystallisation or metallisation recovers 80 to 95% of its original shine. We apply lasting protection that makes future maintenance easier."
        },
        {
          icon: "Clock",
          title: "Minimal disruption to your activity",
          desc: "Quiet machines, fast-drying products (30 to 60 min). For professional premises, evening or weekend intervention for no downtime."
        },
        {
          icon: "Award",
          title: "Expertise in old and delicate floors",
          desc: "Marble, stone, terracotta, antique parquet: our technicians are trained in rare and delicate materials that need special care."
        }
      ],
      process: [
        {
          step: 1,
          title: "Floor diagnosis",
          desc: "Material identification, current protection condition, soiling type, damaged areas. Optimal treatment recommendation and detailed quote.",
          tag: "Free"
        },
        {
          step: 2,
          title: "Preparation and stripping",
          desc: "Removal of old protection (wax, polish, varnish depending on floor type). Deep cleaning to eliminate all embedded dirt.",
          tag: "Day of works"
        },
        {
          step: 3,
          title: "Specialist treatment",
          desc: "Crystallisation (marble), metallisation (industrial floors), sanding (parquet/stone), steam extraction (carpet). Technique adapted to material.",
          tag: "Day 0 to Day+1"
        },
        {
          step: 4,
          title: "Protection and finishing",
          desc: "Application of appropriate protection (wax, polish, vitrifier, impregnation). Optimised shine. Maintenance advice to preserve the result.",
          tag: "End of works"
        }
      ],
      clientExamples: [
        {
          avatar: "A",
          from: "Ms Anne-Sophie V. -Hotel owner, Lyon 1st",
          date: "March 2025",
          subject: "Marble floor renovation -hotel lobby",
          message: "Our 4-star hotel lobby has white Carrara marble floors. After years of inappropriate maintenance they are dull and have light scratches. I'm looking for a marble crystallisation specialist to restore their original shine without damage."
        },
        {
          avatar: "P",
          from: "Mr Paul T. -Manager, commercial surface, Bron",
          date: "January 2025",
          subject: "Stripping and metallisation -2,000 m² retail space",
          message: "Our 2,000 m² shopping gallery tile floors are dirty and the protection is worn. We need a contractor able to work over the weekend to strip and metallise everything in 2 nights and 1 day to avoid closing."
        },
        {
          avatar: "C",
          from: "Ms Claire B. -Individual, Lyon 4th",
          date: "November 2024",
          subject: "Oak parquet renovation -Haussmann apartment",
          message: "Our Haussmann apartment has very damaged antique oak parquet: stains, deep scratches, peeling varnish. We want to have it restored (sanding + vitrification) without moving out. Can you work on site and how long should we allow?"
        }
      ],
      faq: [
        {
          q: "What is marble crystallisation?",
          a: "Crystallisation is a chemical-mechanical treatment that restores the original shine to marble and limestone floors. A crystallising product is applied to the floor then worked with a machine using stainless steel discs. The heat generated creates a chemical reaction that hardens the surface and restores its shine. The result is more lasting than simple buffing."
        },
        {
          q: "Can you restore parquet without us moving out?",
          a: "Yes. We work room by room so you can stay in your home. Modern vitrification products dry in 2 to 4 hours, allowing you to reoccupy the room in the evening. We will provide a precise intervention plan to organise how you live alongside the work."
        },
        {
          q: "What is the difference between stripping and deep cleaning?",
          a: "Deep cleaning removes dirt and surface deposits. Stripping goes further: it removes the old protection layer (wax, emulsion, polish) to bare the floor. Stripping is required before any reapplication of protection or renovation treatment."
        },
        {
          q: "How long does protection last after crystallisation or metallisation?",
          a: "Duration depends on traffic and daily maintenance. Marble crystallisation in a private residence lasts 2 to 5 years. In a hotel lobby or high-traffic shopping gallery, annual maintenance is recommended. Floor tile metallisation lasts 1 to 3 years depending on traffic."
        },
        {
          q: "Do you work on carpets and rugs?",
          a: "Yes. We clean carpets and rugs by hot-water extraction (shampooing extractor): foaming product is injected under pressure into the fibres and immediately extracted with dirty water. Results are remarkable on stains and deep dirt. Drying time: 2 to 4 hours."
        }
      ],
      relatedSlugs: ["chantier", "particuliers", "professionnels", "immeubles"]
    }
  },

  exterieur: {
    fr: {
      seo: {
        title: "Nettoyage haute pression -Façades, Toitures, Terrasses | BIONET SOLUTIONS",
        description: "Nettoyage extérieur haute pression : façades, toitures, terrasses, graffitis, panneaux solaires. Démoussage, hydrofuge. Devis gratuit -Lyon, Rhône-Alpes."
      },
      hero: {
        h1: "Nettoyage haute pression -Façades, Toitures, Terrasses -Lyon & Rhône-Alpes",
        subtitle: "Nettoyage de façades, démoussage toiture, nettoyage de terrasses, suppression de graffitis et entretien de panneaux solaires. Matériel haute pression professionnel.",
        badge: "Haute pression · Démoussage · Hydrofuge",
        image: "https://images.unsplash.com/photo-1558904541-efa843a96f01?crop=entropy&cs=srgb&fm=jpg&q=85&w=900"
      },
      intro: {
        title: "L'entretien extérieur : protéger votre bien et préserver sa valeur",
        body: [
          "Les façades, toitures, terrasses et allées s'encrassent progressivement sous l'effet de la pollution, des algues, des mousses et des lichens. Au-delà de l'aspect visuel, ces dépôts biologiques dégradent les matériaux : les mousses retiennent l'humidité et accélèrent la détérioration des toitures, les algues sur les façades en pierre favorisent les fissures, les lichens sur les terrasses rendent les surfaces glissantes et dangereuses.",
          "BIONET SOLUTIONS réalise des nettoyages extérieurs haute pression adaptés à chaque surface : façades en pierre, crépi, brique ou bardage ; toitures en tuile, ardoise ou bac acier ; terrasses en béton, pierre naturelle, bois composite ou carrelage. Nous utilisons des pressions adaptées à chaque matériau pour un résultat optimal sans dégradation.",
          "En complément du nettoyage, nous proposons des traitements hydrofuges et anti-mousse pour protéger les surfaces traitées et retarder le retour des salissures biologiques. Ces traitements prolongent l'effet du nettoyage de 3 à 7 ans selon l'exposition et le matériau."
        ]
      },
      whyUs: [
        {
          icon: "ShieldCheck",
          title: "Pression adaptée à chaque matériau",
          desc: "Pierre, crépi, brique, bois, bac acier : chaque surface a sa pression optimale. Trop fort casse, trop faible ne nettoie pas. Nous calibrons précisément."
        },
        {
          icon: "Award",
          title: "Traitement hydrofuge inclus",
          desc: "Après nettoyage, application d'un traitement hydrofuge ou anti-mousse professionnel qui protège la surface 3 à 7 ans et facilite l'entretien futur."
        },
        {
          icon: "Zap",
          title: "Équipement accès en hauteur",
          desc: "Nacelles, échafaudages, cordes : nous intervenons en toute sécurité sur les bâtiments de toutes hauteurs. Habilitations travail en hauteur à jour."
        },
        {
          icon: "Star",
          title: "Résultats spectaculaires garantis",
          desc: "Une façade nettoyée retrouve son aspect d'origine. Avant/après photographié. Si le résultat ne répond pas à vos attentes, nous revenons sans frais."
        }
      ],
      process: [
        {
          step: 1,
          title: "Diagnostic et devis gratuit",
          desc: "Visite pour évaluer les surfaces, identifier les types de salissures (mousse, algue, lichen, graffiti) et proposer le traitement optimal.",
          tag: "Gratuit"
        },
        {
          step: 2,
          title: "Prétraitement biocide",
          desc: "Application d'un produit biocide (anti-mousse, anti-algue) sur les surfaces fortement encrassées. Temps de contact selon les surfaces.",
          tag: "J-7 à J-3"
        },
        {
          step: 3,
          title: "Nettoyage haute pression",
          desc: "Nettoyage à la pression adaptée à chaque matériau. Évacuation contrôlée des eaux de nettoyage. Protection des surfaces et végétaux environnants.",
          tag: "Jour J"
        },
        {
          step: 4,
          title: "Traitement protecteur",
          desc: "Application du traitement hydrofuge ou anti-mousse de longue durée. Séchage 24 à 48h. Documentation photos avant/après remise.",
          tag: "Fin d'intervention"
        }
      ],
      clientExamples: [
        {
          avatar: "Y",
          from: "M. Yves G. -Propriétaire, maison individuelle, Miribel",
          date: "Avril 2025",
          subject: "Démoussage toiture + nettoyage façades",
          message: "Ma maison de 1985 a une toiture très envahie par les mousses et des façades en crépi grises de salissures. Je souhaitais faire ça depuis des années. Quelles sont vos disponibilités et combien coûte environ le nettoyage d'une toiture de 120 m² et de façades de 200 m² ?"
        },
        {
          avatar: "J",
          from: "Mme Julie M. -Gérante boutique, Lyon 2e",
          date: "Février 2025",
          subject: "Nettoyage graffitis -devanture commerce",
          message: "Notre devanture en pierre a été taguée cette nuit. Les graffitis sont frais et couvrent environ 8 m². J'ai besoin d'une intervention rapide avant l'ouverture du magasin demain. Pouvez-vous intervenir aujourd'hui ?"
        },
        {
          avatar: "M",
          from: "Résidence Les Acacias -Syndic, Rillieux-la-Pape",
          date: "Décembre 2024",
          subject: "Nettoyage façades immeuble -4 bâtiments",
          message: "Notre résidence de 4 bâtiments construite dans les années 90 a besoin d'un ravalement léger -les façades en crépi sont très sales et des mousse apparaissent sur les parties basses. Nous souhaitons un devis pour le nettoyage des 4 bâtiments avec traitement hydrofuge."
        }
      ],
      faq: [
        {
          q: "Le nettoyage haute pression peut-il abîmer ma façade ou ma toiture ?",
          a: "Mal calibrée, la haute pression peut effectivement endommager certains matériaux. C'est pourquoi nous adaptons systématiquement la pression à chaque surface. Pour les crépis fragiles, les pierres tendres ou les tuiles anciennes, nous utilisons une basse pression combinée à des produits chimiques pour éviter tout risque. Nous évaluons toujours le matériau avant d'intervenir."
        },
        {
          q: "Quelle est la meilleure saison pour nettoyer une façade ou une toiture ?",
          a: "Le printemps et l'automne sont idéaux : températures douces, faible ensoleillement qui permet aux produits de bien réagir, et pluies qui facilitent le rinçage naturel après traitement. Évitez les périodes de gel (produits inefficaces) et de forte canicule (séchage trop rapide des produits)."
        },
        {
          q: "Intervenez-vous pour supprimer les graffitis ?",
          a: "Oui. La suppression de graffitis frais est relativement simple. Pour les graffitis anciens, le traitement dépend du support : pierre, crépi, métal ou bois n'ont pas les mêmes techniques. Plus le graffiti est traité rapidement, plus le résultat est parfait. En cas d'urgence, nous pouvons intervenir en 4 à 8h dans le périmètre lyonnais."
        },
        {
          q: "Nettoyez-vous aussi les panneaux solaires ?",
          a: "Oui. Un panneau solaire encrassé peut perdre jusqu'à 20 à 30 % de rendement. Nous nettoyons les panneaux avec des produits adaptés (sans abrasifs ni solvants agressifs) et de l'eau déminéralisée pour éviter les dépôts calcaires. Intervention en sécurité avec harnais et nacelle si nécessaire."
        },
        {
          q: "Le traitement hydrofuge est-il vraiment utile ?",
          a: "Oui, très. Un hydrofuge crée une barrière imperméable microscopique sur la surface qui empêche l'eau, les algues et les champignons de s'incruster. Il ne change pas l'aspect visuel de la façade mais prolonge l'effet du nettoyage de 3 à 7 ans selon l'exposition. L'investissement est rentabilisé sur la durée."
        }
      ],
      relatedSlugs: ["chantier", "batiments", "immeubles", "espaces_verts"]
    },
    en: {
      seo: {
        title: "Pressure washing -Facades, Roofs, Terraces | BIONET SOLUTIONS",
        description: "Exterior pressure washing: facades, roofs, terraces, graffiti removal, solar panels. Moss removal, waterproofing. Free quote -Lyon, Rhône-Alpes."
      },
      hero: {
        h1: "Pressure washing -Facades, Roofs, Terraces -Lyon & Rhône-Alpes",
        subtitle: "Facade cleaning, roof moss removal, terrace cleaning, graffiti removal and solar panel maintenance. Professional high-pressure equipment.",
        badge: "High pressure · Moss removal · Waterproofing",
        image: "https://images.unsplash.com/photo-1558904541-efa843a96f01?crop=entropy&cs=srgb&fm=jpg&q=85&w=900"
      },
      intro: {
        title: "Exterior maintenance: protecting your property and preserving its value",
        body: [
          "Facades, roofs, terraces and pathways gradually become dirty from pollution, algae, moss and lichen. Beyond appearance, these biological deposits degrade materials: moss retains moisture and accelerates roof deterioration, algae on stone facades promotes cracking, and lichen on terraces makes surfaces slippery and dangerous.",
          "BIONET SOLUTIONS carries out exterior pressure washing adapted to each surface: stone, render, brick or cladding facades; tiled, slate or steel sheet roofs; concrete, natural stone, composite wood or tiled terraces. We use pressures adapted to each material for optimal results without damage.",
          "Alongside cleaning, we offer waterproofing and anti-moss treatments to protect treated surfaces and delay the return of biological soiling. These treatments extend the effect of cleaning by 3 to 7 years depending on exposure and material."
        ]
      },
      whyUs: [
        {
          icon: "ShieldCheck",
          title: "Pressure adapted to each material",
          desc: "Stone, render, brick, wood, steel sheet: each surface has its optimal pressure. Too high breaks it, too low doesn't clean. We calibrate precisely."
        },
        {
          icon: "Award",
          title: "Waterproofing treatment included",
          desc: "After cleaning, professional waterproofing or anti-moss treatment applied, protecting the surface for 3 to 7 years and making future maintenance easier."
        },
        {
          icon: "Zap",
          title: "Height access equipment",
          desc: "Cherry pickers, scaffolding, ropes: we work safely on buildings of all heights. Up-to-date height work certifications."
        },
        {
          icon: "Star",
          title: "Spectacular results guaranteed",
          desc: "A cleaned facade recovers its original appearance. Before/after photographs taken. If the result doesn't meet your expectations, we come back free of charge."
        }
      ],
      process: [
        {
          step: 1,
          title: "Diagnosis and free quote",
          desc: "Visit to assess surfaces, identify soiling types (moss, algae, lichen, graffiti) and propose the optimal treatment.",
          tag: "Free"
        },
        {
          step: 2,
          title: "Biocidal pre-treatment",
          desc: "Application of a biocidal product (anti-moss, anti-algae) to heavily soiled surfaces. Contact time varies per surface.",
          tag: "Day -7 to -3"
        },
        {
          step: 3,
          title: "Pressure washing",
          desc: "Cleaning at pressure adapted to each material. Controlled drainage of wash water. Surrounding surfaces and plants protected.",
          tag: "Day of works"
        },
        {
          step: 4,
          title: "Protective treatment",
          desc: "Application of long-lasting waterproofing or anti-moss treatment. Drying 24 to 48h. Before/after photo documentation provided.",
          tag: "End of works"
        }
      ],
      clientExamples: [
        {
          avatar: "Y",
          from: "Mr Yves G. -Owner, individual house, Miribel",
          date: "April 2025",
          subject: "Roof moss removal + facade cleaning",
          message: "My 1985 house has a roof heavily covered in moss and render facades grey with dirt. I've been meaning to sort this for years. What are your availabilities and roughly how much does cleaning a 120 m² roof and 200 m² of facades cost?"
        },
        {
          avatar: "J",
          from: "Ms Julie M. -Shop manager, Lyon 2nd",
          date: "February 2025",
          subject: "Graffiti removal -shop front",
          message: "Our stone shopfront was tagged last night. The graffiti is fresh and covers about 8 m². I need a fast response before the shop opens tomorrow. Can you come today?"
        },
        {
          avatar: "M",
          from: "Résidence Les Acacias -Property manager, Rillieux-la-Pape",
          date: "December 2024",
          subject: "Building facade cleaning -4 blocks",
          message: "Our 4-block residential development from the 1990s needs light maintenance -render facades are very dirty and moss is appearing on the lower sections. We want a quote for cleaning all 4 blocks with waterproofing treatment."
        }
      ],
      faq: [
        {
          q: "Can pressure washing damage my facade or roof?",
          a: "Incorrectly calibrated, high pressure can indeed damage certain materials. That is why we always adapt pressure to each surface. For fragile render, soft stone or old tiles, we use low pressure combined with chemical products to avoid any risk. We always assess the material before intervening."
        },
        {
          q: "What is the best season to clean a facade or roof?",
          a: "Spring and autumn are ideal: mild temperatures, low sunshine that allows products to react well, and rain that facilitates natural rinsing after treatment. Avoid frost periods (products ineffective) and extreme heat (products dry too fast)."
        },
        {
          q: "Do you remove graffiti?",
          a: "Yes. Removing fresh graffiti is relatively straightforward. For old graffiti, treatment depends on the surface: stone, render, metal and wood each have different techniques. The sooner graffiti is treated, the better the result. For emergencies we can respond in 4 to 8 hours in the Lyon area."
        },
        {
          q: "Do you clean solar panels?",
          a: "Yes. A dirty solar panel can lose up to 20 to 30% efficiency. We clean panels with appropriate products (no abrasives or aggressive solvents) and demineralised water to avoid limescale deposits. Safe intervention with harness and cherry picker if needed."
        },
        {
          q: "Is waterproofing treatment really worthwhile?",
          a: "Yes, very much so. A waterproofing agent creates a microscopic impermeable barrier on the surface that prevents water, algae and fungi from embedding. It does not change the visual appearance of the facade but extends the cleaning effect by 3 to 7 years depending on exposure. The investment pays for itself over time."
        }
      ],
      relatedSlugs: ["chantier", "batiments", "immeubles", "espaces_verts"]
    }
  },

  espaces_verts: {
    fr: {
      seo: {
        title: "Entretien espaces verts -Tonte, Élagage, Haies, Débroussaillage | BIONET SOLUTIONS",
        description: "Entretien et création d'espaces verts : tonte, élagage, taille de haies, débroussaillage, abattage. Particuliers et professionnels -Lyon, Rhône-Alpes. Devis gratuit."
      },
      hero: {
        h1: "Entretien espaces verts -Tonte, Élagage, Haies -Lyon & Auvergne-Rhône-Alpes",
        subtitle: "Entretien régulier ou ponctuel de vos espaces verts : tonte de pelouse, taille de haies, élagage d'arbres, débroussaillage et remise en état de terrain.",
        badge: "Tonte · Élagage · Débroussaillage",
        image: "https://images.unsplash.com/photo-1416879595882-3373a0480b5b?crop=entropy&cs=srgb&fm=jpg&q=85&w=900"
      },
      intro: {
        title: "Un espace vert entretenu : valorisation et sécurité de votre propriété",
        body: [
          "Un espace vert bien entretenu valorise votre propriété, améliore votre cadre de vie et évite les nuisances pour le voisinage. À l'inverse, un jardin laissé à l'abandon avec des haies débordantes, des arbres mal taillés ou un terrain envahi par les ronces génère des conflits de voisinage, des risques de chute de branches et une perte de valeur immobilière. L'entretien régulier est bien plus économique que la remise en état d'un espace totalement à l'abandon.",
          "BIONET SOLUTIONS prend en charge l'entretien complet de vos espaces verts : tonte de pelouse avec ramassage des tontes, taille de haies et bordures, élagage et recépage des arbres, débroussaillage manuel et mécanique, dessouchage, et remise en état de terrains abandonnés. Nous intervenons chez les particuliers, les copropriétés, les entreprises et les collectivités.",
          "Pour les interventions délicates sur les arbres de haute tige (élagage, abattage, démontage en hauteur), nos techniciens sont formés aux techniques de travail en hauteur et disposent des équipements de sécurité nécessaires. Nous évacuons systématiquement les végétaux coupés ou les broyons sur place pour enrichir votre compost."
        ]
      },
      whyUs: [
        {
          icon: "Award",
          title: "Techniciens certifiés arboriculture",
          desc: "Élagage, abattage, démontage en hauteur : nos techniciens sont formés aux techniques arboricoles et aux travaux en hauteur. Interventions sécurisées sur tous types d'arbres."
        },
        {
          icon: "Clock",
          title: "Contrats d'entretien saisonniers",
          desc: "Tonte hebdomadaire, taille haies printemps/automne, élagage hivernal : nous planifions l'entretien de votre jardin selon le calendrier végétal optimal."
        },
        {
          icon: "Users",
          title: "Équipe outillée et efficace",
          desc: "Tondeuses tractées, débroussailleuses professionnelles, tronçonneuses, broyeurs : nous avons le matériel pour tous types d'espaces, de la terrasse au grand terrain."
        },
        {
          icon: "ShieldCheck",
          title: "Évacuation et valorisation des déchets verts",
          desc: "Tous les végétaux coupés sont évacués vers des filières de valorisation (compost, bois énergie) ou broyés sur place selon votre préférence. Zéro encombrant laissé."
        }
      ],
      process: [
        {
          step: 1,
          title: "Visite et devis gratuit",
          desc: "Visite de votre jardin ou espace vert pour évaluer les travaux nécessaires, le volume de végétaux et planifier l'intervention.",
          tag: "Gratuit"
        },
        {
          step: 2,
          title: "Travaux de taille et d'élagage",
          desc: "Taille de haies, élagage des arbres, tonte de la pelouse. Taille de formation ou d'entretien selon l'espèce et l'état du végétal.",
          tag: "Jour J"
        },
        {
          step: 3,
          title: "Débroussaillage et désherbage",
          desc: "Élimination des mauvaises herbes, ronces, végétation envahissante. Débroussaillage manuel ou mécanique selon les surfaces.",
          tag: "Jour J"
        },
        {
          step: 4,
          title: "Évacuation et finitions",
          desc: "Collecte et évacuation de tous les déchets verts. Soufflage ou nettoyage des allées. Votre espace vert est propre et ordonné.",
          tag: "Fin d'intervention"
        }
      ],
      clientExamples: [
        {
          avatar: "B",
          from: "M. Bernard L. -Particulier, Neyron",
          date: "Mai 2025",
          subject: "Entretien annuel jardin -maison individuelle",
          message: "Nous avons un jardin de 800 m² avec une pelouse, des haies de thuyas de 3 mètres, 4 rosiers grimpants et 2 arbres fruitiers. Je cherche un prestataire pour l'entretien annuel complet : 10 à 12 tontes de mai à octobre, une taille de haies printemps/automne et une taille des fruitiers en hiver."
        },
        {
          avatar: "S",
          from: "Résidence Le Hameau -Syndic, Miribel",
          date: "Mars 2025",
          subject: "Entretien espaces verts -résidence 40 logements",
          message: "Notre résidence de 40 logements dispose d'espaces verts de 2 000 m² comprenant pelouses, haies et arbres. Nous cherchons un prestataire pour un contrat d'entretien annuel avec tonte bimensuelle et taille de haies 2 fois par an."
        },
        {
          avatar: "E",
          from: "Mme Élisabeth V. -Propriétaire, Trévoux",
          date: "Septembre 2024",
          subject: "Remise en état terrain abandonné -1 500 m²",
          message: "Nous venons d'acheter une propriété avec un terrain de 1 500 m² laissé à l'abandon depuis 5 ans. Ronces envahissantes, arbustes non taillés, arbres morts. J'ai besoin d'une remise en état complète avant de pouvoir envisager un aménagement."
        }
      ],
      faq: [
        {
          q: "Proposez-vous des contrats d'entretien régulier pour les jardins ?",
          a: "Oui, c'est notre formule la plus demandée. Les contrats d'entretien incluent la tonte régulière (de mai à octobre), la taille des haies (printemps et automne), la taille des arbustes et arbres fruitiers (hiver), et le débroussaillage ponctuel. Le tarif est mensuel et inclut l'évacuation des déchets verts."
        },
        {
          q: "Intervenez-vous pour l'abattage d'arbres dangereux ?",
          a: "Oui. L'abattage et le démontage d'arbres nécessitent une expertise et des équipements spécifiques, surtout pour les arbres proches des bâtiments ou des lignes électriques. Nos techniciens certifiés réalisent l'abattage et le démontage en toute sécurité avec des techniques de ripage ou de démontage en hauteur."
        },
        {
          q: "Pouvez-vous remettre en état un terrain totalement abandonné ?",
          a: "Oui. La remise en état d'un terrain abandonné est une intervention complexe mais que nous maîtrisons : débroussaillage massif, abattage des arbres dangereux, dessouchage, évacuation des déchets verts. Nous vous proposons ensuite un plan d'entretien régulier pour maintenir le résultat."
        },
        {
          q: "Évacuez-vous les déchets verts ?",
          a: "Oui, systématiquement. Nous évacuons tous les végétaux coupés vers des filières de valorisation (plateformes de compostage, bois énergie). Selon votre préférence et si votre espace le permet, nous pouvons aussi broyer les végétaux sur place pour produire du paillage ou enrichir votre compost."
        }
      ],
      relatedSlugs: ["exterieur", "particuliers", "immeubles", "batiments"]
    },
    en: {
      seo: {
        title: "Green spaces maintenance -Mowing, Pruning, Hedges, Clearance | BIONET SOLUTIONS",
        description: "Green spaces maintenance and creation: mowing, pruning, hedge trimming, brush clearing, tree felling. Residential and commercial -Lyon, Rhône-Alpes. Free quote."
      },
      hero: {
        h1: "Green spaces maintenance -Mowing, Pruning, Hedges -Lyon & Auvergne-Rhône-Alpes",
        subtitle: "Regular or one-off maintenance of your green spaces: lawn mowing, hedge trimming, tree pruning, brush clearing and land restoration.",
        badge: "Mowing · Pruning · Brush clearing",
        image: "https://images.unsplash.com/photo-1416879595882-3373a0480b5b?crop=entropy&cs=srgb&fm=jpg&q=85&w=900"
      },
      intro: {
        title: "Maintained green spaces: property value and safety",
        body: [
          "Well-maintained green spaces add value to your property, improve your quality of life and prevent neighbourhood disputes. Conversely, an abandoned garden with overhanging hedges, poorly pruned trees or land overrun with brambles creates neighbour disputes, falling branch risks and loss of property value. Regular maintenance is far more economical than restoring a completely abandoned space.",
          "BIONET SOLUTIONS handles full green space maintenance: lawn mowing with clipping collection, hedge and border trimming, tree pruning and coppicing, manual and mechanical brush clearing, stump removal, and abandoned land restoration. We work for private clients, condominiums, businesses and local authorities.",
          "For delicate work on tall trees (pruning, felling, high-level dismantling), our technicians are trained in aerial work techniques and have the necessary safety equipment. We systematically remove cut vegetation or chip it on site to enrich your compost."
        ]
      },
      whyUs: [
        {
          icon: "Award",
          title: "Certified arboriculture technicians",
          desc: "Pruning, felling, high-level dismantling: our technicians are trained in arboricultural techniques and aerial work. Safe intervention on all tree types."
        },
        {
          icon: "Clock",
          title: "Seasonal maintenance contracts",
          desc: "Weekly mowing, spring/autumn hedge trimming, winter pruning: we plan your garden maintenance according to the optimal vegetation calendar."
        },
        {
          icon: "Users",
          title: "Fully equipped and efficient team",
          desc: "Ride-on mowers, professional strimmers, chainsaws, chippers: we have the equipment for all types of space from terrace to large estate."
        },
        {
          icon: "ShieldCheck",
          title: "Green waste removal and valorisation",
          desc: "All cut vegetation is taken to valorisation channels (composting, biomass) or chipped on site according to your preference. No green waste left behind."
        }
      ],
      process: [
        {
          step: 1,
          title: "Visit and free quote",
          desc: "Visit to your garden or green space to assess works needed, vegetation volume and plan the intervention.",
          tag: "Free"
        },
        {
          step: 2,
          title: "Trimming and pruning",
          desc: "Hedge trimming, tree pruning, lawn mowing. Formative or maintenance pruning according to species and plant condition.",
          tag: "Day of works"
        },
        {
          step: 3,
          title: "Brush clearing and weeding",
          desc: "Elimination of weeds, brambles, invasive vegetation. Manual or mechanical clearing according to surfaces.",
          tag: "Day of works"
        },
        {
          step: 4,
          title: "Removal and finishing",
          desc: "Collection and removal of all green waste. Blowing or cleaning of paths. Your green space is left clean and tidy.",
          tag: "End of works"
        }
      ],
      clientExamples: [
        {
          avatar: "B",
          from: "Mr Bernard L. -Individual, Neyron",
          date: "May 2025",
          subject: "Annual garden maintenance -individual house",
          message: "We have an 800 m² garden with lawn, 3-metre thuja hedges, 4 climbing rose bushes and 2 fruit trees. I'm looking for a contractor for full annual maintenance: 10 to 12 mows from May to October, a spring/autumn hedge trim and winter pruning of the fruit trees."
        },
        {
          avatar: "S",
          from: "Résidence Le Hameau -Property manager, Miribel",
          date: "March 2025",
          subject: "Green spaces maintenance -40-unit residence",
          message: "Our 40-unit residence has 2,000 m² of green spaces including lawns, hedges and trees. We are looking for a contractor for an annual maintenance contract with fortnightly mowing and hedge trimming twice a year."
        },
        {
          avatar: "E",
          from: "Ms Élisabeth V. -Owner, Trévoux",
          date: "September 2024",
          subject: "Abandoned land restoration -1,500 m²",
          message: "We've just bought a property with a 1,500 m² plot left abandoned for 5 years. Invasive brambles, untrimmed shrubs, dead trees. I need a full restoration before we can think about landscaping."
        }
      ],
      faq: [
        {
          q: "Do you offer regular maintenance contracts for gardens?",
          a: "Yes, it is our most requested formula. Maintenance contracts include regular mowing (May to October), hedge trimming (spring and autumn), shrub and fruit tree pruning (winter), and occasional clearing. Monthly pricing includes green waste removal."
        },
        {
          q: "Do you handle felling of dangerous trees?",
          a: "Yes. Tree felling and dismantling require specialist expertise and equipment, especially near buildings or power lines. Our certified technicians carry out felling and dismantling safely using rigging or aerial dismantling techniques."
        },
        {
          q: "Can you restore completely abandoned land?",
          a: "Yes. Restoring abandoned land is a complex intervention we have mastered: large-scale clearing, felling of dangerous trees, stump removal, green waste removal. We then propose a regular maintenance plan to sustain the result."
        },
        {
          q: "Do you remove green waste?",
          a: "Yes, always. We take all cut vegetation to valorisation channels (composting platforms, biomass energy). Depending on your preference and if your space allows, we can also chip vegetation on site to produce mulch or enrich your compost."
        }
      ],
      relatedSlugs: ["exterieur", "particuliers", "immeubles", "batiments"]
    }
  },

  batiments: {
    fr: {
      seo: {
        title: "Traitement humidité, moisissures et entretien bâtiments | BIONET SOLUTIONS",
        description: "Traitement moisissures, humidité, ramonage, nettoyage VMC et bâtiments anciens. Diagnostic gratuit -Lyon, Rhône-Alpes. Devis gratuit."
      },
      hero: {
        h1: "Traitement humidité, moisissures et entretien technique de bâtiments -Lyon & Rhône-Alpes",
        subtitle: "Diagnostic et traitement des moisissures, humidité et remontées capillaires. Nettoyage VMC, ramonage, entretien de bâtiments anciens et agricoles.",
        badge: "Diagnostic gratuit · Moisissures · Humidité · VMC",
        image: "https://images.unsplash.com/photo-1486325212027-8081e485255e?crop=entropy&cs=srgb&fm=jpg&q=85&w=900"
      },
      intro: {
        title: "L'entretien technique du bâtiment : prévenir plutôt que guérir",
        body: [
          "Les problèmes d'humidité, de moisissures et de ventilation sont parmi les causes les plus fréquentes de dégradation des bâtiments et de problèmes de santé pour les occupants. Les moisissures libèrent des spores allergènes, les remontées capillaires détruisent les enduits et les maçonneries, et une VMC encrassée diffuse les polluants intérieurs dans l'ensemble du logement. Ces problèmes s'aggravent progressivement si on ne les traite pas à la source.",
          "BIONET SOLUTIONS propose un diagnostic complet de votre bâtiment pour identifier les sources d'humidité, les zones moisies et les défauts de ventilation. Nous mettons en œuvre les traitements adaptés : fongicides professionnels pour les moisissures, injection de résine ou barrière d'étanchéité pour les remontées capillaires, nettoyage et désinfection des réseaux VMC avec mesures de débit.",
          "Nous intervenons également sur les bâtiments anciens et patrimoniaux qui nécessitent des techniques et des produits respectueux des matériaux d'origine (pierre, brique, mortier à la chaux), ainsi que sur les bâtiments agricoles (étables, granges, serres) qui nécessitent des traitements spécifiques en termes de biocides et de protocoles."
        ]
      },
      whyUs: [
        {
          icon: "ShieldCheck",
          title: "Diagnostic avant traitement",
          desc: "Nous n'appliquons jamais de traitement sans diagnostic préalable. Mesures d'humidité, identification des espèces fongiques, analyse des sources. Traitement ciblé et efficace."
        },
        {
          icon: "Award",
          title: "Traitements homologués et durables",
          desc: "Fongicides et biocides homologués BPR européen. Traitements curatifs et préventifs. Garantie 5 ans sur les traitements d'humidité par injection."
        },
        {
          icon: "Zap",
          title: "Nettoyage VMC avec mesures de débit",
          desc: "Nettoyage complet des réseaux de ventilation avec mesure des débits avant/après. Attestation de conformité fournie pour les bailleurs et gestionnaires de patrimoine."
        },
        {
          icon: "Users",
          title: "Expertise bâtiments anciens",
          desc: "Pierres, briques, mortiers à la chaux : nos techniciens sont formés aux matériaux anciens et sensibles. Aucun produit agressif qui risque de dégrader le bâti historique."
        }
      ],
      process: [
        {
          step: 1,
          title: "Diagnostic technique gratuit",
          desc: "Inspection du bâtiment avec hygromètre, caméra thermique si nécessaire. Identification des zones humides, moisissures, et défauts de ventilation.",
          tag: "Gratuit"
        },
        {
          step: 2,
          title: "Plan de traitement",
          desc: "Rapport de diagnostic avec cartographie des zones traitées, protocoles recommandés, produits utilisés et estimation de durée et de coût.",
          tag: "Sous 48h"
        },
        {
          step: 3,
          title: "Traitement et décontamination",
          desc: "Application des fongicides, traitement des remontées capillaires, nettoyage VMC. Confinement si nécessaire pour éviter la dispersion des spores.",
          tag: "Jour J à J+3"
        },
        {
          step: 4,
          title: "Contrôle et prévention",
          desc: "Vérification du résultat du traitement. Conseils de prévention pour éviter la réapparition. Documentation et attestation de traitement fournie.",
          tag: "J+7 à J+14"
        }
      ],
      clientExamples: [
        {
          avatar: "X",
          from: "M. Xavier D. -Propriétaire, maison ancienne, Ain",
          date: "Janvier 2025",
          subject: "Moisissures récurrentes -murs pignon",
          message: "Depuis 3 ans, nous avons des moisissures noires récurrentes sur les murs pignons de notre maison de 1920. Les peintres ont repeint 2 fois mais ça revient toujours. J'aimerais un diagnostic sérieux pour comprendre la cause et traiter le problème définitivement."
        },
        {
          avatar: "O",
          from: "Mme Odile C. -Bailleuse, appartement locatif, Lyon 9e",
          date: "Mars 2025",
          subject: "Nettoyage VMC -immeuble années 70",
          message: "J'ai reçu des plaintes de mes locataires concernant des odeurs persistantes et une mauvaise qualité de l'air. L'immeuble date de 1975 et la VMC n'a probablement jamais été nettoyée. J'ai besoin d'un nettoyage complet avec mesure des débits et attestation pour mon dossier de bailleur."
        },
        {
          avatar: "W",
          from: "M. William P. -Exploitant agricole, Ain",
          date: "Octobre 2024",
          subject: "Désinfection bâtiment agricole -stabulation",
          message: "Je dois procéder à la désinfection complète de ma stabulation bovine avant l'entrée des animaux pour l'hiver. 800 m² à traiter avec des produits biocides agréés. Intervenez-vous dans les bâtiments agricoles et quels produits utilisez-vous ?"
        }
      ],
      faq: [
        {
          q: "Comment éliminez-vous les moisissures définitivement ?",
          a: "La clé est de traiter à la fois les moisissures visibles ET leur cause. Un simple nettoyage ou une peinture anti-moisissures sans traiter la source d'humidité ne fait que repousser le problème. Nous appliquons un fongicide professionnel homologué qui tue les spores en profondeur, puis nous traitons la source (pont thermique, remontée capillaire, ventilation insuffisante) pour éviter la réapparition."
        },
        {
          q: "Les moisissures sont-elles dangereuses pour la santé ?",
          a: "Oui. Les moisissures libèrent des spores qui peuvent provoquer ou aggraver des allergies, de l'asthme et des irritations respiratoires, surtout chez les enfants, les personnes âgées et les personnes immunodéprimées. Certaines espèces (Stachybotrys chartarum, ou « moisissure noire ») produisent des mycotoxines particulièrement nocives. Il ne faut pas les ignorer."
        },
        {
          q: "Comment fonctionne le nettoyage de VMC ?",
          a: "Nous intervenons sur l'ensemble du réseau : nettoyage mécanique des gaines avec brosses rotatives, aspiration des dépôts, désinfection des bouches et des caissons. Nous mesurons les débits d'air avant et après l'intervention pour confirmer l'efficacité. Une attestation de nettoyage avec mesures est fournie."
        },
        {
          q: "Intervenez-vous dans les bâtiments anciens classés ou en pierre ?",
          a: "Oui. Nous utilisons des produits et des techniques compatibles avec les matériaux anciens : bienoîte, pierre calcaire, brique, mortier à la chaux. Aucun produit agressif (acides forts, solvants chlorés) qui risquerait de dégrader le bâti. Nous avons l'expérience de l'entretien de bâtisses du 18e et 19e siècle."
        },
        {
          q: "Garantissez-vous le résultat des traitements anti-humidité ?",
          a: "Oui. Les traitements d'imperméabilisation par injection de résine ou pose de barrière d'étanchéité bénéficient d'une garantie de 5 ans. Pour les traitements fongicides, l'efficacité dépend du maintien d'une bonne ventilation après traitement. Nous vous fournissons toutes les recommandations nécessaires pour préserver le résultat."
        }
      ],
      relatedSlugs: ["exterieur", "sinistre", "chantier", "immeubles"]
    },
    en: {
      seo: {
        title: "Damp, mould treatment and building maintenance | BIONET SOLUTIONS",
        description: "Mould, damp and rising damp treatment. HVAC cleaning, chimney sweeping, old and agricultural buildings. Free diagnosis -Lyon, Rhône-Alpes. Free quote."
      },
      hero: {
        h1: "Damp, mould treatment and technical building maintenance -Lyon & Rhône-Alpes",
        subtitle: "Diagnosis and treatment of mould, damp and rising damp. HVAC cleaning, chimney sweeping, maintenance of old and agricultural buildings.",
        badge: "Free diagnosis · Mould · Damp · HVAC",
        image: "https://images.unsplash.com/photo-1486325212027-8081e485255e?crop=entropy&cs=srgb&fm=jpg&q=85&w=900"
      },
      intro: {
        title: "Technical building maintenance: prevention over cure",
        body: [
          "Damp, mould and ventilation problems are among the most common causes of building deterioration and occupant health issues. Mould releases allergenic spores, rising damp destroys renders and masonry, and a dirty HVAC system spreads indoor pollutants throughout the whole property. These problems worsen progressively if not treated at source.",
          "BIONET SOLUTIONS provides a full building diagnosis to identify damp sources, mouldy areas and ventilation defects. We implement appropriate treatments: professional fungicides for mould, resin injection or waterproof barrier for rising damp, HVAC network cleaning and disinfection with airflow measurements.",
          "We also work on old and heritage buildings requiring techniques and products respectful of original materials (stone, brick, lime mortar), as well as agricultural buildings (barns, stables, greenhouses) requiring specific biocides and protocols."
        ]
      },
      whyUs: [
        {
          icon: "ShieldCheck",
          title: "Diagnosis before treatment",
          desc: "We never apply treatment without prior diagnosis. Humidity measurements, fungal species identification, source analysis. Targeted, effective treatment."
        },
        {
          icon: "Award",
          title: "Approved and lasting treatments",
          desc: "European BPR-approved fungicides and biocides. Curative and preventive treatments. 5-year guarantee on injection damp treatments."
        },
        {
          icon: "Zap",
          title: "HVAC cleaning with airflow measurements",
          desc: "Full ventilation network cleaning with before/after airflow measurements. Compliance certificate provided for landlords and property managers."
        },
        {
          icon: "Users",
          title: "Old buildings expertise",
          desc: "Stone, brick, lime mortars: our technicians are trained in old and sensitive materials. No aggressive products that could damage historic fabric."
        }
      ],
      process: [
        {
          step: 1,
          title: "Free technical diagnosis",
          desc: "Building inspection with hygrometer, thermal camera if needed. Identification of damp areas, mould and ventilation defects.",
          tag: "Free"
        },
        {
          step: 2,
          title: "Treatment plan",
          desc: "Diagnostic report with map of areas to treat, recommended protocols, products used and time and cost estimate.",
          tag: "Within 48h"
        },
        {
          step: 3,
          title: "Treatment and decontamination",
          desc: "Fungicide application, rising damp treatment, HVAC cleaning. Containment if needed to prevent spore dispersal.",
          tag: "Day 0 to Day+3"
        },
        {
          step: 4,
          title: "Check and prevention",
          desc: "Treatment result verification. Prevention advice to avoid recurrence. Treatment documentation and certificate provided.",
          tag: "Day+7 to Day+14"
        }
      ],
      clientExamples: [
        {
          avatar: "X",
          from: "Mr Xavier D. -Owner, old house, Ain",
          date: "January 2025",
          subject: "Recurring mould -gable walls",
          message: "For 3 years we've had recurring black mould on the gable walls of our 1920 house. Decorators have repainted twice but it always comes back. I'd like a serious diagnosis to understand the cause and solve the problem permanently."
        },
        {
          avatar: "O",
          from: "Ms Odile C. -Landlord, rental apartment, Lyon 9th",
          date: "March 2025",
          subject: "HVAC cleaning -1970s building",
          message: "I've received complaints from my tenants about persistent odours and poor air quality. The building dates from 1975 and the ventilation system has probably never been cleaned. I need a full clean with airflow measurements and a certificate for my landlord file."
        },
        {
          avatar: "W",
          from: "Mr William P. -Farmer, Ain",
          date: "October 2024",
          subject: "Agricultural building disinfection -cattle barn",
          message: "I need to fully disinfect my cattle barn before the animals come in for winter. 800 m² to treat with approved biocidal products. Do you work on agricultural buildings and what products do you use?"
        }
      ],
      faq: [
        {
          q: "How do you eliminate mould permanently?",
          a: "The key is to treat both the visible mould AND its cause. Simply cleaning or applying anti-mould paint without treating the damp source only postpones the problem. We apply an approved professional fungicide that kills spores in depth, then treat the source (thermal bridge, rising damp, insufficient ventilation) to prevent recurrence."
        },
        {
          q: "Is mould dangerous to health?",
          a: "Yes. Mould releases spores that can trigger or worsen allergies, asthma and respiratory irritations, especially in children, the elderly and immunocompromised individuals. Some species (Stachybotrys chartarum, or 'black mould') produce particularly harmful mycotoxins. They should not be ignored."
        },
        {
          q: "How does HVAC cleaning work?",
          a: "We work on the full network: mechanical cleaning of ducts with rotating brushes, debris extraction, disinfection of grilles and units. We measure airflow before and after to confirm effectiveness. A cleaning certificate with measurements is provided."
        },
        {
          q: "Do you work in listed or stone old buildings?",
          a: "Yes. We use products and techniques compatible with old materials: limestone, brick, lime mortar. No aggressive products (strong acids, chlorinated solvents) that could damage historic fabric. We have experience maintaining 18th and 19th century buildings."
        },
        {
          q: "Do you guarantee the results of damp treatments?",
          a: "Yes. Resin injection or waterproof barrier treatments carry a 5-year guarantee. For fungicidal treatments, effectiveness depends on maintaining good ventilation after treatment. We provide all necessary recommendations to preserve the result."
        }
      ],
      relatedSlugs: ["exterieur", "sinistre", "chantier", "immeubles"]
    }
  },
  canapes: {
    fr: {
      seo: {
        title: "Nettoyage canapé, fauteuil et tissus d'ameublement à domicile -Lyon & Rhône-Alpes | BIONET SOLUTIONS",
        description: "Nettoyage professionnel de canapés, fauteuils, matelas et tissus à domicile. Extraction à vapeur, traitement anti-acariens, détachage. Lyon, Rhône-Alpes. Devis gratuit."
      },
      hero: {
        h1: "Nettoyage professionnel de canapés, fauteuils et tissus d'ameublement à domicile",
        subtitle: "Résultats visibles dès la première intervention. Traitement vapeur, extraction à sec, anti-acariens -à Lyon et en Rhône-Alpes.",
        badge: "Résultat garanti · Anti-acariens · Séchage rapide",
        image: "https://images.unsplash.com/photo-1555041469-a586c61ea9bc?crop=entropy&cs=srgb&fm=jpg&q=85&w=900"
      },
      intro: {
        title: "Pourquoi confier le nettoyage de vos tissus à un professionnel ?",
        body: [
          "Un canapé accueille en moyenne 3 à 4 heures d'utilisation quotidienne. En quelques mois, il accumule sueur, peaux mortes, squames d'animaux, poussières et résidus alimentaires qui s'incrustent profondément dans les fibres. Le nettoyage ménager de surface -coup de chiffon ou aspirateur léger -n'élimine qu'une fraction infime de ces dépôts. La majorité reste emprisonnée dans la trame, favorisant la prolifération des acariens et l'altération progressive du tissu.",
          "BIONET SOLUTIONS intervient avec un matériel d'extraction professionnel combinant injection d'eau chaude sous pression et aspiration puissante. Ce procédé atteint les couches profondes des fibres inaccessibles à l'entretien courant, élimine les acariens, bactéries et allergènes, et extrait les taches incrustées sans agresser le tissu. Le temps de séchage est réduit à 2-4 heures grâce à la forte capacité d'aspiration de notre matériel.",
          "Nos techniciens s'adaptent à chaque type de tissu : microfibre, velours, lin, coton, cuir, alcantara, mélange synthétique. Avant toute intervention, nous effectuons un test de solidité des couleurs sur une zone cachée et évaluons la nature des taches pour choisir le produit adapté. Certains textiles délicats nécessitent une extraction à sec (sans eau) ou un shampooing mousse -nos équipes maîtrisent l'ensemble de ces techniques.",
          "Nous intervenons à domicile à Lyon et dans toute la région Rhône-Alpes, depuis notre base de Neyron (01) près de Lyon. Pas besoin de transporter vos meubles ou de vous déplacer : nos techniciens viennent chez vous avec le matériel complet. L'intervention dure généralement 1 à 3 heures selon le nombre de pièces à traiter.",
          "Au-delà de l'aspect hygiénique, un nettoyage professionnel régulier prolonge significativement la durée de vie de vos textiles. Les salissures incrustées agissent comme un abrasif qui érode progressivement les fibres : un nettoyage annuel ou biannuel préserve l'aspect, la couleur et la solidité de vos tissus d'ameublement pour de nombreuses années supplémentaires."
        ]
      },
      whyUs: [
        {
          icon: "Zap",
          title: "Séchage en 2 à 4 heures",
          desc: "Notre matériel d'extraction haute puissance aspire jusqu'à 95 % de l'humidité injectée. Votre canapé est utilisable le soir même de l'intervention dans la grande majorité des cas."
        },
        {
          icon: "ShieldCheck",
          title: "Produits certifiés sans danger",
          desc: "Détergents hypoallergéniques, certifiés sans perturbateurs endocriniens. Sans danger pour les enfants et les animaux domestiques dès la fin du séchage. Aucune odeur chimique résiduelle."
        },
        {
          icon: "Star",
          title: "Résultats visibles garantis",
          desc: "Satisfaction garantie ou intervention complémentaire offerte. Nous photographions les zones traitées avant et après pour vous montrer les résultats. La grande majorité des taches incrustées est éliminée en une seule séance."
        },
        {
          icon: "Home",
          title: "Intervention à domicile à Lyon et en Rhône-Alpes",
          desc: "Nos techniciens se déplacent chez vous avec tout le matériel nécessaire. Pas de déplacement, pas de manutention. Disponibles en semaine et le week-end sur rendez-vous."
        }
      ],
      process: [
        {
          step: 1,
          title: "Devis et prise de rendez-vous",
          desc: "Envoyez des photos de vos meubles via le formulaire ou appelez-nous. Nous vous donnons un tarif précis et fixons un rendez-vous à votre convenance, souvent dans les 48h.",
          tag: "< 24h"
        },
        {
          step: 2,
          title: "Diagnostic textile sur place",
          desc: "À l'arrivée, nos techniciens identifient les types de fibres, testent la solidité des couleurs et évaluent les taches. Le protocole de nettoyage est ajusté en fonction.",
          tag: "15 min"
        },
        {
          step: 3,
          title: "Pré-traitement des taches",
          desc: "Les zones tachées sont pré-traitées avec des détachants spécifiques (gras, protéiniques, tanniques, synthétiques). Temps de pose adapté à la nature de chaque tache.",
          tag: "Inclus"
        },
        {
          step: 4,
          title: "Extraction ou nettoyage à sec",
          desc: "Nettoyage par injection-extraction (eau chaude + aspiration) ou à sec selon le tissu. Le matériel professionnel atteint les fibres profondes inaccessibles à l'entretien courant.",
          tag: "1 à 3h"
        },
        {
          step: 5,
          title: "Séchage et protection optionnelle",
          desc: "Vérification du séchage, ventilation si nécessaire. Application optionnelle d'un protecteur textile permanent (anti-taches, imperméabilisant) sur demande.",
          tag: "2 à 4h séchage"
        }
      ],
      clientExamples: [
        {
          avatar: "A",
          from: "Mme Aurélie B. -Particulière, Lyon 6e",
          date: "Février 2025",
          subject: "Canapé d'angle en microfibre taché",
          message: "Bonjour, nous avons un canapé d'angle en microfibre beige avec des taches importantes (café, jus de fruits, traces d'animaux). Nous avons essayé plusieurs produits du commerce sans résultat. Le canapé est récent et nous souhaitons le conserver. Est-ce que vous pouvez intervenir à domicile et quel serait le tarif approximatif ?"
        },
        {
          avatar: "M",
          from: "M. Marc D. -Propriétaire, Villeurbanne",
          date: "Avril 2025",
          subject: "Remise en état appartement locatif",
          message: "Suite au départ d'un locataire, le canapé et le fauteuil de l'appartement sont dans un état dégradé. Il y a des odeurs de tabac importantes et des taches diverses. Je dois remettre l'appartement en état rapidement pour une nouvelle location. Pouvez-vous intervenir et traiter également les odeurs ?"
        },
        {
          avatar: "C",
          from: "Cabinet immobilier Prestige -Bron",
          date: "Janvier 2025",
          subject: "Lot de mobilier pour appartement meublé",
          message: "Nous gérons plusieurs appartements meublés et avons régulièrement besoin de nettoyage de canapés et fauteuils entre deux locations. Travaillez-vous avec des professionnels de l'immobilier sur des volumes ? Quelles sont vos conditions pour un contrat régulier ?"
        },
        {
          avatar: "S",
          from: "Mme Sophie et M. Laurent R. -Particuliers, Neyron",
          date: "Mars 2025",
          subject: "Matelas et canapé pour allergie aux acariens",
          message: "Notre fille est allergique aux acariens. Son médecin nous a conseillé un traitement professionnel du matelas et du canapé. Faites-vous ce type d'intervention ? Quels produits utilisez-vous et sont-ils sans danger pour un enfant de 6 ans ?"
        }
      ],
      faq: [
        {
          q: "Quels types de tissus pouvez-vous nettoyer ?",
          a: "Nous traitons la grande majorité des textiles d'ameublement : microfibre, velours, lin, coton, polyester, mélange synthétique, cuir (naturel et synthétique), alcantara, daim synthétique. Certains tissus très délicats (soie naturelle, laine pure vintage) nécessitent une extraction à sec que nous maîtrisent également. Un test de compatibilité est toujours réalisé avant l'intervention."
        },
        {
          q: "Mon canapé sera-t-il utilisable le jour même ?",
          a: "Dans la majorité des cas, oui. Notre matériel d'extraction haute puissance aspire jusqu'à 95 % de l'humidité, ce qui réduit le temps de séchage à 2-4 heures selon l'épaisseur du tissu et les conditions ambiantes (température, aération). Nous recommandons de ventiler la pièce et de ne pas s'asseoir sur le canapé tant qu'il n'est pas complètement sec."
        },
        {
          q: "Pouvez-vous éliminer les odeurs de tabac ou d'animal ?",
          a: "Oui. Les odeurs de tabac, d'animaux domestiques et de moisissures sont parmi les plus demandées. Nous utilisons des neutralisants d'odeurs à action profonde, non des masquants. Le traitement est intégré au nettoyage : les molécules odorantes incrustées dans les fibres sont neutralisées chimiquement plutôt que recouvertes. Le résultat est durable, sans odeur chimique résiduelle."
        },
        {
          q: "Faut-il déplacer le canapé avant l'intervention ?",
          a: "Non. Nos techniciens apportent tout le matériel et travaillent directement sur place. Il suffit de dégager les coussins et l'accès autour du canapé. Pour un canapé d'angle en salon standard, aucun déplacement de meubles n'est nécessaire. Nous posons des protections au sol pour protéger votre parquet ou moquette pendant l'intervention."
        },
        {
          q: "Combien coûte le nettoyage d'un canapé ?",
          a: "Le tarif dépend du type de tissu, de la taille (2, 3 places, angle), du niveau de salissure et des prestations complémentaires souhaitées (traitement anti-acariens, imperméabilisation). Pour un canapé 3 places en microfibre standard, comptez en général entre 80 et 180 € selon l'état. Demandez un devis gratuit avec photos pour une estimation précise."
        },
        {
          q: "Intervenez-vous sur les matelas ?",
          a: "Oui. Le nettoyage de matelas est l'une de nos prestations les plus demandées, notamment pour les allergies aux acariens. Nous effectuons un nettoyage vapeur en profondeur suivi d'un traitement acaricide homologué. L'intervention dure environ 1h par matelas et le séchage complet se fait en 3-4 heures."
        },
        {
          q: "Les produits sont-ils sans danger pour les enfants et animaux ?",
          a: "Oui. Nous utilisons exclusivement des détergents hypoallergéniques et des produits certifiés sans perturbateurs endocriniens, adaptés aux environnements familiaux. Une fois le séchage complet (2-4h), les surfaces traitées sont parfaitement sûres pour les enfants en bas âge et les animaux domestiques."
        },
        {
          q: "Comment obtenir un devis pour le nettoyage de mes canapés ?",
          a: "Le plus simple est d'envoyer des photos de vos canapés (vue d'ensemble + zones tachées) via notre formulaire de devis en ligne. Vous recevrez une estimation tarifaire sous 24h. Pour une intervention urgente ou des cas particuliers, appelez le 06 49 50 28 01."
        }
      ],
      relatedSlugs: ["tapis", "particuliers", "sols", "sinistre"]
    },
    en: {
      seo: {
        title: "Professional sofa, armchair and upholstery cleaning at home -Lyon & Rhône-Alpes | BIONET SOLUTIONS",
        description: "Professional cleaning of sofas, armchairs, mattresses and upholstery at home. Steam extraction, anti-mite treatment, stain removal. Lyon, Rhône-Alpes. Free quote."
      },
      hero: {
        h1: "Professional sofa, armchair and upholstery cleaning at home",
        subtitle: "Visible results from the first visit. Steam treatment, dry extraction, anti-mite -in Lyon & the Rhône-Alpes region.",
        badge: "Guaranteed results · Anti-mite · Fast drying",
        image: "https://images.unsplash.com/photo-1555041469-a586c61ea9bc?crop=entropy&cs=srgb&fm=jpg&q=85&w=900"
      },
      intro: {
        title: "Why trust a professional with your upholstery cleaning?",
        body: [
          "A sofa is used for an average of 3 to 4 hours daily. Within a few months, it accumulates sweat, dead skin, pet dander, dust and food residues that become deeply embedded in the fibres. Surface-level home cleaning -a quick wipe or light vacuum -removes only a tiny fraction of these deposits. Most remain trapped in the fabric, encouraging dust mite proliferation and progressive fibre degradation.",
          "BIONET SOLUTIONS uses professional extraction equipment combining high-pressure hot water injection with powerful suction. This process reaches the deep fibre layers inaccessible to routine maintenance, eliminates mites, bacteria and allergens, and extracts embedded stains without damaging the fabric. Drying time is reduced to 2-4 hours thanks to the high suction capacity of our equipment.",
          "Our technicians adapt to each fabric type: microfibre, velvet, linen, cotton, leather, alcantara, synthetic blends. Before any intervention, we perform a colour fastness test on a hidden area and assess the nature of stains to choose the appropriate product. Some delicate textiles require dry extraction (without water) or foam shampoo -our teams master all these techniques.",
          "We operate in Lyon & the Rhône-Alpes region, with our main base in Neyron (01) near Lyon. No need to transport your furniture: our technicians come to you with full equipment. The intervention typically lasts 1 to 3 hours depending on the number of items.",
          "Beyond hygiene, regular professional cleaning significantly extends the life of your textiles. Embedded dirt acts like an abrasive that progressively erodes the fibres: annual or biannual cleaning preserves the appearance, colour and durability of your upholstery for many additional years."
        ]
      },
      whyUs: [
        {
          icon: "Zap",
          title: "Dry in 2 to 4 hours",
          desc: "Our high-power extraction equipment removes up to 95% of injected moisture. Your sofa is ready to use the same evening in the vast majority of cases."
        },
        {
          icon: "ShieldCheck",
          title: "Certified safe products",
          desc: "Hypoallergenic detergents, certified free from endocrine disruptors. Safe for children and pets as soon as drying is complete. No residual chemical odour."
        },
        {
          icon: "Star",
          title: "Visible results guaranteed",
          desc: "Satisfaction guaranteed or a complimentary follow-up visit. We photograph treated areas before and after so you can see the results. The vast majority of embedded stains are removed in one session."
        },
        {
          icon: "Home",
          title: "Home service in Lyon & the Rhône-Alpes region",
          desc: "Our technicians come to you with all necessary equipment. No travel, no heavy lifting. Available weekdays and weekends by appointment."
        }
      ],
      process: [
        {
          step: 1,
          title: "Quote and appointment",
          desc: "Send photos of your furniture via the form or call us. We provide an accurate price and schedule an appointment at your convenience, often within 48 hours.",
          tag: "< 24h"
        },
        {
          step: 2,
          title: "On-site textile assessment",
          desc: "On arrival, our technicians identify fibre types, test colour fastness and assess stains. The cleaning protocol is adjusted accordingly.",
          tag: "15 min"
        },
        {
          step: 3,
          title: "Stain pre-treatment",
          desc: "Stained areas are pre-treated with specific stain removers (oil-based, protein-based, tannin-based, synthetic). Contact time is adapted to each stain type.",
          tag: "Included"
        },
        {
          step: 4,
          title: "Extraction or dry cleaning",
          desc: "Cleaning by injection-extraction (hot water + suction) or dry method depending on the fabric. Professional equipment reaches deep fibres inaccessible to routine cleaning.",
          tag: "1 to 3h"
        },
        {
          step: 5,
          title: "Drying and optional protection",
          desc: "Drying check, ventilation if needed. Optional application of a permanent fabric protector (stain-resistant, water-repellent) on request.",
          tag: "2 to 4h drying"
        }
      ],
      clientExamples: [
        {
          avatar: "A",
          from: "Ms Aurélie B. -Homeowner, Lyon 6e",
          date: "February 2025",
          subject: "Stained microfibre corner sofa",
          message: "Hello, we have a beige microfibre corner sofa with significant stains (coffee, juice, pet marks). We've tried several off-the-shelf products with no success. The sofa is relatively new and we'd like to keep it. Can you come to our home and what would be the approximate cost?"
        },
        {
          avatar: "M",
          from: "Mr Marc D. -Landlord, Villeurbanne",
          date: "April 2025",
          subject: "Rental flat restoration",
          message: "After a tenant moved out, the sofa and armchair in the flat are in poor condition. There are strong tobacco smells and various stains. I need to get the flat ready quickly for a new tenancy. Can you come and also treat the odours?"
        },
        {
          avatar: "C",
          from: "Prestige Estate Agency -Bron",
          date: "January 2025",
          subject: "Furniture for furnished apartments",
          message: "We manage several furnished flats and regularly need sofa and armchair cleaning between tenancies. Do you work with property professionals on a volume basis? What are your terms for a regular contract?"
        },
        {
          avatar: "S",
          from: "Ms Sophie & Mr Laurent R. -Homeowners, Neyron",
          date: "March 2025",
          subject: "Mattress and sofa for dust mite allergy",
          message: "Our daughter is allergic to dust mites. Her doctor recommended professional treatment of the mattress and sofa. Do you offer this service? What products do you use and are they safe for a 6-year-old child?"
        }
      ],
      faq: [
        {
          q: "What fabric types can you clean?",
          a: "We treat the vast majority of upholstery textiles: microfibre, velvet, linen, cotton, polyester, synthetic blends, leather (natural and synthetic), alcantara, synthetic suede. Some very delicate fabrics (natural silk, vintage pure wool) require dry extraction which we also master. A compatibility test is always performed before the intervention."
        },
        {
          q: "Will my sofa be usable the same day?",
          a: "In most cases, yes. Our high-power extraction equipment removes up to 95% of moisture, reducing drying time to 2-4 hours depending on fabric thickness and ambient conditions (temperature, ventilation). We recommend ventilating the room and not sitting on the sofa until it is completely dry."
        },
        {
          q: "Can you remove tobacco or pet odours?",
          a: "Yes. Tobacco, pet and mould odours are among the most common requests. We use deep-action odour neutralisers, not masking agents. The treatment is integrated into the cleaning process: odour molecules embedded in the fibres are chemically neutralised rather than covered. The result is lasting and without residual chemical smell."
        },
        {
          q: "Does the sofa need to be moved before the visit?",
          a: "No. Our technicians bring all the equipment and work directly on-site. You just need to clear the cushions and provide access around the sofa. For a corner sofa in a standard living room, no furniture moving is needed. We lay floor protection to protect your floorboards or carpet during the visit."
        },
        {
          q: "How much does sofa cleaning cost?",
          a: "The price depends on the fabric type, size (2-seater, 3-seater, corner), level of soiling and any additional services (anti-mite treatment, fabric protection). For a standard 3-seater microfibre sofa, expect roughly €80-180 depending on condition. Request a free quote with photos for an accurate estimate."
        },
        {
          q: "Do you clean mattresses?",
          a: "Yes. Mattress cleaning is one of our most requested services, especially for dust mite allergies. We perform deep steam cleaning followed by an approved acaricidal treatment. The visit takes about 1 hour per mattress, with full drying in 3-4 hours."
        },
        {
          q: "Are the products safe for children and pets?",
          a: "Yes. We use only hypoallergenic detergents and products certified free from endocrine disruptors, suitable for family environments. Once fully dry (2-4h), treated surfaces are perfectly safe for young children and pets."
        },
        {
          q: "How do I get a quote for sofa cleaning?",
          a: "The simplest way is to send photos of your sofas (overview + stained areas) via our online quote form. You'll receive a price estimate within 24 hours. For urgent interventions or specific cases, call 06 49 50 28 01."
        }
      ],
      relatedSlugs: ["tapis", "particuliers", "sols", "sinistre"]
    }
  },
  tapis: {
    fr: {
      seo: {
        title: "Nettoyage professionnel de tapis et moquettes à domicile -Lyon & Rhône-Alpes | BIONET SOLUTIONS",
        description: "Nettoyage en profondeur de tapis, moquettes et tapis d'Orient à domicile. Injection-extraction, détachage, anti-acariens. Lyon, Auvergne-Rhône-Alpes. Devis gratuit."
      },
      hero: {
        h1: "Nettoyage professionnel de tapis et moquettes à domicile et en entreprise",
        subtitle: "Injection-extraction haute performance, détachage, traitement anti-acariens. Résultats durables -à Lyon et en Rhône-Alpes.",
        badge: "Intervention à domicile · Résultats durables · Lyon & Rhône-Alpes",
        image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?crop=entropy&cs=srgb&fm=jpg&q=85&w=900"
      },
      intro: {
        title: "Pourquoi un nettoyage professionnel de tapis est-il indispensable ?",
        body: [
          "Un tapis ou une moquette agit comme un véritable filtre : il retient poussières, pollens, squames, bactéries et acariens profondément dans ses fibres. L'aspirateur domestique, même performant, n'élimine que les dépôts de surface. Les couches profondes restent intactes et peuvent représenter plusieurs kilogrammes de résidus dans un tapis de salon standard après quelques années d'utilisation.",
          "Le nettoyage professionnel par injection-extraction est la méthode la plus efficace pour atteindre ces dépôts en profondeur. De l'eau chaude sous pression est injectée dans les fibres pendant que l'aspiration simultanée extrait l'eau, les salissures et les résidus biologiques. Ce procédé élimine jusqu'à 99 % des acariens, les bactéries et les allergènes incrustés -là où l'aspirateur ne peut aller.",
          "Nos techniciens maîtrisent également les méthodes alternatives adaptées aux fibres délicates : shampooing mousse, nettoyage par absorbant ou encapsulation. Pour les tapis d'Orient, les tapis berbères et les tapis en laine ancienne, nous privilégions des techniques douces qui préservent les colorants naturels et la structure des fibres sans risque de déformation ou décoloration.",
          "Les moquettes collées dans les bureaux, hôtels et commerces nécessitent une approche différente des tapis posés. Nous disposons du matériel adapté pour nettoyer les grandes surfaces rapidement et efficacement, y compris avec rotation nocturne pour ne pas perturber l'activité.",
          "BIONET SOLUTIONS intervient à Lyon et en Auvergne-Rhône-Alpes. Un seul déplacement suffit pour un résultat professionnel : nos techniciens viennent chez vous avec le matériel complet, protègent vos meubles et vos sols, et laissent vos tapis propres et séchés en quelques heures."
        ]
      },
      whyUs: [
        {
          icon: "Target",
          title: "Injection-extraction haute performance",
          desc: "Notre matériel professionnel atteint les fibres en profondeur inaccessibles à l'aspirateur. Élimination jusqu'à 99 % des acariens, bactéries et allergènes -y compris sur tapis très encrassés."
        },
        {
          icon: "Leaf",
          title: "Techniques adaptées à chaque fibre",
          desc: "Tapis d'Orient, berbère, laine, synthétique, moquette collée : nos techniciens choisissent la méthode adéquate (extraction, mousse, absorbant) pour préserver vos fibres et vos colorants."
        },
        {
          icon: "ShieldCheck",
          title: "Traitement anti-acariens certifié",
          desc: "Traitement acaricide homologué en fin d'intervention sur demande. Certificat fourni pour les personnes allergiques. Produits hypoallergéniques sans danger pour les enfants et animaux après séchage."
        },
        {
          icon: "Clock",
          title: "Séchage rapide, activité préservée",
          desc: "Temps de séchage réduit à 2-6h grâce à l'extraction haute puissance. Pour les professionnels, intervention en soirée ou nuit possible pour aucun impact sur votre activité."
        }
      ],
      process: [
        {
          step: 1,
          title: "Évaluation et devis",
          desc: "Envoyez photos et dimensions de vos tapis ou décrivez votre surface moquette. Devis gratuit sous 24h avec tarif précis selon fibres, surface et niveau de salissure.",
          tag: "< 24h"
        },
        {
          step: 2,
          title: "Préparation et aspiration préalable",
          desc: "Aspiration approfondie avec matériel professionnel pour éliminer les dépôts secs et faciliter l'efficacité du traitement humide. Protection du mobilier et des sols environnants.",
          tag: "Inclus"
        },
        {
          step: 3,
          title: "Pré-traitement des taches",
          desc: "Application de détachants spécifiques sur chaque type de tache (huile, vin, urine, rouille, etc.). Temps de pose adapté pour maximiser l'efficacité avant l'extraction.",
          tag: "Inclus"
        },
        {
          step: 4,
          title: "Nettoyage par injection-extraction",
          desc: "Passage de la machine d'extraction sur l'ensemble de la surface. L'eau chaude injectée dissout les salissures profondes que l'aspiration évacue immédiatement avec les résidus.",
          tag: "Selon surface"
        },
        {
          step: 5,
          title: "Séchage et protection",
          desc: "Séchage accéléré par ventilation. Application optionnelle d'un protecteur anti-taches. Traitement anti-acariens en finition sur demande. Tapis utilisable en 2-6h.",
          tag: "2 à 6h"
        }
      ],
      clientExamples: [
        {
          avatar: "N",
          from: "Mme Nadia K. -Particulière, Lyon 3e",
          date: "Mars 2025",
          subject: "Tapis berbère blanc très taché",
          message: "Bonjour, j'ai un grand tapis berbère blanc (environ 200x300) avec des taches importantes de café et de vin rouge. J'ai peur que le nettoyage l'abîme. Est-ce que vous avez de l'expérience avec ce type de tapis et pouvez-vous garantir que les fibres et les couleurs seront préservées ?"
        },
        {
          avatar: "H",
          from: "Hôtel Lumière -Responsable hébergement, Lyon 8e",
          date: "Janvier 2025",
          subject: "Nettoyage moquettes chambres et couloirs",
          message: "Nous avons 40 chambres avec moquette et des couloirs de 120m² à nettoyer. Nous cherchons un prestataire pouvant intervenir de nuit pour ne pas perturber les clients. Travaillez-vous en horaires décalés et quelle est votre capacité par nuit ?"
        },
        {
          avatar: "L",
          from: "M. Laurent P. -Propriétaire, Caluire-et-Cuire",
          date: "Décembre 2024",
          subject: "Moquette après dégât des eaux",
          message: "Suite à une fuite, la moquette de mon salon est humide depuis 48h et commence à sentir. Est-ce que vous pouvez intervenir rapidement pour nettoyer et traiter les moisissures éventuelles ? La moquette est collée sur 35m²."
        },
        {
          avatar: "E",
          from: "Cabinet d'avocats Dumont & Associés -Part-Dieu, Lyon",
          date: "Octobre 2024",
          subject: "Entretien annuel moquette bureaux",
          message: "Nous avons 180m² de moquette dans nos bureaux qui n'ont pas été nettoyés professionnellement depuis 2 ans. Nous cherchons un prestataire pour un nettoyage annuel. Pouvez-vous intervenir un vendredi soir ou un week-end ?"
        }
      ],
      faq: [
        {
          q: "Quelle est la différence entre votre nettoyage et un aspirateur classique ?",
          a: "L'aspirateur élimine les dépôts en surface (poussières, poils) mais ne peut pas atteindre les couches profondes des fibres. Notre matériel d'injection-extraction injecte de l'eau chaude sous pression au cœur des fibres tout en aspirant simultanément l'eau et les salissures extraites. Ce procédé élimine jusqu'à 99 % des acariens, bactéries et allergènes profondément incrustés -résultats impossibles à atteindre avec un aspirateur domestique."
        },
        {
          q: "Pouvez-vous nettoyer mes tapis d'Orient ou tapis anciens ?",
          a: "Oui, avec les techniques adaptées. Les tapis d'Orient et anciens nécessitent une approche douce pour préserver les colorants naturels, la structure des nœuds et les fibres délicates. Nous effectuons un test de solidité des couleurs avant toute intervention et choisissons entre shampooing mousse, nettoyage par absorbant ou extraction à basse pression selon les caractéristiques du tapis."
        },
        {
          q: "Mon tapis sera-t-il sec rapidement ?",
          a: "Oui. Notre matériel d'extraction récupère jusqu'à 95 % de l'humidité injectée. Un tapis standard est généralement sec en 2 à 4 heures. Une moquette épaisse ou un tapis en laine peut nécessiter 4 à 6 heures. Nous recommandons de ventiler la pièce et d'éviter de marcher dessus jusqu'au séchage complet."
        },
        {
          q: "Pouvez-vous éliminer les odeurs d'urine (animaux, enfants) ?",
          a: "Oui. Les taches et odeurs d'urine sont parmi les plus tenaces dans les tapis. Nous utilisons des enzymes spécifiques qui décomposent les molécules organiques responsables des odeurs, suivies d'un neutralisateur d'odeurs à action profonde. Le résultat est durable et sans odeur chimique résiduelle, même pour des taches anciennes."
        },
        {
          q: "Intervenez-vous sur les moquettes collées dans les entreprises ?",
          a: "Oui, c'est une de nos spécialités. Nous intervenons dans les bureaux, hôtels, commerces et établissements recevant du public. Pour minimiser l'impact sur votre activité, nous pouvons travailler en soirée ou de nuit. Nos machines sont adaptées aux grandes surfaces et permettent de traiter 100 à 200 m² par nuit."
        },
        {
          q: "Combien de temps faut-il entre deux nettoyages professionnels ?",
          a: "Pour un usage domestique normal (tapis de salon, famille de 2-4 personnes, sans animal), un nettoyage professionnel annuel est recommandé. Avec des animaux domestiques ou des enfants en bas âge, tous les 6 mois est conseillé. Pour les espaces professionnels à fort passage, une fréquence trimestrielle ou biannuelle est généralement appropriée."
        },
        {
          q: "Pouvez-vous aussi nettoyer les sous-tapis ?",
          a: "Nous recommandons toujours de soulever le tapis pour nettoyer le sol en dessous. Pour les sous-tapis en feutre ou caoutchouc, nous les aspirons et les traitons si nécessaire. C'est important car la saleté s'accumule également entre le sous-tapis et le sol, et peut remonter dans les fibres du tapis au fil du temps."
        },
        {
          q: "Comment obtenir un devis ?",
          a: "Envoyez des photos de vos tapis et les dimensions approximatives via notre formulaire de devis en ligne. Pour les moquettes en entreprise, précisez la surface en m². Vous recevrez un devis sous 24h. Pour une intervention urgente (dégât des eaux, odeurs soudaines), appelez directement le 06 49 50 28 01."
        }
      ],
      relatedSlugs: ["canapes", "sols", "particuliers", "sinistre"]
    },
    en: {
      seo: {
        title: "Professional rug and carpet cleaning at home -Lyon & Rhône-Alpes | BIONET SOLUTIONS",
        description: "Deep cleaning of rugs, carpets and oriental rugs at home. Injection-extraction, stain removal, anti-mite treatment. Lyon, Auvergne-Rhône-Alpes. Free quote."
      },
      hero: {
        h1: "Professional rug and carpet cleaning at home and in business",
        subtitle: "High-performance injection-extraction, stain removal, anti-mite treatment. Lasting results -in Lyon & the Rhône-Alpes region.",
        badge: "Home service · Lasting results · Lyon & Rhône-Alpes",
        image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?crop=entropy&cs=srgb&fm=jpg&q=85&w=900"
      },
      intro: {
        title: "Why is professional rug cleaning essential?",
        body: [
          "A rug or carpet acts as a genuine filter: it traps dust, pollen, dander, bacteria and mites deep in its fibres. Even a high-performance domestic vacuum cleaner only removes surface deposits. The deep layers remain intact and can represent several kilograms of residue in a standard living-room rug after a few years of use.",
          "Professional injection-extraction cleaning is the most effective method for reaching these deep deposits. Hot water is injected under pressure into the fibres while simultaneous suction extracts the water, dirt and biological residues. This process eliminates up to 99% of mites, bacteria and embedded allergens -where no vacuum can reach.",
          "Our technicians also master alternative methods suited to delicate fibres: foam shampoo, absorbent cleaning or encapsulation. For oriental rugs, Berber rugs and antique wool rugs, we favour gentle techniques that preserve natural dyes and fibre structure without risk of deformation or discolouration.",
          "Glued carpets in offices, hotels and retail spaces require a different approach from loose rugs. We have the right equipment to clean large surfaces quickly and effectively, including with night-time rotation to avoid disrupting business activity.",
          "BIONET SOLUTIONS operates in Lyon & the Rhône-Alpes region. A single visit delivers professional results: our technicians come to you with full equipment, protect your furniture and floors, and leave your rugs clean and dry within a few hours."
        ]
      },
      whyUs: [
        {
          icon: "Target",
          title: "High-performance injection-extraction",
          desc: "Our professional equipment reaches deep fibres inaccessible to vacuum cleaners. Elimination of up to 99% of mites, bacteria and allergens -even on heavily soiled rugs."
        },
        {
          icon: "Leaf",
          title: "Techniques matched to each fibre",
          desc: "Oriental, Berber, wool, synthetic, glued carpet: our technicians choose the right method (extraction, foam, absorbent) to preserve your fibres and dyes."
        },
        {
          icon: "ShieldCheck",
          title: "Certified anti-mite treatment",
          desc: "Approved acaricidal treatment on request at the end of the visit. Certificate provided for allergy sufferers. Hypoallergenic products safe for children and pets after drying."
        },
        {
          icon: "Clock",
          title: "Fast drying, activity preserved",
          desc: "Drying time reduced to 2-6h thanks to high-power extraction. For businesses, evening or night interventions possible for zero impact on your activity."
        }
      ],
      process: [
        {
          step: 1,
          title: "Assessment and quote",
          desc: "Send photos and dimensions of your rugs or describe your carpet area. Free quote within 24h with accurate pricing based on fibres, surface area and soiling level.",
          tag: "< 24h"
        },
        {
          step: 2,
          title: "Preparation and pre-vacuuming",
          desc: "Deep vacuuming with professional equipment to remove dry deposits and enhance the effectiveness of wet treatment. Furniture and surrounding floors protected.",
          tag: "Included"
        },
        {
          step: 3,
          title: "Stain pre-treatment",
          desc: "Application of specific stain removers for each stain type (oil, wine, urine, rust, etc.). Contact time adjusted to maximise effectiveness before extraction.",
          tag: "Included"
        },
        {
          step: 4,
          title: "Injection-extraction cleaning",
          desc: "The extraction machine passes over the entire surface. Injected hot water dissolves deep soiling, immediately evacuated by suction along with the residues.",
          tag: "Depends on area"
        },
        {
          step: 5,
          title: "Drying and protection",
          desc: "Accelerated drying by ventilation. Optional anti-stain protector application. Anti-mite treatment as a finish on request. Rug usable in 2-6h.",
          tag: "2 to 6h"
        }
      ],
      clientExamples: [
        {
          avatar: "N",
          from: "Ms Nadia K. -Homeowner, Lyon 3e",
          date: "March 2025",
          subject: "Heavily stained white Berber rug",
          message: "Hello, I have a large white Berber rug (approx 200x300cm) with significant coffee and red wine stains. I'm worried cleaning might damage it. Do you have experience with this type of rug and can you guarantee the fibres and colours will be preserved?"
        },
        {
          avatar: "H",
          from: "Hôtel Lumière -Accommodation Manager, Lyon 8e",
          date: "January 2025",
          subject: "Room and corridor carpet cleaning",
          message: "We have 40 carpeted rooms and 120m² of corridors to clean. We need a contractor who can work at night to avoid disturbing guests. Do you work out-of-hours and what is your capacity per night?"
        },
        {
          avatar: "L",
          from: "Mr Laurent P. -Homeowner, Caluire-et-Cuire",
          date: "December 2024",
          subject: "Carpet after water damage",
          message: "After a leak, my living room carpet has been damp for 48 hours and is starting to smell. Can you intervene quickly to clean and treat any mould? The carpet is glued over 35m²."
        },
        {
          avatar: "E",
          from: "Dumont & Associates Law Firm -Part-Dieu, Lyon",
          date: "October 2024",
          subject: "Annual office carpet maintenance",
          message: "We have 180m² of carpet in our offices that hasn't been professionally cleaned for 2 years. We're looking for a contractor for annual cleaning. Can you work on a Friday evening or weekend?"
        }
      ],
      faq: [
        {
          q: "What's the difference between your cleaning and a regular vacuum?",
          a: "A vacuum removes surface deposits (dust, hair) but cannot reach the deep fibre layers. Our injection-extraction equipment injects hot water under pressure into the core of the fibres while simultaneously vacuuming the water and extracted dirt. This process eliminates up to 99% of mites, bacteria and deeply embedded allergens -results impossible to achieve with a domestic vacuum."
        },
        {
          q: "Can you clean oriental or antique rugs?",
          a: "Yes, with the appropriate techniques. Oriental and antique rugs require a gentle approach to preserve natural dyes, knot structure and delicate fibres. We perform a colour fastness test before any intervention and choose between foam shampoo, absorbent cleaning or low-pressure extraction based on the rug's characteristics."
        },
        {
          q: "Will my rug dry quickly?",
          a: "Yes. Our extraction equipment recovers up to 95% of the injected moisture. A standard rug is typically dry in 2 to 4 hours. A thick carpet or wool rug may need 4 to 6 hours. We recommend ventilating the room and avoiding walking on it until fully dry."
        },
        {
          q: "Can you remove urine odours (pets, children)?",
          a: "Yes. Urine stains and odours are among the most persistent in rugs. We use specific enzymes that break down the organic molecules responsible for odours, followed by a deep-action odour neutraliser. The result is lasting and without residual chemical smell, even for old stains."
        },
        {
          q: "Do you work on glued carpets in businesses?",
          a: "Yes, it's one of our specialities. We work in offices, hotels, shops and public venues. To minimise impact on your activity, we can work evenings or at night. Our machines are suited to large surfaces, treating 100 to 200m² per night."
        },
        {
          q: "How long between professional cleanings?",
          a: "For normal domestic use (living-room rug, 2-4 person household, no pets), annual professional cleaning is recommended. With pets or young children, every 6 months is advised. For high-traffic professional spaces, quarterly or biannual cleaning is generally appropriate."
        },
        {
          q: "Can you also clean the underlay?",
          a: "We always recommend lifting the rug to clean the floor underneath. For felt or rubber underlays, we vacuum and treat them if needed. This is important as dirt also accumulates between the underlay and floor, and can migrate back into the rug fibres over time."
        },
        {
          q: "How do I get a quote?",
          a: "Send photos of your rugs and approximate dimensions via our online quote form. For business carpets, specify the area in m². You'll receive a quote within 24 hours. For urgent interventions (water damage, sudden odours), call 06 49 50 28 01 directly."
        }
      ],
      relatedSlugs: ["canapes", "sols", "particuliers", "sinistre"]
    }
  },
  vitres: {
    fr: {
      seo: {
        title: "Nettoyage professionnel de vitres et fenêtres à domicile et en entreprise -Lyon & Rhône-Alpes | BIONET SOLUTIONS",
        description: "Lavage de vitres intérieures et extérieures, baies vitrées, vérandas, Velux, vitrines. Résultat impeccable, sans traces. Lyon, Rhône-Alpes. Devis gratuit."
      },
      hero: {
        h1: "Nettoyage professionnel de vitres et fenêtres à domicile et en entreprise",
        subtitle: "Résultat sans traces ni auréoles. Intérieur, extérieur, baies vitrées, vérandas, vitrines -à Lyon et en Rhône-Alpes.",
        badge: "Sans traces garanties · Intérieur & extérieur · Lyon & Rhône-Alpes",
        image: "https://images.unsplash.com/photo-1527515545081-5db817172677?crop=entropy&cs=srgb&fm=jpg&q=85&w=900"
      },
      intro: {
        title: "Pourquoi faire appel à un professionnel pour le nettoyage de vos vitres ?",
        body: [
          "Les vitres sales diminuent significativement la luminosité d'un intérieur : une vitre encrassée peut bloquer jusqu'à 40 % de la lumière naturelle. Au-delà de l'aspect esthétique, les dépôts calcaires, les traces de pollution atmosphérique, les fientes d'oiseaux et les projections routières s'attaquent progressivement au verre et peuvent provoquer des micro-rayures permanentes si elles ne sont pas traitées correctement.",
          "Le nettoyage professionnel de vitres requiert des outils adaptés : raclettes de qualité professionnelle, eau osmosée (déminéralisée) pour éviter les dépôts calcaires, produits dégraissants adaptés au verre et techniques de passage qui garantissent l'absence de traces et d'auréoles. Nos techniciens sont formés aux techniques de raclette, au lavage au perchoir pour les zones hautes et à l'utilisation du balai alimenté en eau pour les façades inaccessibles.",
          "Pour les particuliers, nous prenons en charge l'ensemble des surfaces vitrées : fenêtres, portes-fenêtres, baies coulissantes, vérandas, Velux et fenêtres de toit, miroirs, cloisons vitrées. Chaque surface est traitée avec les produits et techniques adaptés pour éviter les rayures et garantir un résultat irréprochable.",
          "Pour les professionnels, nous intervenons sur les vitrines commerciales, les façades vitrées de bureaux, les cloisons en verre dans les open spaces, les fenêtres d'hôtels et de restaurants. Nous proposons des contrats d'entretien régulier (hebdomadaire, mensuel, trimestriel) adaptés à votre activité.",
          "BIONET SOLUTIONS couvre Lyon et la région Rhône-Alpes depuis Neyron (01). Nos équipes sont équipées pour travailler en hauteur en toute sécurité sur les bâtiments de 1 à 3 étages. Pour les immeubles plus hauts ou les façades complexes, nous disposons du matériel spécialisé nécessaire."
        ]
      },
      whyUs: [
        {
          icon: "Sparkles",
          title: "Résultat sans traces garanti",
          desc: "Eau osmosée déminéralisée, raclettes professionnelles, techniques de finition irréprochable. Aucune auréole ni trace de produit -résultat photographiable immédiatement après l'intervention."
        },
        {
          icon: "Building2",
          title: "Intérieur, extérieur, hauteur",
          desc: "Fenêtres, baies, vérandas, Velux, vitrines, façades. Nous travaillons en intérieur et en extérieur jusqu'à 3 étages avec le matériel adapté (perchoirs, balais alimentés en eau)."
        },
        {
          icon: "RefreshCw",
          title: "Contrats d'entretien régulier",
          desc: "Particuliers et professionnels : tarifs préférentiels pour les interventions régulières (mensuel, trimestriel, biannuel). Devis personnalisé selon vos fenêtres et votre fréquence souhaitée."
        },
        {
          icon: "Shield",
          title: "Traitement anti-calcaire et anti-pluie",
          desc: "Application optionnelle d'un traitement hydrophobe (effet pluie) et anti-calcaire pour prolonger la propreté jusqu'à 6 mois. Vos vitres restent propres plus longtemps entre deux interventions."
        }
      ],
      process: [
        {
          step: 1,
          title: "Devis et prise de rendez-vous",
          desc: "Décrivez vos fenêtres (nombre, types, étages, dernière date de nettoyage). Devis gratuit sous 24h. Intervention possible sous 48-72h dans la plupart des zones.",
          tag: "< 24h"
        },
        {
          step: 2,
          title: "Pré-traitement des taches résistantes",
          desc: "Traitement ciblé des dépôts calcaires, fientes et traces incrustées avec des produits adaptés au verre. Temps de pose avant rinçage pour dissoudre les minéraux.",
          tag: "Inclus"
        },
        {
          step: 3,
          title: "Lavage professionnel",
          desc: "Application de la solution nettoyante avec mouilleur professionnel, puis raclage à la raclette de précision en passes horizontales ou verticales selon la surface.",
          tag: "Selon volume"
        },
        {
          step: 4,
          title: "Finition et essuyage des bords",
          desc: "Essuyage minutieux des encadrements, rebords et joints pour éviter les coulures. Inspection de chaque vitre sous différents angles de lumière pour garantir l'absence de traces.",
          tag: "Inclus"
        },
        {
          step: 5,
          title: "Traitement optionnel",
          desc: "Application d'un traitement hydrophobe (eau glisse, effet perlant) ou anti-calcaire sur demande. Votre vitre reste propre jusqu'à 6 mois selon les conditions d'exposition.",
          tag: "En option"
        }
      ],
      clientExamples: [
        {
          avatar: "I",
          from: "Mme Isabelle M. -Particulière, Lyon 9e",
          date: "Avril 2025",
          subject: "Véranda et vitres maison",
          message: "Bonjour, j'ai une véranda de 25m² et 8 grandes fenêtres dans ma maison. Les vitres n'ont pas été nettoyées de l'extérieur depuis presque 2 ans et il y a des traces de calcaire importantes. Est-ce que vous pouvez intervenir et traiter les dépôts calcaires ? Quelle est votre disponibilité ?"
        },
        {
          avatar: "T",
          from: "M. Thomas S. -Gérant boutique, Presqu'île Lyon",
          date: "Février 2025",
          subject: "Nettoyage mensuel vitrine",
          message: "Je tiens une boutique de 25m² en Presqu'île. La vitrine fait 4 mètres de large. Je cherche un prestataire pour un nettoyage mensuel, idéalement tôt le matin avant l'ouverture. Est-ce que vous proposez des contrats réguliers pour les commerces ?"
        },
        {
          avatar: "J",
          from: "Résidence Les Pins -Syndic, Ecully",
          date: "Mars 2025",
          subject: "Vitres parties communes immeuble",
          message: "Nous devons faire nettoyer les vitres des parties communes de notre résidence (hall d'entrée, cage d'escalier vitrée, local vélos). Ce sont des surfaces difficiles d'accès. Pouvez-vous évaluer et nous donner un tarif pour une intervention annuelle ?"
        },
        {
          avatar: "R",
          from: "Restaurant Le Bouchon Lyonnais -Vieux Lyon",
          date: "Novembre 2024",
          subject: "Vitres de restaurant grasses et incrustées",
          message: "Notre restaurant a des grandes fenêtres côté rue avec des dépôts de graisse et de pollution. Dernière intervention il y a 8 mois. Nous avons besoin d'un nettoyage complet intérieur et extérieur. Pouvez-vous intervenir un lundi ou mardi matin (fermeture) ?"
        }
      ],
      faq: [
        {
          q: "Combien de temps dure le nettoyage de vitres d'une maison standard ?",
          a: "Pour une maison de 100-150 m² avec 8 à 12 fenêtres standard et une porte-fenêtre, comptez 2 à 3 heures pour un nettoyage intérieur et extérieur complet. Une véranda s'ajoute généralement 1 à 1,5h selon sa taille. Ces durées varient selon l'état des vitres, l'accessibilité et la présence de dépôts calcaires importants."
        },
        {
          q: "Pouvez-vous nettoyer les vitres en hauteur (1er, 2e étage) ?",
          a: "Oui. Nous intervenons jusqu'au 3e étage avec notre matériel standard (perchoirs télescopiques, balais alimentés en eau déminéralisée). Au-delà, nous disposons de matériel spécialisé. Pour les façades de grande hauteur ou les accès très complexes, une visite préalable peut être nécessaire pour évaluer les équipements requis."
        },
        {
          q: "Comment évitez-vous les traces et les auréoles ?",
          a: "Le secret est l'eau osmosée (déminéralisée) et la technique de raclette. L'eau du robinet contient des minéraux qui laissent des dépôts en séchant. L'eau osmosée, en séchant, ne laisse aucun résidu. Combinée à des raclettes professionnelles de qualité et aux techniques de passage appropriées, elle garantit des vitres sans trace ni auréole dans tous les cas."
        },
        {
          q: "Nettoyez-vous également les encadrements et les rebords de fenêtres ?",
          a: "Oui, c'est inclus dans notre prestation standard. Nous nettoyons les vitres, les encadrements (PVC, aluminium, bois), les rebords intérieurs et extérieurs, et les joints. Pour les encadrements très sales ou les joints noircis, nous appliquons un traitement spécifique pour restaurer leur aspect d'origine."
        },
        {
          q: "Mes Velux et fenêtres de toit peuvent-ils être nettoyés ?",
          a: "Oui. Les fenêtres de toit (Velux et autres marques) sont l'une de nos spécialités. Nous nettoyons l'intérieur depuis l'intérieur du logement et l'extérieur depuis le toit avec les équipements de sécurité appropriés. Les Velux accumulent rapidement mousses et lichens à l'extérieur qui nécessitent un traitement spécifique."
        },
        {
          q: "Quelle est la durée entre deux nettoyages professionnels ?",
          a: "Cela dépend de votre environnement. En zone urbaine avec beaucoup de pollution, 2 à 3 fois par an est recommandé. En zone pavillonnaire standard, 2 fois par an suffit généralement. Avec l'application d'un traitement hydrophobe, vous pouvez réduire la fréquence de nettoyage ou maintenir la propreté plus longtemps entre les interventions."
        },
        {
          q: "Proposez-vous des contrats pour les professionnels ?",
          a: "Oui. Nous proposons des contrats d'entretien régulier pour les commerces, bureaux, restaurants et hôtels. La fréquence (hebdomadaire, mensuelle, trimestrielle) et le périmètre (vitrine seulement, vitres intérieures + extérieures) sont définis selon vos besoins. Les contrats bénéficient de tarifs préférentiels par rapport aux interventions ponctuelles."
        },
        {
          q: "Comment obtenir un devis ?",
          a: "Décrivez votre situation via notre formulaire de devis en ligne : nombre et types de fenêtres, nombre d'étages, présence de véranda ou Velux, dernière date de nettoyage. Vous recevrez un devis sous 24h. Pour une visite préalable ou une intervention urgente, appelez le 06 49 50 28 01."
        }
      ],
      relatedSlugs: ["particuliers", "exterieur", "immeubles", "chantier"]
    },
    en: {
      seo: {
        title: "Professional window cleaning at home and for businesses -Lyon & Rhône-Alpes | BIONET SOLUTIONS",
        description: "Interior and exterior window, bay window, conservatory, skylight and shopfront washing. Streak-free results. Lyon, Rhône-Alpes. Free quote."
      },
      hero: {
        h1: "Professional window cleaning at home and for businesses",
        subtitle: "Streak-free results guaranteed. Interior, exterior, bay windows, conservatories, shopfronts -in Lyon & the Rhône-Alpes region.",
        badge: "Streak-free guarantee · Interior & exterior · Lyon & Rhône-Alpes",
        image: "https://images.unsplash.com/photo-1527515545081-5db817172677?crop=entropy&cs=srgb&fm=jpg&q=85&w=900"
      },
      intro: {
        title: "Why hire a professional for window cleaning?",
        body: [
          "Dirty windows significantly reduce indoor light: a soiled window can block up to 40% of natural light. Beyond aesthetics, limescale deposits, atmospheric pollution residues, bird droppings and road splashes progressively attack the glass and can cause permanent micro-scratches if not treated correctly.",
          "Professional window cleaning requires appropriate tools: professional-grade squeegees, osmosis (demineralised) water to avoid limescale deposits, glass-specific degreasers and squeegee techniques that guarantee streak-free and smear-free results. Our technicians are trained in squeegee techniques, reach-and-wash for high areas and water-fed poles for inaccessible facades.",
          "For homeowners, we handle all glazed surfaces: windows, French doors, sliding bays, conservatories, skylights and roof windows, mirrors, glass partitions. Each surface is treated with the appropriate products and techniques to avoid scratches and guarantee impeccable results.",
          "For businesses, we work on shop windows, glazed office facades, glass partitions in open-plan offices, hotel and restaurant windows. We offer regular maintenance contracts (weekly, monthly, quarterly) tailored to your business.",
          "BIONET SOLUTIONS covers Lyon and the Rhône-Alpes region from Neyron (01). Our teams are equipped to work safely at height on 1 to 3 storey buildings. For taller buildings or complex facades, we have the specialist equipment required."
        ]
      },
      whyUs: [
        {
          icon: "Sparkles",
          title: "Streak-free result guaranteed",
          desc: "Demineralised osmosis water, professional squeegees, impeccable finishing technique. No smears or product residue -results you can photograph immediately after the visit."
        },
        {
          icon: "Building2",
          title: "Interior, exterior, at height",
          desc: "Windows, bays, conservatories, skylights, shopfronts, facades. We work inside and outside up to 3 floors with the right equipment (extension poles, water-fed poles)."
        },
        {
          icon: "RefreshCw",
          title: "Regular maintenance contracts",
          desc: "Homeowners and businesses: preferential rates for regular visits (monthly, quarterly, biannual). Personalised quote based on your windows and desired frequency."
        },
        {
          icon: "Shield",
          title: "Anti-limescale and rain-repellent treatment",
          desc: "Optional hydrophobic treatment (rain-beading effect) and anti-limescale to extend cleanliness for up to 6 months. Your windows stay clean longer between visits."
        }
      ],
      process: [
        {
          step: 1,
          title: "Quote and appointment",
          desc: "Describe your windows (number, types, floors, last cleaning date). Free quote within 24h. Visit possible within 48-72h in most areas.",
          tag: "< 24h"
        },
        {
          step: 2,
          title: "Pre-treatment of stubborn marks",
          desc: "Targeted treatment of limescale deposits, bird droppings and embedded marks with glass-appropriate products. Contact time before rinsing to dissolve minerals.",
          tag: "Included"
        },
        {
          step: 3,
          title: "Professional washing",
          desc: "Application of cleaning solution with professional applicator, then precision squeegee in horizontal or vertical passes according to the surface.",
          tag: "Depends on volume"
        },
        {
          step: 4,
          title: "Finishing and frame wiping",
          desc: "Careful wiping of frames, sills and seals to prevent drips. Inspection of each pane under different light angles to guarantee a streak-free result.",
          tag: "Included"
        },
        {
          step: 5,
          title: "Optional treatment",
          desc: "Application of a hydrophobic (water-beading) or anti-limescale treatment on request. Your window stays clean for up to 6 months depending on exposure conditions.",
          tag: "Optional"
        }
      ],
      clientExamples: [
        {
          avatar: "I",
          from: "Ms Isabelle M. -Homeowner, Lyon 9e",
          date: "April 2025",
          subject: "Conservatory and house windows",
          message: "Hello, I have a 25m² conservatory and 8 large windows in my house. The outside hasn't been cleaned for nearly 2 years and there is significant limescale build-up. Can you come and treat the deposits? What is your availability?"
        },
        {
          avatar: "T",
          from: "Mr Thomas S. -Shop owner, Presqu'île Lyon",
          date: "February 2025",
          subject: "Monthly shopfront cleaning",
          message: "I run a 25m² shop in Presqu'île. The shopfront is 4 metres wide. I'm looking for a contractor for monthly cleaning, ideally early in the morning before opening. Do you offer regular contracts for retailers?"
        },
        {
          avatar: "J",
          from: "Résidence Les Pins -Management company, Ecully",
          date: "March 2025",
          subject: "Common area windows in apartment block",
          message: "We need to have the windows in the common areas of our residence cleaned (entrance hall, glazed stairwell, bike storage). These are difficult-to-access surfaces. Can you assess and give us a price for an annual visit?"
        },
        {
          avatar: "R",
          from: "Restaurant Le Bouchon Lyonnais -Vieux Lyon",
          date: "November 2024",
          subject: "Greasy and ingrained restaurant windows",
          message: "Our restaurant has large street-facing windows with grease and pollution deposits. Last cleaned 8 months ago. We need a full interior and exterior clean. Can you come on a Monday or Tuesday morning (closing day)?"
        }
      ],
      faq: [
        {
          q: "How long does window cleaning take for a standard house?",
          a: "For a 100-150m² house with 8 to 12 standard windows and a French door, allow 2 to 3 hours for a full interior and exterior clean. A conservatory adds roughly 1 to 1.5 hours depending on size. These times vary with window condition, accessibility and the extent of limescale deposits."
        },
        {
          q: "Can you clean windows at height (1st, 2nd floor)?",
          a: "Yes. We work up to the 3rd floor with our standard equipment (telescopic poles, water-fed poles with demineralised water). Beyond that, we have specialist equipment. For very tall facades or complex access, a preliminary visit may be needed to assess the required gear."
        },
        {
          q: "How do you avoid streaks and smears?",
          a: "The secret is osmosis (demineralised) water and squeegee technique. Tap water contains minerals that leave deposits as it dries. Osmosis water, when it dries, leaves no residue. Combined with professional-grade squeegees and the right technique, it guarantees streak-free windows every time."
        },
        {
          q: "Do you also clean frames and window sills?",
          a: "Yes, it's included in our standard service. We clean the panes, frames (PVC, aluminium, wood), interior and exterior sills, and seals. For very dirty frames or blackened seals, we apply a specific treatment to restore their original appearance."
        },
        {
          q: "Can you clean Velux and skylights?",
          a: "Yes. Roof windows (Velux and other brands) are one of our specialities. We clean the inside from within the property and the outside from the roof with appropriate safety equipment. Skylights quickly accumulate moss and lichen on the outside that require specific treatment."
        },
        {
          q: "How often should windows be professionally cleaned?",
          a: "It depends on your environment. In urban areas with high pollution, 2 to 3 times a year is recommended. In a standard suburban setting, twice a year is generally sufficient. With a hydrophobic treatment applied, you can reduce cleaning frequency or maintain cleanliness longer between visits."
        },
        {
          q: "Do you offer contracts for businesses?",
          a: "Yes. We offer regular maintenance contracts for shops, offices, restaurants and hotels. Frequency (weekly, monthly, quarterly) and scope (shopfront only, interior + exterior windows) are defined to fit your needs. Contracts benefit from preferential rates compared to one-off visits."
        },
        {
          q: "How do I get a quote?",
          a: "Describe your situation via our online quote form: number and types of windows, number of floors, conservatory or skylight, last cleaning date. You'll receive a quote within 24 hours. For a preliminary visit or urgent intervention, call 06 49 50 28 01."
        }
      ],
      relatedSlugs: ["particuliers", "exterieur", "immeubles", "chantier"]
    }
  }
};
